"use strict";

function FxBSizeWizard()
{
    return undefined;
}

(function ($)
{
    FxBSizeWizard._MobileThreshold = 768;
    FxBSizeWizard._MobileClass = "fxb_mobile";
    FxBSizeWizard._DesktopClass = "fxb_desktop";
    FxBSizeWizard._CurrentClass = null;

    FxBSizeWizard._GetCurrentSizeClass = function () 
    {
        if (window.innerWidth < FxBSizeWizard._MobileThreshold)
        {
            return FxBSizeWizard._MobileClass;
        }
        return FxBSizeWizard._DesktopClass;
    };

    FxBSizeWizard._UpdateSizeClassification = function () 
    {
        var lNewClass = FxBSizeWizard._GetCurrentSizeClass();
        if (lNewClass !== FxBSizeWizard._CurrentClass)
        {
            if (FxBSizeWizard._CurrentClass !== null)
            {
                $('body').removeClass(FxBSizeWizard._CurrentClass);
            }
            FxBSizeWizard._CurrentClass = lNewClass;
            $('body').addClass(FxBSizeWizard._CurrentClass);

            // run callbacks here?
        }
    };
    
    FxBSizeWizard._Init = function ()
    {
        var lLocalMobileThreshold = $("body").css("--FxB-MobileThreshold");
        if (!FBUtilities.IsParameterUndefinedOrEmpty(lLocalMobileThreshold))
        {
            FxBSizeWizard._MobileThreshold = Number(lLocalMobileThreshold);
        }
        FxBSizeWizard._UpdateSizeClassification();
    };

    // considering DOMContentLoaded for this, but would need jQuery free code.
    $(window).on('load', FxBSizeWizard._Init);
    $(window).resize(FxBSizeWizard._UpdateSizeClassification);
}(jQuery));


// -----------------------------------------------------------------------------------------------------
//  Foxbright CMS commonly-used functions v1.0
//  Created: 2009-09-10 (AW)
// -----------------------------------------------------------------------------------------------------

function FBUtilities()
{
    return undefined;
}

function FBQuickAjax()
{
}

function FBMenuManager()
{
    return undefined;
}

function ThumbnailUtilities()
{
    return undefined;
}

function FoxAjaxContent()
{
    return undefined;
}

function FoxEncoder()
{
    return undefined;
}

function VideoUtilities()
{
    return undefined;
}

function FBLightbox()
{
    return undefined;
}

var fb_js_debug = false;

///////////////////////////////////////////////////////////////////////////////
// FBCommon functions
///////////////////////////////////////////////////////////////////////////////

var FBCommon_1_2 =
{
    dumpCollection: function (name, collection)
    {
        var key;
        window.console.log(name);
        if (collection)
        {
            for (key in collection)
            {
                if (collection.hasOwnProperty(key))
                {
                    window.console.log("%s: %s", key, collection[key]);
                }
            }
        }
    },
    // Try use replaceChars() instead going forward (AW: 2010-10-01)
    // Params:
    //   Required: words (string)
    //   Required: character (string to remove)
    // Return vals: words (string with character removed)
    // Notes: Remove all instances of character from words
    removeCharacters: function (parameters)
    {
        var words, character, chars, x;

        words = parameters.words;
        character = (parameters.character === undefined ? ' ' : parameters.character);
        chars = words.length;

        for (x = 0; x < chars; x += 1)
        {
            words = words.replace(character, "");
        }
        return words;
    },

    // Return true if we are in an editor page.
    isInEditor: function ()
    {
        if (jQuery('body.fbcms_editmode').length === 1)
        {
            return true;
        }
        return false;
    },


    /**
     * Encodes html tag characters
     * @param {string} text
     */
    htmlTagEncode: function (text)
    {
        let encoded;
        if (text === undefined || text === null)
        {
            encoded = '';
        }
        else
        {
            encoded = text.replaceAll('<', '&lt;').replaceAll('>', '&gt;');
        }
        return encoded;
    },

    // --[ html Encode/Decode ]-------------------------------------------------------------------------
    // Params:
    //    text - the text to encode/decode.
    // Returns:
    //    the text, encoded or decoded.
    htmlEncode: function (text)
    {
        return jQuery('<div/>').text(text).html();
    },

    htmlEncodeMinimal: function (str)
    {
        if (str === undefined || str === null || typeof (str) !== 'string' || str.length === 0)
        {
            return str;
        }

        let buffer = [];
        for (let i = 0; i < str.length; i++)
        {
            let iC = str[i].charCodeAt();
            if (iC === 38)
            {
                buffer.push('&amp;');
            }
            else if (iC === 60)
            {
                buffer.push('&lt;');
            }
            else if (iC === 62)
            {
                buffer.push('&gt;');
            }
            else if (iC === 34)
            {
                buffer.push('&quot;');
            }
            // NOPE, ignore these please!
            /*else if (iC < 65
                || iC > 127
                || (iC > 90
                    && iC < 97)) {
                buffer.push('&#');
                buffer.push(iC);
                buffer.push(';');
            }*/
            else
            {
                buffer.push(str[i]);
            }
        }
        return buffer.join('');
    },

    htmlEncodeKludgy: function(str)
    {       
        if (str === undefined || str === null || typeof (str) !== 'string' || str.length)
        {
            return str;
        }
        let aRet = []

        for (let i = 0; i < str.lenght; i++)
        {
            let iC = str[i].charCodeAt();
            if (iC < 65
                || iC > 127
                || (iC > 90
                    && iC < 97))
            {
                aRet.push('&#');
                aRet.push(iC);
                aRet.push(';');
            }
            else
            {
                aRet.push(str[i]);
            }
        }//endwhile
        return aRet.join('');
    },

    htmlDecode: function (text)
    {
        return jQuery('<div/>').html(text).text();
    },

    PairCountrySelectWithStateSelect: function (countryCodeId, stateCodeId) 
    {
        const countrySelector = `#${countryCodeId}`;
        const stateSelector = `#${stateCodeId}`;
        function updateStateCodeSelect()
        {
            const selectedCountryCode = $(countrySelector).val();

            $(stateSelector).find('option').each(function ()
            {
                const country = $(this).data('country_code');
                if (selectedCountryCode === '' || country === '' || country === selectedCountryCode)
                {
                    $(this).prop('hidden', false);
                }
                else
                {
                    $(this).prop('hidden', true);
                    if ($(this).prop('selected'))
                    {
                        $(this).prop('selected', false);
                    }
                }
            });
        }

        $(countrySelector).on('change', updateStateCodeSelect);
        updateStateCodeSelect.call($(countrySelector).get(0));
    },

    // Example calls:
    //    addSearchBoxTriggers({});
    //    addSearchBoxTriggers({ fieldId : 'myField', defaultText : 'enter search criteria' });
    // Params:
    //    Optional: ID of search field
    //    Optional: Default text
    //    Optional: CSS class for empty field
    // Return vals: None
    // Notes: Clear search field on focus if empty / return to default state on blur if empty
    addSearchBoxTriggers: function (parameters)
    {
        var defaultText, emptyClass, fieldId;

        fieldId = (parameters.fieldId === undefined) ? 'search_string' : parameters.fieldId;
        defaultText = (parameters.defaultText === undefined) ? '' : parameters.defaultText;
        emptyClass = (parameters.emptyClass === undefined) ? 'empty' : parameters.emptyClass;

        jQuery("#" + fieldId).focus(function ()
        {
            jQuery(this).removeClass(emptyClass);
            if (jQuery(this).val() === defaultText)
            {
                jQuery(this).val('');
            }
        }).blur(function ()
        {
            if (FBCommon_1_2.removeCharacters({ words: jQuery(this).val() }) === '')
            {
                jQuery(this).addClass('empty');
                jQuery(this).val(defaultText);
            }
        });

        // Ensure empty class is removed if page is refreshed while search field contains text
        if (jQuery("#" + fieldId).val() !== defaultText)
        {
            jQuery("#" + fieldId).removeClass(emptyClass);
        }
    },

    // Example calls:
    //    setQuickJumpMenu({});
    //    setQuickJumpMenu({ quickJumpSpeed : 'slow', quickJumpDelay : 300 });
    // Params:
    //    Optional: quickJumpID: ID of the QuickJump menu.
    //    Optional: quickJumpButtonClass: Class of quick jump button
    //    Optional: quickJumpDropClass:   Class of quick jump drop menu
    //    Optional: quickJumpDelay:  milliseconds before QJD hides
    //    Optional: quickJumpSpeed:  milliseconds QJD hide/show transition takes
    //    Optional: quickJumpOpenClass: class to put on the overall element when the menu is open
    // Return vals: none
    // Notes: Adds show/hide triggers to quick jump menu
    // Requires: jQuery.timer, jQuery.clearTimer
    setQuickJumpMenu: function (parameters)
    {
        var defaults, options, quickJumpTimer, quickJumpButton, quickJumpDrop;

        defaults =
        {
            quickJumpID: 'myQuickJump'
            , quickJumpButtonClass: 'quickJumpButton'
            , quickJumpDropClass: 'quickJumpDrop'
            , quickJumpDelay: 300
            , quickJumpSpeed: 0
            , quickJumpClickActive: true
            , quickJumpHoverActive: false
            , quickJumpOpenClass: 'quickJumpOpen'
        };

        options = jQuery.extend(
            defaults,
            parameters
        );

        quickJumpTimer = null;
        quickJumpButton = jQuery("#" + options.quickJumpID + ' .' + options.quickJumpButtonClass);
        quickJumpDrop = jQuery("#" + options.quickJumpID + ' .' + options.quickJumpDropClass);


        function openQuickJumpMenu()
        {
            quickJumpDrop.slideDown(options.quickJumpSpeed);
            if (!FBUtilities.IsParameterUndefinedOrEmpty(options.quickJumpOpenClass))
            {
                jQuery("#" + options.quickJumpID).addClass(options.quickJumpOpenClass);
            }
        }//end openQuickJumpMenu

        function closeQuickJumpMenu()
        {
            quickJumpDrop.slideUp(options.quickJumpSpeed);
            if (!FBUtilities.IsParameterUndefinedOrEmpty(options.quickJumpOpenClass))
            {
                jQuery("#" + options.quickJumpID).removeClass(options.quickJumpOpenClass);
            }
        }//end closeQuickJumpMenu

        if (quickJumpButton.length === 0 || quickJumpDrop.length === 0)
        {
            return;
        }

        if (options.quickJumpClickActive === true)
        {
            quickJumpButton.click(
                function ()
                {
                    if (quickJumpDrop.is(':hidden'))
                    {
                        openQuickJumpMenu();
                    }
                    else
                    {
                        closeQuickJumpMenu();
                    }
                }
            );
        }

        quickJumpButton.hover(
            function ()
            {
                if (options.quickJumpHoverActive === true)
                {
                    if (quickJumpDrop.is(':hidden'))
                    {
                        jQuery('.' + options.quickJumpDropClass).slideUp(options.quickJumpSpeed);
                        openQuickJumpMenu();
                    }
                }

                if (quickJumpTimer !== null)
                {
                    jQuery.clearTimer(quickJumpTimer);
                }
            },
            function ()
            {
                quickJumpTimer = jQuery.timer(
                    options.quickJumpDelay,
                    function ()
                    {
                        closeQuickJumpMenu();
                    }
                );
            }
        );

        quickJumpDrop.hover(
            function ()
            {
                if (quickJumpTimer !== null)
                {
                    jQuery.clearTimer(quickJumpTimer);
                }
            },
            function ()
            {
                quickJumpTimer = jQuery.timer(
                    options.quickJumpDelay,
                    function ()
                    {
                        closeQuickJumpMenu();
                    }
                );
            }
        );



    }, //end setQuickJumpMenu

    initCmsAlert: function (aParentId, aChildClass)
    {
        const $alert = $(`#${aParentId}`);
        const noAlertToShow = $alert.find(`.${aChildClass}`).length === 0;
        if (noAlertToShow) {
            return;
        }

        function fnHideCmsAlert() {
            $alert.attr('aria-hidden', "true").hide();

            jQuery('#fbcms_ea_shadowBox').remove(); // close trigger
            var jFirst = jQuery('.skip_link').first();
            if (jFirst.length === 0) {
                jFirst = jQuery(':tabbable').first();
            }
            jFirst.focus();
            return false;
        };

        jQuery('body')
            .prepend('<div id="fbcms_ea_shadowBox"></div>');

        jQuery('#fbcms_ea_shadowBox')
            .height(jQuery(document).height() + 'px')
            .click(fnHideCmsAlert);

        const labbelledById = `${aParentId}-header`;
        $alert.find('.fbcms_contentheader .contentheader_item.fbcms_news_headlines_title').attr('id', labbelledById);

        const describedById = `${aParentId}-content`;
        $alert.find('.fbcms_headline_list_content ').attr('id', describedById);

        $alert
            .prepend(`<button type="button" title="Close alert" aria-labelledby="closeAlert-label" id="closeAlert"><i class="fas fa-times" aria-hidden="true"></i> <span id="closeAlert-label" class="visually-hidden">Close alert</span></button>`)
            .attr('role', 'alertdialog')
            .attr('aria-labelledby', labbelledById)
            .attr('aria-describedby', describedById)
            .attr('aria-hidden', "false")
            .show();

        $alert
            .find('#closeAlert')
            .on('click', fnHideCmsAlert)
            .on('keypress', function (event) {
                if (event.keyCode === 13 /*enter*/ || event.keyCode === 27 /*escape*/) {
                    event.preventDefault();
                    fnHideCmsAlert();
                }
            })
            .focus();


        let tababble = $alert.find(':tabbable');
        tababble.first().on('keydown', function (event) {
            if (event.keyCode === 9 && event.shiftKey === true) {
                event.preventDefault();
                $alert.find(':tabbable').last().focus();
            }

        });

        tababble.last().on('keydown', function (event) {
            if (event.keyCode === 9 && event.shiftKey === false) {
                event.preventDefault();
                $alert.find(':tabbable').first().focus();
            }

        });
    },

    /*
        FBCommon_1_2.initTabs();
    
        Initializes tab events (and cleanup).
        A Tabset is identified by .fbcms_tabset
        Two containers must be found inside, for the titles (.tabset_titlecontainer) and content (.tabset_contentcontainer)
        If only one title (.tabset_title) is found, nothing further is done.
        Active titles and content are indicated by the active class (.active).  
            This should be set in the markup on the desired set to be initially displayed.
        Each title must have data-tabselector attribute set with a selector for the matching content element inside the content container.
        Content and Tab elments must have id attributes set.
        If two or more are titles are present:
            Each title is checked if it is empty of Text (not markup).
            If blank or otherwise empty, the title and matching content elements are removed - unless Active (see extra options).
            If text is present, the title and content elements are labelled with ARIA attributes.
        
        Extra options:
            Clear All Empty (default: false) This will cause a title/content element to be removed EVEN IF IT IS ACTIVE. 
                This can be specified by a data attribute on the tabset container: data-tabset-clearallempty
                Setting this to 'true' will activate this setting, all other values will result in the default behavior.
        
        Unprocessed, initial markup example:
        
        <div class="fbcms_tabset" data-tabset-clearallempty="false">
            <ul class="tabset_titlecontainer" role="tablist">
                <li id="tabtitle1" class="tabset_title active" data-tab-selector="#tab1" role="tab">
                </li><!-- .tabset_title //-->
                <li id="tabtitle2" class="tabset_title" data-tab-selector="#tab2" role="tab">
                </li><!-- .tabset_title //-->
            </ul><!-- .tabset_titlecontainer //-->
            <div class="tabset_contentcontainer">
                <div id="tab1" class="tabset_content active" role="tabpanel">
                </div><!-- .tabset_content //-->
                <div id="tab2" class="tabset_content" role="tabpanel">
                </div><!-- .tabset_content //-->
            </div><!-- .tabset_contentcontainer //-->
        </div>
    */
    initTabs: function ()
    {
        function activateTabSetTitle(aTarget, aCleanAnchorHash) 
        {
            const jCurrentTab = $(aTarget).closest('.tabset_title');
            if (jCurrentTab.hasClass('active'))
            {
                return;
            }

            const contentSelector = jCurrentTab.data('tab-selector');
            if (contentSelector === undefined || contentSelector === null || contentSelector.length === 0)
            {
                return;
            }
            
            const jTabSet = jCurrentTab.closest('.fbcms_tabset');
            const jContentContainers = jTabSet.find('.tabset_contentcontainer');            
            const jContent = jContentContainers.find(contentSelector);
            if (jContent.length === 0)
            {
                return;
            }

            const jTitleContainers = jTabSet.find('.tabset_titlecontainer');

            jTitleContainers.find('.tabset_title').removeClass('active').attr('aria-selected', 'false');
            jContentContainers.find('.tabset_content').removeClass('active');
            jCurrentTab.addClass('active').attr('aria-selected', 'true');
            jContent.addClass('active');

            if (!FBUtilities.IsParameterUndefinedOrEmpty(aCleanAnchorHash))
            {
                // was given an anchor, use it.
                window.location.hash = `#${aCleanAnchorHash}`;
            }
            else if (!FBUtilities.IsParameterUndefinedOrEmpty(window.location.hash))
            {   
                // is the current hash inside this hashset? in active content? in titles?
                const inTabset = jTabSet.find(window.location.hash).length !== 0
                const inActiveContent = jContent.find(window.location.hash).length !== 0;
                const inTitles = jTitleContainers.find(window.location.hash).length !== 0;

                if (inTabset && !inActiveContent && !inTitles)
                {
                    const cleanedUrl = window.location.href.split('#')[0];
                    window.history.replaceState(null, null, cleanedUrl);
                }
            }

            const cleanAnchorHash = !FBUtilities.IsParameterUndefinedOrEmpty(aCleanAnchorHash) ? aCleanAnchorHash : undefined;
            setTimeout(function ()
            {
                if (cleanAnchorHash !== undefined)
                {
                    // was given an anchor, use it.
                    const cleanedUrl = window.location.href.split('#')[0];
                    window.history.replaceState(null, null, cleanedUrl);
                    window.location.hash = `#${cleanAnchorHash}`;
                }

                const masons = jContent.find('.masonry');
                if (masons.length !== 0 && masons.masonry !== undefined)
                {
                    masons.masonry("layout");
                }
            }, 1);
        }

        const tabSets = $('.fbcms_tabset');
        if (tabSets.length === 0)
        {
            return;
        }

        const isEditMode = FBCommon_1_2.isInEditor();

        tabSets.each(function ()
        {
            const $tabSet = $(this);
            const $titleContainers = $tabSet.find('.tabset_titlecontainer');
            const $contentContainers = $tabSet.find('.tabset_contentcontainer');

            if ($titleContainers.length > 0 && $contentContainers.length > 0)
            {
                const clearAllEmpty = $tabSet.data('tabset-clearallempty');
                const keepEmpty = $tabSet.data('tabset-keepempty');
                const $titles = $titleContainers.find('.tabset_title');
                if ($titles.length < 2)
                {
                    $titleContainers.on('click', '.tabset_title', function (aEvent) {
                        aEvent.preventDefault();
                        return false;
                    });

                    if ($tabSet.find('.tabset_title').length === 0) {
                        $tabSet.remove();
                    }
                    return;
                }

                if (isEditMode === false)
                {
                    $.each($titles, function (aIndex, aValue)//ignore jslint
                    {
                        const $title = $(aValue);
                        const isActive = $title.hasClass('active');
                        const contentSelector = $title.data('tab-selector');

                        if (FBUtilities.IsParameterUndefinedOrEmpty(contentSelector))
                        {
                            return;
                        }

                        const $content = $contentContainers.find(contentSelector);
                        if ($content.length === 0)
                        {
                            return;
                        }

                        if (keepEmpty !== true
                            && FBUtilities.IsStringEmptyOrWhitespace($title.text()) === true
                            && (isActive === false || clearAllEmpty === true)
                        )
                        {
                            $title.remove();
                            $content.remove();
                            if ($tabSet.find('.tabset_title').length === 0) {
                                $tabSet.remove();
                            }
                            return;
                        }

                        const tabId = $title.attr('id');
                        const contentId = $content.attr('id');
                        if (FBUtilities.IsStringEmptyOrWhitespace(tabId) === true
                            || FBUtilities.IsStringEmptyOrWhitespace(contentId) === true)
                        {
                            return;
                        }
                        $title.attr('aria-controls', contentId);
                        $title.attr('aria-selected', isActive);
                        $content.attr('aria-labelledby', tabId);
                    });
                }

                $titleContainers.on('click', '.tabset_title', (event) => 
                {
                    event.preventDefault();
                    const tabSet = event.target;
                    activateTabSetTitle(tabSet);
                    return false;
                });
            }

            window.addEventListener("hashchange", (event) =>
            {
                selectHashRequestedTab($titleContainers);
            });

            selectHashRequestedTab($titleContainers);
        });

        function selectHashRequestedTab(aTabWrapper)
        {
            const rawAnchorHash = window.location.hash;
            if (rawAnchorHash.lastIndexOf('#') === -1)
            {
                return;
            }

            const cleanAnchorHash = rawAnchorHash.substring(rawAnchorHash.lastIndexOf('#') + 1);
            const jDirect = aTabWrapper.find(`.tabset_title[data-tab-selector="${rawAnchorHash}"]`);
            if (jDirect.length !== 0)
            {
                if (jDirect.length === 1)
                {
                    activateTabSetTitle(jDirect, cleanAnchorHash);
                }
                return
            }

            const jTarget = $(`#${cleanAnchorHash}`);
            if (jTarget.length !== 1)
            {
                return;
            }

            const jTabsetContent = jTarget.closest('.tabset_content');
            if (jTabsetContent.length !== 1)
            {
                return;
            }

            const parentTabContentId = jTabsetContent.attr('id');
            const jTitlesToActivate = aTabWrapper.find('.tabset_title[data-tab-selector="#' + parentTabContentId + '"]')
            if (jTitlesToActivate.length !== 1)
            {
                return;
            }

            activateTabSetTitle(jTitlesToActivate, cleanAnchorHash);
        }//end selectHashRequestedTab
    },//end initTabs

    getJQueryDialogButton: function (dialog_selector, button_name)
    {
        var buttons = $(dialog_selector + ' .ui-dialog-buttonpane button');
        for (var i = 0; i < buttons.length; ++i)
        {
            var jButton = $(buttons[i]);
            if (jButton.text() === button_name)
            {
                return jButton;
            }
        }

        return null;
    },

    disableJQueryDialogButton: function (dialog_selector, button_name)
    {
        var button = FBCommon_1_2.getJQueryDialogButton(dialog_selector, button_name);
        if (button !== null)
        {
            button.attr('disabled', 'disabled').addClass('ui-state-disabled');
        }
    },

    enableJQueryDialogButton: function (dialog_selector, button_name)
    {
        var button = FBCommon_1_2.getJQueryDialogButton(dialog_selector, button_name);
        if (button !== null)
        {
            button.removeAttr('disabled').removeClass('ui-state-disabled');
        }
    }
};

///////////////////////////////////////////////////////////////////////////////
// FBCommon_1_2 Function Aliases
///////////////////////////////////////////////////////////////////////////////

var isInEditor = FBCommon_1_2.isInEditor;
var PairCountrySelectWithStateSelect = FBCommon_1_2.PairCountrySelectWithStateSelect;
var addSearchBoxTriggers = FBCommon_1_2.addSearchBoxTriggers; //clarenceville & vansingel(!)
var setQuickJumpMenu = FBCommon_1_2.setQuickJumpMenu; //fruitport2015 & mioausable


///////////////////////////////////////////////////////////////////////////////
// jQuery Timer Plugin
///////////////////////////////////////////////////////////////////////////////

(function ()
{
    /*
    * jQuery Timer Plugin
    * http://www.evanbot.com/article/jquery-timer-plugin/23
    *
    * @version      1.0
    * @copyright    2009 Evan Byrne (http://www.evanbot.com)
    */

    jQuery.timer = function (time, func, callback)
    {
        var a = {
            timer: setTimeout(func, time),
            callback: null
        };

        if (typeof callback === 'function')
        {
            a.callback = callback;
        }
        return a;
    };

    jQuery.clearTimer = function (a)
    {
        if (a === null)
        {
            return this;
        }
        clearTimeout(a.timer);
        if (typeof (a.callback) === 'function')
        {
            a.callback();
        }
        return this;
    };
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// A real string replaceAll function
///////////////////////////////////////////////////////////////////////////////

//(function ()
//{
//    // http://www.codedigest.com/CodeDigest/75-String-ReplaceAll-function-in-JavaScript.aspx
//    String.prototype.replaceAll = function (stringToFind, stringToReplace)
//    {
//        var temp, index;

//        temp = this.toString();
//        index = temp.indexOf(stringToFind);

//        while (index !== -1)
//        {
//            temp = temp.replace(stringToFind, stringToReplace);
//            index = temp.indexOf(stringToFind);
//        }
//        return temp;
//    };
//}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FoxEncoder
///////////////////////////////////////////////////////////////////////////////

(function ()
{
    //----------------------------------------------------------------------------
    //  FoxEncoder Javascript functions.
    //  http://ntt.cc/2008/01/19/base64-encoder-decoder-with-javascript.html
    //----------------------------------------------------------------------------

    FoxEncoder.keyStr64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    FoxEncoder.base64RegexTest = /[^A-Za-z0-9\+\/\=]/g;

    FoxEncoder.encodeUTF8andBase64 = function (input)
    {
        return FoxEncoder.encodeUTF8andBase64worker(input, FoxEncoder.keyStr64);
    };

    FoxEncoder.encodeUTF8andBase64worker = function (input, keyStr64)
    {
        var output = "",
            chr1,
            chr2,
            chr3 = "",
            enc1,
            enc2,
            enc3,
            enc4 = "",
            i = 0;

        if (FBUtilities.IsParameterUndefinedOrEmpty(input))
        {
            return output;
        }

        input = FoxEncoder.encodeUTF8(input);

        do
        {
            chr1 = input.charCodeAt(i);
            i += 1;
            chr2 = input.charCodeAt(i);
            i += 1;
            chr3 = input.charCodeAt(i);
            i += 1;

            enc1 = chr1 >> 2; //ignore jslint
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4); //ignore jslint
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6); //ignore jslint
            enc4 = chr3 & 63; //ignore jslint

            if (isNaN(chr2))
            {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3))
            {
                enc4 = 64;
            }

            output = output +
                keyStr64.charAt(enc1) +
                keyStr64.charAt(enc2) +
                keyStr64.charAt(enc3) +
                keyStr64.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        }
        while (i < input.length);

        return output;
    }; //end FoxEncoder.encodeUTF8andBase64worker

    FoxEncoder.decodeBase64andUTF8 = function (input)
    {
        return FoxEncoder.decodeBase64andUTF8worker(input, FoxEncoder.keyStr64, FoxEncoder.base64RegexTest);
    };

    FoxEncoder.decodeBase64andUTF8worker = function (input, keyStr64, base64RegexTest)
    {
        var output = "",
            chr1, chr2, chr3 = "",
            enc1, enc2, enc3, enc4 = "",
            i = 0;

        // remove all characters that are not in the key string.
        if (base64RegexTest.exec(input))
        {
            return null;
        }
        input = input.replace(base64RegexTest, "");

        do
        {
            enc1 = keyStr64.indexOf(input.charAt(i));
            i += 1;
            enc2 = keyStr64.indexOf(input.charAt(i));
            i += 1;
            enc3 = keyStr64.indexOf(input.charAt(i));
            i += 1;
            enc4 = keyStr64.indexOf(input.charAt(i));
            i += 1;

            chr1 = (enc1 << 2) | (enc2 >> 4); //ignore jslint
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2); //ignore jslint
            chr3 = ((enc3 & 3) << 6) | enc4; //ignore jslint

            output = output + String.fromCharCode(chr1);

            if (enc3 !== 64)
            {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64)
            {
                output = output + String.fromCharCode(chr3);
            }

            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        }
        while (i < input.length);

        output = FoxEncoder.decodeUTF8(output);
        return output;
    }; //end FoxEncoder.decodeBase64andUTF8

    // private method for UTF-8 encoding
    FoxEncoder.encodeUTF8 = function (string) 
    {
        var utftext = "",
            n,
            c;

        string = string.replace(/\r\n/g, "\n");


        for (n = 0; n < string.length; n += 1)
        {

            c = string.charCodeAt(n);

            if (c < 128)
            {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048))
            {
                utftext += String.fromCharCode((c >> 6) | 192); //ignore jslint
                utftext += String.fromCharCode((c & 63) | 128);  //ignore jslint
            }
            else
            {
                utftext += String.fromCharCode((c >> 12) | 224); //ignore jslint
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);  //ignore jslint
                utftext += String.fromCharCode((c & 63) | 128);  //ignore jslint
            }

        }

        return utftext;
    };

    // private method for UTF-8 decoding
    FoxEncoder.decodeUTF8 = function (utftext)
    {
        var string = "",
            i = 0,
            c = 0,
            c2 = 0,
            c3 = 0;

        while (i < utftext.length)
        {

            c = utftext.charCodeAt(i);

            if (c < 128)
            {
                string += String.fromCharCode(c);
                i += 1;
            }
            else if ((c > 191) && (c < 224))
            {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63)); //ignore jslint
                i += 2;
            }
            else
            {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)); //ignore jslint
                i += 3;
            }

        }

        return string;
    };
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FoxAjaxContent
///////////////////////////////////////////////////////////////////////////////

(function ()
{
    // "Static" Variables
    //////////////////////////////////////////////////////////////////////////////////////////////////
    //   Variables defined here are used by all fox ajax content instances on the page.

    // class of the div wrapper
    FoxAjaxContent.loading_class = "fb_ajax_loading";
    FoxAjaxContent.content_class = "fb_ajax_content";

    FoxAjaxContent.support_animate = true;

    //////////////////////////////////////////////////////////////////////////////////////////////////


    // "Static" Methods
    //////////////////////////////////////////////////////////////////////////////////////////////////
    //   Functions defined here are used by all fox ajax content instances on the page.

    FoxAjaxContent.createFoxAjaxContent = function (guid, pagecontent_id, fullpath, oncompletecallback)
    {
        if (guid === undefined)
        {
            FBUtilities.LogMessage("FoxAjaxContent: creation error - guid undefined");
            return null;
        }

        if (pagecontent_id === undefined)
        {
            FBUtilities.LogMessage("FoxAjaxContent: creation error - pagecontent_id undefined");
            return null;
        }

        if (fullpath === undefined)
        {
            FBUtilities.LogMessage("FoxAjaxContent: creation error - fullpath undefined");
            return null;
        }

        if ('v' == '\v' /*jQuery.browser.msie*/) //ignore jslint
        {
            FoxAjaxContent.support_animate = false;
        }

        var my_content = new FoxAjaxContent();
        my_content.guid = guid;
        my_content.pagecontent_id = pagecontent_id;
        my_content.fullpath = fullpath;
        if (oncompletecallback !== undefined)
        {
            if (oncompletecallback !== undefined && typeof oncompletecallback === "function")
            {
                my_content.oncompletecallback = oncompletecallback;
            }
        }
        return my_content;
    };


    // "Object" Variables
    //////////////////////////////////////////////////////////////////////////////////////////////////
    //    Variables defined here are used as unique copies in each instance of fox ajax content.
    //    they are defined with these defaults, and may be modified after being instanciated
    //    without effecting others.


    // id of the div where content is to be placed.
    FoxAjaxContent.prototype.guid = null;
    // name of the section which the contains the content.
    FoxAjaxContent.prototype.pagecontent_id = null;
    // url where the section is found (usually the current url)
    FoxAjaxContent.prototype.fullpath = null;


    //////////////////////////////////////////////////////////////////////////////////////////////////

    // Loads the requested content into the area, sending along requested parameters, if any.
    FoxAjaxContent.prototype.loadRequestedContent = function (params) 
    {
        var lContentLoader, content_selector, loading_selector, fullpath, data, prop;

        lContentLoader = this;
        content_selector = '#' + lContentLoader.guid + ' .' + FoxAjaxContent.content_class;
        loading_selector = '#' + lContentLoader.guid + ' .' + FoxAjaxContent.loading_class;

        // animate fade out.
        if (FoxAjaxContent.support_animate)
        {
            jQuery(content_selector).animate(
                { opacity: 0.4 },
                { duration: 250 });
        }
        jQuery(loading_selector).show(250);

        fullpath = lContentLoader.fullpath;
        data = {
            fco: '1',
            pcid: lContentLoader.pagecontent_id
        };

        if (params !== undefined)
        {
            if (typeof params === "object")
            {
                for (prop in params)
                {
                    if (params.hasOwnProperty(prop))
                    {
                        data[prop] = params[prop];
                    }
                } //endfor
            }
            //else if ( typeof ( params ) === "function" )
            //{
            //    // function
            //}
            //else
            //{
            //    // number, string, or boolean
            //}
        }
        jQuery(content_selector).load(fullpath, data, function ()
        {
            FBUtilities.initializeLoadables($(content_selector).get(0));
            if (lContentLoader.oncompletecallback !== undefined)
            {
                if (typeof (lContentLoader.oncompletecallback) === "function")
                {
                    lContentLoader.oncompletecallback(content_selector);
                }
            }
            // animate fade back
            if (FoxAjaxContent.support_animate)
            {
                jQuery(content_selector).animate(
                    { opacity: 1.0 },
                    { duration: 250 });
            }
            jQuery(loading_selector).hide(250);
        });
    };
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// ThumbnailUtilities
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    ThumbnailUtilities.RandomParamName = 'r';
    ThumbnailUtilities.MaxWidthParamName = 'w';
    ThumbnailUtilities.MaxHeightParamName = 'h';
    ThumbnailUtilities.CropperOptionParamName = 'c';
    ThumbnailUtilities.FullCropperOptionValue = 'f';
    ThumbnailUtilities.ThumbnailCropperOptionValue = 't';

    ThumbnailUtilities.GetThumbnailUrl = function (aParameters)
    {

        if (FBUtilities.IsParameterUndefinedOrEmpty(aParameters)) 
        {
            FBUtilities.LogMessage('ThumbnailUtilities: Null or empty parameters sent.');
            return;
        }

        var lDefaults, lParameters, lUrl, lThumbnailParams;

        lDefaults = {
            Url: null
            , MaxWidth: null
            , MaxHeight: null
            , AddRandomParam: false
        };

        lParameters = $.extend(lDefaults, aParameters);

        if (FBUtilities.IsParameterUndefinedOrEmpty(lParameters.Url)) 
        {
            FBUtilities.LogMessage('ThumbnailUtilities: Url not set.');
            return;
        }

        lUrl = lParameters.Url;
        lThumbnailParams = {};
        lThumbnailParams[ThumbnailUtilities.CropperOptionParamName] = ThumbnailUtilities.ThumbnailCropperOptionValue;

        if (!FBUtilities.IsParameterUndefinedOrEmpty(lParameters.MaxWidth)) 
        {
            lThumbnailParams[ThumbnailUtilities.MaxWidthParamName] = lParameters.MaxWidth;
        }

        if (!FBUtilities.IsParameterUndefinedOrEmpty(lParameters.MaxHeight)) 
        {
            lThumbnailParams[ThumbnailUtilities.MaxHeightParamName] = lParameters.MaxHeight;
        }

        if (lParameters.AddRandomParam === true)
        {
            lThumbnailParams[ThumbnailUtilities.RandomParamName] = Math.random();
        }

        return FBUtilities.BuildGetUrl(lUrl, lThumbnailParams);
    }; //end GetThumbnailUrl

}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBUtilities
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    FBUtilities.DebugMode = false;

    let allowedTldArray = null;
    const defaultAllowedTlds = 'com,org,net,edu,gov,mil,us,academy,education,school';

    FBUtilities.GetAllowedTLDs = function ()
    {        
        if (allowedTldArray === null)
        {
            const allowed = FBUtilities.IsStringEmptyOrWhitespace(cmsAllowedEmailTlds) ? defaultAllowedTlds : cmsAllowedEmailTlds;
            let items = allowed.split(/[\s,;]+/)
            let update = [];
            for (let i = 0; i < items.length; i++)
            {
                let value = items[i];
                if (value !== undefined && value !== null && (typeof value === 'string') && value.length !== 0)
                {
                    update.push(value);
                }
            }

            allowedTldArray = update;
        }

        return allowedTldArray;
    };

    FBUtilities.IsParameterUndefined = function (aParameter)
    {
        if (aParameter === undefined)
        {
            return true;
        }
        return false;
    };//end IsParameterUndefined

    FBUtilities.IsParameterUndefinedOrNull = function (aParameter)
    {
        return (aParameter === undefined || aParameter === null);
    };//end IsParameterUndefinedOrNull

    FBUtilities.IsParameterUndefinedOrEmpty = function (aParameter)
    {
        return (aParameter === undefined || aParameter === null || aParameter.length === 0);
    };//end IsParameterUndefinedOrEmpty

    FBUtilities.IsStringEmptyOrWhitespace = function (aParameter)
    {
        return (aParameter === undefined || aParameter === null || aParameter.length === 0 || $.trim(aParameter) === '');
    };//end IsStringEmptyOrWhitespace

    FBUtilities.AreStringsEqual = function (aFirst, aSecond, aCaseInsensitive)
    {
        if (typeof aFirst !== "string")
        {
            return false;
        }

        if (typeof aSecond !== "string")
        {
            return false;
        }

        let first = (aCaseInsensitive === true) ? aFirst.toLowerCase() : aFirst;
        let second = (aSecond === true) ? aFirst.toLowerCase() : aSecond;

        return first === second;
    };


    FBUtilities.GetIntOrNull = function (aParameter)
    {
        if (FBUtilities.IsParameterUndefinedOrEmpty(aParameter))
        {
            return null;
        }

        var lInt = parseInt(aParameter, 10);
        if (isNaN(lInt))
        {
            return null;
        }

        return lInt;
    };//end GetIntOrNull

    FBUtilities.GetBoolOrNull = function (aParameter)
    {
        if (FBUtilities.IsParameterUndefinedOrEmpty(aParameter))
        {
            return null;
        }

        var lInput = aParameter;
        if (typeof lInput === 'string')
        {
            lInput = lInput.toLowerCase();
        }
        switch (lInput)
        {
            case true:
            case "true":
            case 1:
            case "1":
            case "on":
            case "yes":
                return true;
            case false:
            case "false":
            case 0:
            case "0":
            case "off":
            case "no":
                return false;
            default:
                return null;
        }//endswitch
    }; //end GetBoolOrNull

    FBUtilities.GetCallbackOrNull = function (aCallbacks, aName)
    {
        if (FBUtilities.IsParameterUndefinedOrEmpty(aCallbacks))
        {
            return null;
        }

        if (FBUtilities.IsParameterUndefinedOrNull(aCallbacks[aName]))
        {
            return null;
        }
        return aCallbacks[aName];
    };//end GetCallbackOrNull

    FBUtilities.HasCallback = function (aCallbacks, aName)
    {
        var lCallback = FBUtilities.GetCallbackOrNull(aCallbacks, aName);
        if (lCallback === null)
        {
            return false;
        }
        return true;
    };//end HasCallback

    FBUtilities.RunCallback = function (aCallbacks, aName)
    {
        var lIndex, lCallback, lPassOnArgs;

        FBUtilities.LogMessage('RunCallback - "' + aName + '"');

        lCallback = FBUtilities.GetCallbackOrNull(aCallbacks, aName);
        if (lCallback === null)
        {
            FBUtilities.LogMessage('RunCallback - "' + aName + '" - Not Found');
            return;
        }

        if (arguments.length > 2)
        {
            lPassOnArgs = [];
            for (lIndex = 2; (lIndex < arguments.length); lIndex += 1)
            {
                lPassOnArgs.push(arguments[lIndex]);
            }
            lCallback.apply(this, lPassOnArgs);
        }
        else
        {
            lCallback();
        }
    };//end RunCallback

    // DEPRECATED -- TODO REEVALUATE KEEPING THIS. //
    FBUtilities.YesNoValue = function (aElement) 
    {
        if (FBUtilities.IsParameterUndefinedOrNull(aElement))
        {
            return;
        }

        var lId, lIsRadio;

        lId = aElement.attr('id');
        lIsRadio = aElement.hasClass('yesnoradio');

        if (FBUtilities.IsParameterUndefinedOrEmpty(lId))
        {
            return;
        }

        if (lIsRadio)
        {
            if (aElement.find('#' + lId + '_yes:checked').length === 1)
            {
                return true;
            }
            if (aElement.find('#' + lId + '_no:checked').length === 1)
            {
                return false;
            }
        }

        return null;
    };//end YesNoValue

    // Replaces an item in an array with a replacement item.
    //  Assumes uniqueness, i.e. only the first item will 
    //    be replaced.
    //  Array: Array to act on, changes are made in place.
    //           If undefined or null, returns.
    //  Parameters: (If undefined or null, returns.)
    //    Item - Item in the array to replace, if not defined 
    //          (or not found), the Replacement will be put 
    //          at the end of the array.
    //    Replacement - Replacement item for the array. If 
    //          undefined, the Item will simply be deleted.
    FBUtilities.ReplaceArrayItem = function (aArray, aParameters)
    {
        if (FBUtilities.IsParameterUndefinedOrNull(aArray))
        {
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrNull(aParameters))
        {
            return;
        }

        var lDeleteCount, lStart, lIndex;

        lDeleteCount = 0;
        lStart = aArray.length;

        if (!FBUtilities.IsParameterUndefined(aParameters.Item))
        {
            lDeleteCount = 1;
        }

        if (!FBUtilities.IsParameterUndefined(aParameters.Replacement))
        {
            for (lIndex = 0; lIndex < aArray.length; lIndex += 1)
            {
                if (aArray[lIndex] === aParameters.Replacement)
                {
                    lStart = lIndex;
                    break;
                }
            }//endfor

            aArray.splice(lStart, lDeleteCount, aParameters.Replacement);
        }
        else
        {
            aArray.splice(lStart, lDeleteCount);
        }
    }; //end ReplaceArrayItem

    // Converts a hash array into a string using the separators given.
    //  Parameters:
    //    aHashArray - (If undefined, null or empty, blank is returned.)
    //    aEntrySeparator - Separator to appear between each entry. 
    //      (If undefined, null, or blank, ';' is used.)
    //    aPairSeparator - Separator to appear between the key and value in each pair. 
    //      (If undefined, null, or blank, '=' is used.)
    //
    // Example:
    //  "key1=value1;key2=value2"
    FBUtilities.JoinHashArray = function (aHashArray, aEntrySeparator, aPairSeparator) 
    {
        var lResult = '',
            lEntrySeparator = ';',
            lPairSeparator = '=',
            lKey;

        if (FBUtilities.IsParameterUndefinedOrEmpty(aHashArray))
        {
            return lResult;
        }

        if (!FBUtilities.IsParameterUndefinedOrEmpty(aEntrySeparator))
        {
            lEntrySeparator = aEntrySeparator;
        }

        if (!FBUtilities.IsParameterUndefinedOrEmpty(aPairSeparator))
        {
            lPairSeparator = aPairSeparator;
        }

        for (lKey in aHashArray)
        {
            if (aHashArray.hasOwnProperty(lKey))
            {
                lResult += lKey;
                lResult += lPairSeparator;
                lResult += aHashArray[lKey];
                lResult += lEntrySeparator;
            }
        }//endfor

        return lResult;
    };//end JoinHashArray

    // Converts a hash array into a GET url string.
    //  Parameters:
    //    aUrl - The url the parameters are to be appended to.
    //      (If undefined or null it is returned. If empty or 
    //      full, parameters [if any] are appended)
    //    aParameters - GET params to be appended to the url.
    FBUtilities.BuildGetUrl = function (aUrl, aParameters)
    {
        var lResult, lParamString;

        lResult = aUrl;
        if (FBUtilities.IsParameterUndefinedOrNull(aUrl))
        {
            FBUtilities.LogMessage('BuildGetUrl: Null or undefined url.');
            return lResult;
        }

        if (FBUtilities.IsParameterUndefinedOrNull(aParameters))
        {
            FBUtilities.LogMessage('BuildGetUrl: Null or undefined parameters.');
            return lResult;
        }

        lParamString = FBUtilities.JoinHashArray(aParameters, '&');
        if (lParamString.length > 0)
        {
            lParamString = '?' + lParamString;
        }

        return lResult + lParamString;
    }; //end BuildGetUrl

    FBUtilities.CombinePath = function (...segments)
    {
        let combined = '';
        for (const segment of segments)
        {
            if (!FBUtilities.IsStringEmptyOrWhitespace(segment))
            {
                combined = combined.replace(/\/+$/, '') + '/' + segment.replace(/^\/+/, '');
            }
        }
        return combined;
    };
    FBUtilities.LogMessage = function (aMessage)
    {
        if (FBUtilities.DebugMode === false) 
        {
            return;
        }

        if (window.console
            && window.console.log)
        {
            window.console.log(aMessage);
        }
    }; //end LogMessage


    FBUtilities.GetPageSize = function ()
    {
        var lXScroll,
            lYScroll,
            lWindowWidth,
            lWindowHeight,
            lPageWidth,
            lPageHeight,
            self = window,
            lArrayPageSize;

        if (window.innerHeight
            && window.scrollMaxY) 
        {
            lXScroll = document.body.scrollWidth;
            lYScroll = window.innerHeight + window.scrollMaxY;
        }
        else if (document.body.scrollHeight > document.body.offsetHeight)
        {
            // all but Explorer Mac
            lXScroll = document.body.scrollWidth;
            lYScroll = document.body.scrollHeight;
        }
        else 
        {
            // Explorer Mac...would also work in Explorer 6 Strict, Mozilla and Safari
            lXScroll = document.body.offsetWidth;
            lYScroll = document.body.offsetHeight;
        }


        if (self.innerHeight) 
        {
            // all except Explorer
            lWindowWidth = self.innerWidth;
            lWindowHeight = self.innerHeight;
        }
        else if (document.documentElement
            && document.documentElement.clientHeight) 
        {
            // Explorer 6 Strict Mode
            lWindowWidth = document.documentElement.clientWidth;
            lWindowHeight = document.documentElement.clientHeight;
        }
        else if (document.body) 
        {
            // other Explorers
            lWindowWidth = document.body.clientWidth;
            lWindowHeight = document.body.clientHeight;
        }

        // for small pages with total height less then height of the viewport
        if (lYScroll < lWindowHeight)
        {
            lPageHeight = lWindowHeight;
        }
        else 
        {
            lPageHeight = lYScroll;
        }

        // for small pages with total width less then width of the viewport
        if (lXScroll < lWindowWidth)
        {
            lPageWidth = lWindowWidth;
        }
        else 
        {
            lPageWidth = lXScroll;
        }

        lArrayPageSize = [lPageWidth, lPageHeight, lWindowWidth, lWindowHeight];
        return lArrayPageSize;
    };//end GetPageSize

    FBUtilities.GetPageScroll = function ()
    {
        var lYScroll,
            self = window,
            lArrayPageScroll;

        if (self.pageYOffset) 
        {
            lYScroll = self.pageYOffset;
        }
        else if (document.documentElement
            && document.documentElement.scrollTop)
        {
            // Explorer 6 Strict
            lYScroll = document.documentElement.scrollTop;
        }
        else if (document.body) 
        {
            // all other Explorers
            lYScroll = document.body.scrollTop;
        }

        lArrayPageScroll = ['', lYScroll];
        return lArrayPageScroll;
    };//end GetPageScroll

    FBUtilities.SetupStickyNav = function (aHeaderSelector, aStickyNavSelector)
    {
        var lHeader = $(aHeaderSelector);
        if (lHeader.length === 0)
        {
            return;
        }

        var lStickyNav = $(aStickyNavSelector);
        if (lStickyNav.length === 0)
        {
            return;
        }

        var lHeaderHeight = lHeader.outerHeight();
        var lStickyNavHeight = lStickyNav.outerHeight();

        if (lHeaderHeight === 0
            || lStickyNavHeight === 0
            || lHeaderHeight < lStickyNavHeight)
        {
            return;
        }

        var lAboveHeight = lHeaderHeight;


        var lUpdateStickyNav = function ()
        {
            //if the page size is too small, remove modifiers
            if (window.innerWidth < 768)
            {
                lStickyNav.removeClass('fixed_menu');
            }
            else
            {
                lHeaderHeight = lHeader.outerHeight();
                lAboveHeight = lHeaderHeight;
            }
        };

        $(window).scroll(
            function ()
            {
                //if (Modernizr.mq('(max-width: 767px)')) {
                if ($(window).width() < 768)
                {
                    return;
                }

                //if scrolled down more than the header’s height
                if ($(window).scrollTop() > lAboveHeight)
                {
                    // if yes, add sticky class to the sticky nav
                    lStickyNav.addClass('fixed_menu');
                    $('.main_menu  .top_level_item > .drop_down').css('max-height', 'calc(100vh - ' + lStickyNavHeight + 'px');
                }
                else
                {
                    // when scroll up or less than lAboveHeight, remove the sticky class
                    lStickyNav.removeClass('fixed_menu');
                }
            }
        );

        $(window).resize(lUpdateStickyNav);
        lUpdateStickyNav();
    };//end SetupStickyNav

    FBUtilities.SetupStickyHeader = function (aHeaderSelector, aPaddingSelector)
    {
        var lHeader = $(aHeaderSelector);
        if (lHeader.length === 0)
        {
            return;
        }

        var lPaddedElement = $(aPaddingSelector);
        if (lPaddedElement.length === 0)
        {
            return;
        }

        var lHeaderHeight = lHeader.outerHeight();

        if (lHeaderHeight === 0)
        {
            return;
        }

        var lMainNavClass = 'nav-main';
        if ($('.' + lMainNavClass).length === 0)
        {
            lMainNavClass = 'main-nav';
        }
        if ($('.' + lMainNavClass).length === 0)
        {
            lMainNavClass = null;
        }

        var lUpdateStickyHeader = function ()
        {
            //if the page size is too small, remove modifiers
            if (window.innerWidth < 768)
            {
                lHeader.removeClass('fixed_header');
                $('.fixed_header_padded').css('padding-top', '');
                if (lMainNavClass !== null)
                {
                    $('.' + lMainNavClass + ' .top_level_item > .drop').css('max-height', 'none');
                }
                lPaddedElement.removeClass('fixed_header_padded');
                //if there might be some other dynamic styling, set the styled bits to "".
            }
            else
            {
                // if yes, modify the stuff
                lHeader.addClass('fixed_header');
                lPaddedElement.addClass('fixed_header_padded');

                // remove shrink class before measuring header height
                lHeader.removeClass('shrink');
                lHeaderHeight = lHeader.outerHeight();
                $("body").css("--StickyHeader-Height", "" + lHeaderHeight + "px");

                if ($(document).scrollTop() > 50)
                {
                    lHeader.addClass("shrink");
                }

                $('.fixed_header_padded').css('padding-top', lHeaderHeight + 'px');
                if (lMainNavClass !== null)
                {
                    //$('.' + lMainNavClass + ' .top_level_item > .drop').attr("tabindex", "1");// Not sure why this was here. Removed for #16028
                    $('.' + lMainNavClass + ' .top_level_item > .drop').css('max-height', 'calc(100vh - ' + lHeaderHeight + 'px');
                }
            }
        };

        // https://codepen.io/tomdurkin/pen/nvAjd
        $(document).on("scroll", function ()
        {
            if
                ($(document).scrollTop() > 50)
            {
                lHeader.addClass("shrink");
            }
            else
            {
                lHeader.removeClass("shrink");
            }
        });

        $(window).resize(lUpdateStickyHeader);
        lUpdateStickyHeader();
    };//end SetupStickyHeader

    // Sticky Header and Focus area with content that scrolls up between the two
    // - lUpdateFocusHeight helps define dimensions of a rotator 
    //   which doesn't have a height of its own when sticky due to absolute positioned images
    // - This does require some skin-level css
    FBUtilities.SetupStickyFocus = function (aHeaderSelector, aFocusWrapperSelector, aFocusSelector)
    {
        var lHeader = $(aHeaderSelector);
        if (lHeader.length === 0)
        {
            return;
        }

        var lFocusWrapperElement = $(aFocusWrapperSelector);
        if (lFocusWrapperElement.length === 0)
        {
            return;
        }

        var lFocusElement = $(aFocusSelector);
        if (lFocusElement.length === 0)
        {
            return;
        }

        var lHeaderHeight = lHeader.outerHeight();

        if (lHeaderHeight === 0)
        {
            return;
        }

        var lFocusHeight = 0;

        var lUpdateFocusHeight = function ()
        {
            lFocusWrapperElement.removeClass('fixed_focus_wrapper');
            lFocusElement.removeClass('fixed_focus');
            lFocusHeight = lFocusElement.outerHeight();
            if (lFocusHeight === 0)
            {
                return;
            }
        }

        var lMainNavClass = 'nav-main';
        if ($('.' + lMainNavClass).length === 0)
        {
            lMainNavClass = 'main-nav';
        }
        if ($('.' + lMainNavClass).length === 0)
        {
            lMainNavClass = null;
        }

        var lUpdateStickyContent = function ()
        {
            //if the page size is too small, remove modifiers
            if (window.innerWidth < 768)
            {
                lHeader.removeClass('fixed_header');
                $('.fixed_focus_wrapper').css('padding-bottom', '');
                if (lMainNavClass !== null)
                {
                    $('.' + lMainNavClass + ' .top_level_item > .drop').css('max-height', 'none');
                }
                lFocusWrapperElement.removeClass('fixed_focus_wrapper');
                lFocusElement.removeClass('fixed_focus');
                //if there might be some other dynamic styling, set the styled bits to "".
            }
            else
            {
                // if yes, modify the stuff
                lHeader.addClass('fixed_header');
                lUpdateFocusHeight();
                lFocusWrapperElement.addClass('fixed_focus_wrapper');
                lHeaderHeight = lHeader.outerHeight();
                $('.fixed_focus_wrapper').css('padding-bottom', lFocusHeight + 'px');
                lFocusElement.addClass('fixed_focus');
                $('.home_focus').css('padding-bottom', '0');
                if (lMainNavClass !== null)
                {
                    //$('.' + lMainNavClass + ' .top_level_item > .drop').attr("tabindex", "1");// Not sure why this was here. Removed for #16028
                    $('.' + lMainNavClass + ' .top_level_item > .drop').css('max-height', 'calc(100vh - ' + lHeaderHeight + 'px');
                }
            }
        };

        // https://codepen.io/tomdurkin/pen/nvAjd
        $(document).on("scroll", function ()
        {
            if
                ($(document).scrollTop() > 50)
            {
                $("header").addClass("shrink");
            }
            else
            {
                $("header").removeClass("shrink");
            }
        });

        $(window).resize(lUpdateStickyContent);
        lUpdateStickyContent();
    };//end SetupStickyFocus

    // Date related functions.
    const REGEX_TIME_24 = new RegExp(/^([0-2][0-9]):([0-5][0-9])$/);
    const REGEX_TIME_12 = new RegExp(/^(?:1[0-2]|0?[1-9]):[0-5][0-9] [aApP][mM]$/);

    FBUtilities.IsDateBeforeOrEqual = function (startDateString, endDateString, granularity)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(startDateString) || FBUtilities.IsStringEmptyOrWhitespace(endDateString))
        {
            return false;
        }

        const luxonStart = FBUtilities.ParseDateString(startDateString);
        const luxonEnd = FBUtilities.ParseDateString(endDateString);
        return luxonStart.isValid && luxonEnd.isValid && (luxonStart.startOf(granularity) <= luxonEnd.startOf(granularity));
    };

    FBUtilities.IsDateAndTimeBeforeOrEqual = function (startDate, startTime, endDate, endTime, granularity)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(startDate) 
            || FBUtilities.IsStringEmptyOrWhitespace(startTime)
            || FBUtilities.IsStringEmptyOrWhitespace(endDate)
            || FBUtilities.IsStringEmptyOrWhitespace(endTime)
        )
        {
            return false;
        }

        const luxonStart = FBUtilities.ParseDateTimeString(`${startDate} ${startTime}`);
        const luxonEnd = FBUtilities.ParseDateTimeString(`${endDate} ${endTime}`);
        return luxonStart.isValid && luxonEnd.isValid && (luxonStart.startOf(granularity) <= luxonEnd.startOf(granularity));
    };


    FBUtilities.IsTimeString = function (timeString)
    {
        return !FBUtilities.IsStringEmptyOrWhitespace(timeString) && (REGEX_TIME_24.test(timeString) || REGEX_TIME_12.test(timeString));
    };

    FBUtilities.ParseDateTimeString = function (dateTimeString)
    {
        const formats = [
            'yyyy-MM-dd HH:mm',
            'MM-dd-yyyy HH:mm',
            'yyyy-MM-dd H:mm',
            'MM-dd-yyyy H:mm',
            'yyyy-MM-dd hh:mm a',
            'MM-dd-yyyy hh:mm a',
            'yyyy-MM-dd h:mm a',
            'MM-dd-yyyy h:mm a'
        ];
        let dateTime = luxon.DateTime.invalid;
        for(const format of formats)
        {
            dateTime = luxon.DateTime.fromFormat(`${dateTimeString}`, format);
            if (dateTime.isValid)
            {
                break;
            }
        }
        return dateTime;
    };

    FBUtilities.ParseDateString = function (dateString)
    {
        const formats = ['MM/dd/yyyy', 'MM-dd-yyyy', 'yyyy-MM-dd'];
        let date = luxon.DateTime.invalid;
        for(const format of formats)
        {
            date = luxon.DateTime.fromFormat(`${dateString}`, format);
            if (date.isValid)
            {
                break;
            }
        }
        return date;
    };

    FBUtilities.IsDateString = function (dateString)
    {
        return FBUtilities.ParseDateString(dateString).isValid;
    };

    FBUtilities.ReformatToStandardDateString = function (dateString)
    {
        const date = FBUtilities.ParseDateString(dateString);
        return date.toFormat('MM/dd/yyyy');
    };     

    FBUtilities.ReformatToLongDateString = function (dateString)
    {
        const date = FBUtilities.ParseDateString(dateString);
        return date.toFormat('"cccc, MMMM d yyyy');
    };

    FBUtilities.ParseTimeString = function (timeString)
    {
        const formats = ['HH:mm', 'H:mm', 'hh:mm a', 'h:mm a'];
        let time = luxon.DateTime.invalid;
        for(const format of formats)
        {
            time = luxon.DateTime.fromFormat(`${timeString}`, format);
            if (time.isValid)
            {
                break;
            }
        }
        return time;
    };

    FBUtilities.ReformatToStandardTimeString = function (timeString)
    {
        const date = FBUtilities.ParseTimeString(timeString);
        return date.toFormat('h:mm a');
    };

    FBUtilities.IsHtmlDateField = function (aField)
    {
        let isHtmlDateField;
        if (aField === undefined)
        {
            isHtmlDateField = false;
        }
        else if (aField === null)
        {
            isHtmlDateField = false;
        }
        else if ($(aField).attr('type') !== 'date')
        {
            isHtmlDateField = false;
        }
        else if ($(aField).prop('type') !== 'date')
        {
            isHtmlDateField = false;
        }
        else
        {
            isHtmlDateField = true;
        }
        return isHtmlDateField;
    };

    FBUtilities.IsHtmlTimeField = function (aField)
    {
        let isTimeField;
        if (aField === undefined)
        {
            isTimeField = false;
        }
        else if (aField === null)
        {
            isTimeField = false;
        }
        else if ($(aField).attr('type') !== 'time')
        {
            isTimeField = false;
        }
        else if ($(aField).prop('type') !== 'time')
        {
            isTimeField = false;
        }
        else
        {
            isTimeField = true;
        }
        return isTimeField;
    };

    

    
    /**
     * Updates the style of the widget overlay underneath a jquery dialog. This method
     * ensures that the overlay has a reasonable zindex and is semi-opaque. 
     * @param {any} the jquery dialog.
     */
    FBUtilities.UpdateWidgetOverlayStyle = function (dialog)
    {
        let dialogIndex = window.getComputedStyle(dialog).getPropertyValue('z-index');
        if (!Number.isInteger(dialogIndex))
        {
            dialogIndex = $(dialog)[0].style.zIndex;
            if (!Number.isInteger(dialogIndex))
            {
                dialogIndex = 100;
            }
        }

        let overlayIndex = dialogIndex - 1;
        $(".ui-widget-overlay").attr('style', `background-color: #000; opacity:0.6; z-index:${overlayIndex};`);
    };
    
    // appends the markup given to the DOM element given.
    // Does nothing if either is null or markup is whitespace.
    FBUtilities.AppendMarkup = function (aElement, aMarkup)
    {
        if (FBUtilities.IsParameterUndefinedOrNull(aElement) === true)
        {
            return;
        }
        var lNewElement = FBUtilities.BuildDomElement(aMarkup);
        if (lNewElement === null)
        {
            return;
        }
        aElement.appendChild(lNewElement);
    };
    
    // Returns a loose DOM element (child of a Template) built from the markup given.
    // Returns null if markup is null or whitespace.
    FBUtilities.BuildDomElement = function (aMarkup)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aMarkup) === true)
        {
            return null;
        }
        var tempDiv = document.createElement('template');
        tempDiv.innerHTML = aMarkup.trim();
        return tempDiv.content.firstChild;
    };
    
    // Returns valid Foxbright Icons markup.
    // Returns an empty string if the icon url or title are null or empty.
    FBUtilities.BuildFBIconMarkup = function (aIconUrl, aTitle, aAdditionalClasses)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aIconUrl) === true
            || FBUtilities.IsStringEmptyOrWhitespace(aTitle) === true)
        {
            return '';
        }
        let lAdditionalClasses = '';
        if (FBUtilities.IsStringEmptyOrWhitespace(aAdditionalClasses) === false)
        {
            lAdditionalClasses = ' ' + aAdditionalClasses.trim();
        }
        return `<span class="fb-icon${lAdditionalClasses}" title="${aTitle}"><load-file replaceWith src="${aIconUrl}"></load-file></span>`;
    };

    function _getVersionedStorageObjectKey(itemName)
    {
        const version = typeof cmsVersion !== 'undefined' ? cmsVersion : "website";
        return `${itemName}_${version}`;
    }

    FBUtilities.getLocalStorageObject = function (itemName)
    {        
        let result = undefined;
        const key = _getVersionedStorageObjectKey(itemName);
        const item = localStorage.getItem(key);
        if (item !== null)
        {
            const jsonString = FoxEncoder.decodeBase64andUTF8(item);
            result = JSON.parse(jsonString);
        }
        return result;
    };

    FBUtilities.setLocalStorageObject = function (itemName, dataObject)
    {
        const key = _getVersionedStorageObjectKey(itemName);
        const jsonString = JSON.stringify(dataObject);
        const base64value = FoxEncoder.encodeUTF8andBase64(jsonString);
        localStorage.setItem(key, base64value);
    };

    FBUtilities.removeLocalStorageObject = function (itemName)
    {
        const key = _getVersionedStorageObjectKey(itemName);
        localStorage.removeItem(key);
    };

    let lastServerCheckedTime = null;

    function _showCheckServerAlert(message)
    {
        const alertClasses = [
            'alert-primary',
            'alert-secondary',
            'alert-success',
            'alert-danger',
            'alert-warning',
            'alert-info',
            'alert-light',
            'alert-dark',
        ];

        const alertElement = $('#admincp_alert');        
        const wantClass = 'alert-warning';        
        const previouslyShown = !alertElement.hasClass("d-none");
        const previouslySameClass = alertElement.hasClass(wantClass);
        const previouslySameMessage = alertElement.html() === message;

        if (!previouslySameClass)
        {
            alertClasses.forEach(classname =>
            {
                if (classname !== wantClass)
                {
                    alertElement.removeClass(classname)
                }                    
            });
            alertElement.addClass(wantClass);
        }

        if (!previouslySameMessage)
        {
            alertElement.html(message);
        }

        if (!previouslyShown)
        {
            alertElement.removeClass("d-none");
        }

        if (!previouslyShown || !previouslySameClass || !previouslySameMessage)
        {
            alert(message);
        }
    }

    function _checkServer()
    {
        $.ajax({
            type: "get",
            url: "/Admin/Home/Check",
            dataType: "json",
            async: true,
            error: function (jqXHR, textStatus, errorThrown) 
            {
                if (jqXHR.status === 401 || jqXHR.status === 403)
                {
                    console.info(`Logging out. No longer authorized by server.`);
                    document.location = '/Admin/Logout';
                    return;
                }
                console.log(`${textStatus}: ${errorThrown}`);
            },
            success: function (data, _textStatus, _jqXHR)
            {
                if (data.version !== undefined && data.version !== cmsVersion)
                {
                    console.info(`Logging out. Server was upgraded to version ${data.version}.`);
                    document.location = '/Admin/Logout';
                    return;
                }

                if (data.status !== undefined && data.status !== 'ok')
                {
                    console.info(`_checkServer: ${data.status} ${data.message}`);
                    _showCheckServerAlert(data.message);                
                }
            },
            complete: function ()
            {
                const currentTime = Date.now();
                if (lastServerCheckedTime !== null)
                {
                    var elapsedTime = currentTime - lastServerCheckedTime;
                    if (elapsedTime > cmsCheckServerMaxEllapsedMilli)
                    {
                        console.info(`Logging out. Server last checked ${elapsedTime}ms ago.`);
                        document.location = '/Admin/Logout';
                        return;
                    }
                }
                lastServerCheckedTime = currentTime;
            }
        });
        setTimeout(_checkServer, 15000);
    };

    FBUtilities.startCheckServer = function ()
    {
        const pathname = document.location.pathname;
        if (pathname.toLowerCase().startsWith('/admin/'))
        {
            setTimeout(_checkServer, 10);
        }
    };
    
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBAjaxDialog
///////////////////////////////////////////////////////////////////////////////
function FBAjaxDialog()
{
    this._vars = {
        AjaxRequestObject: null,
        BackdropClass: "backdrop",
        CloseButtonClass: 'fbd_close',
        CurrentCallbacks: null,
        DataOptionsName: "fbd-dialog-options",
        DialogClass: 'fbd_dialog',
        DialogId: 'fbd_ajaxdialog',
        TitleClass: 'fbd_title'
    };

    this.options = {
        ActionType: 'GET',
        AjaxUrl: null,
        Data: null,
        ErrorContent: null,
        ErrorDialogCallbacks: null,
        ErrorDialogTitle: 'Error',
        ExtraDialogClasses: null,
        LoadingContent: null,
        LoadingDialogCallbacks: null,
        LoadingDialogTitle: 'Loading...',
        OnCloseCallback: null,
        SuccessDialogCallbacks: null,
        SuccessDialogTitle: 'Detail',
        ParentSelector: "body",
        SelectionElement: null
    };
}

(function ($)
{
    FBAjaxDialog._activeDialogs = {
    };

    FBAjaxDialog.FindAndClose = function (aDialogId)
    {
        let dialogId = aDialogId === undefined ? 'fbd_ajaxdialog' : aDialogId;
        if (FBAjaxDialog._activeDialogs[dialogId] !== undefined)
        {
            FBAjaxDialog._activeDialogs[dialogId].Close();
        }
    };

    FBAjaxDialog.prototype.Start = function (options)
    {
        let self = this;
        self.options = $.extend({}, self.options, options);

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.LoadingContent))
        {
            console.debug("The LoadingContent value was not specified.");
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AjaxUrl))
        {
            console.debug("The AjaxUrl value was not specified.");
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.ErrorContent))
        {
            console.debug("The ErrorContent value was not specified.");
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.ActionType))
        {
            console.debug("The ActionType value was not specified.");
            return;
        }

        self.options.Data = self.options.Data === undefined ? {} : self.options.Data;
        self._showLoadingContent();
        self._vars.AjaxRequestObject = $.ajax(
            self.options.AjaxUrl,
            {
                success: function (aData, _aTextStatus, _aJqXHR)
                {
                    self._showSuccessContent(aData);
                },
                error: function (_aJqXHR, _aTextStatus, _aErrorThrown)
                {
                    self._showErrorContent();
                },
                complete: function (_aData, _aTextStatus, _aJqXHR)
                {
                    self._vars.AjaxRequestObject = null;
                },
                type: self.options.ActionType,
                data: self.options.Data
            });
    };

    FBAjaxDialog.prototype.Close = function ()
    {
        let dialog = $(`#${this._vars.DialogId}`);
        if (dialog.length === 0)
        {
            return;
        }

        if (this._vars.AjaxRequestObject !== undefined && this._vars.AjaxRequestObject !== null)
        {
            this._vars.AjaxRequestObject.abort();
            this._vars.AjaxRequestObject = null;
        }

        if (dialog.is(':visible'))
        {
            dialog.hide();
            dialog.next('.backdrop').remove();
        }

        FBUtilities.RunCallback(this._vars.CurrentCallbacks, 'OnClose', dialog);

        if (this._vars.OnCloseCallback !== undefined && this._vars.OnCloseCallback !== null && typeof this._vars.OnCloseCallback === 'function')
        {
            this._vars.OnCloseCallback();
        }

        $(dialog).vpFocusManager("dropFocus");
        $(dialog).vpFocusManager("destroy");        
        dialog.remove();          
        delete FBAjaxDialog._activeDialogs[this._vars.DialogId];


    };

    FBAjaxDialog.prototype._showErrorContent = function ()
    {
        this._show(
            this.options.ErrorContent,
            {
                ExtraDialogClasses: this.options.ExtraDialogClasses,
                Title: this.options.ErrorDialogTitle,
                CloseButtonText: 'Close',
                Callbacks: this.options.ErrorDialogCallbacks,
                OnCloseCallback: this.options.OnCloseCallback
            }
        );
    };

    FBAjaxDialog.prototype._showSuccessContent = function (content)
    {
        this._show(
            content,
            {
                ExtraDialogClasses: this.options.ExtraDialogClasses,
                Title: this.options.SuccessDialogTitle,
                CloseButtonText: 'Close',
                Callbacks: this.options.SuccessDialogCallbacks,
                OnCloseCallback: this.options.OnCloseCallback
            }
        );
    };

    FBAjaxDialog.prototype._showLoadingContent = function ()
    {
        this._show(
            this.options.LoadingContent,
            {
                ExtraDialogClasses: this.options.ExtraDialogClasses,
                Title: this.options.LoadingDialogTitle,
                CloseButtonText: 'Cancel',
                Callbacks: this.options.LoadingDialogCallbacks,
                OnCloseCallback: this.options.OnCloseCallback
            }
        );
    };

    FBAjaxDialog.prototype._show = function (content, parameters)
    {

        let self = this;
        FBAjaxDialog._activeDialogs[self._vars.DialogId] = this;
        let dialog = $(`#${self._vars.DialogId}`);
        if (dialog.length === 0)
        {
            const labelId = `${self._vars.DialogId}-label`;
            const contentId = `${self._vars.DialogId}-content`;
            dialog = $(`<dialog id="${self._vars.DialogId}" role="alertdialog" class="${self._vars.DialogClass}" aria-labelledby="${labelId}" aria-describedby="${contentId}"></dialog>`);

            $(self.options.ParentSelector).prepend(dialog);

            dialog = $(`.${self._vars.DialogClass}`);
            if (typeof dialogPolyfill !== 'undefined')
            {
                dialogPolyfill.registerDialog(dialog.get(0));
            }

            dialog.on('click', `.${self._vars.CloseButtonClass}`, function (aEvent) 
            {
                aEvent.preventDefault();
                self.Close();
                return false;
            });

            //dialog.append(`<div class="fbd_header"><span class="${self._vars.TitleClass}"></span><a href="javascript:" aria-label="Close Dialog" class="${self._vars.CloseButtonClass}"><span class="fas fa-window-close"></span><span class="screen-reader-text">Close Dialog</span></a></div>`);
            dialog.append(`<div class="fbd_header"><span id="${labelId}" class="${self._vars.TitleClass}"></span><a href="javascript:" aria-label="Close Dialog" class="${self._vars.CloseButtonClass}"><img src="/img/dialog-icon-close.svg"/><span class="screen-reader-text">Close Dialog</span></a></div>`);
            dialog.append(`<div id="${contentId}" class="fbd_content fbcms_content"></div>`);
        }
        else
        {
            if (dialog.is(':visible'))
            {
                dialog.hide();
                dialog.next(`.${self._vars.BackdropClass}`).remove();
            }
            dialog.find('.fbd_content').html('');
        }

        this._vars.CurrentCallbacks = parameters.Callbacks;
        this._vars.OnCloseCallback = parameters.OnCloseCallback;
        if (!FBUtilities.IsParameterUndefinedOrEmpty(parameters.ExtraDialogClasses))
        {
            dialog.addClass(parameters.ExtraDialogClasses);
        }

        dialog.find(`.${self._vars.TitleClass}`).html(parameters.Title);
        dialog.find('.fbd_content').html(content);
        dialog.find(`.${self._vars.CloseButtonClass}`).attr('title', `${parameters.CloseButtonText} ${parameters.Title} dialog.`);

        FBUtilities.RunCallback(this._vars.CurrentCallbacks, 'OnInit', dialog);

        if (!dialog.is(':visible'))
        {
            dialog.after(`<div class="backdrop"></div>`);
            dialog.show();
        }
        
        if ($(dialog).vpFocusManager("instance") === undefined)
        {
            $(dialog).vpFocusManager(
                {
                    ExitFocusSpecificElement : self.options.SelectionElement
                    , OnEscapeCallback : function() { self.Close(); }
                }
            );
        }
        $(dialog).vpFocusManager("takeFocus");

        FBUtilities.RunCallback(self._vars.CurrentCallbacks, 'OnShow', dialog);
    };
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBModal widget
///////////////////////////////////////////////////////////////////////////////

function FBModal()
{
    this._vars = {
        // true if it's initialized
        IsDialogInit: false,
        // true if open or closing, false otherwise
        IsDialogOpen: false,
        // true if opening.
        IsDialogOpening: false,
        // true if closing.
        IsDialogClosing: false,
        DialogClass: 'fbd_dialog',
        TitleClass: 'fbd_title',
        CloseButtonClass: 'fbd_close',
        OnCloseCallback: null,
        CurrentCallbacks: null,
        ButtonCallbacks: {},
        AjaxDefaults: {
            ActionType: 'GET',
            AjaxUrl: null,
            Data: null,
            ErrorContent: null,
            ErrorDialogCallbacks: null,
            ErrorDialogTitle: 'Error',
            LoadingContent: null,
            LoadingDialogCallbacks: null,
            LoadingDialogTitle: 'Loading...',
            SuccessDialogCallbacks: null,
            SuccessDialogTitle: 'Detail'
        }
    };

    this.options = {
        DialogId: 'fbd_modaldialog',
        ParentSelector: "body",
        ExtraDialogClasses: null,
        Title: null,
        CloseButtonText: 'Close',
        AddFooterClose: false,
        Callbacks: null,
        OnCloseCallback: null,
        Buttons: null,
        Content: null,
        UseAjaxLoader: false,
        AjaxOptions: {
            ActionType: 'GET',
            AjaxUrl: null,
            Data: null,
            ErrorContent: null,
            ErrorDialogCallbacks: null,
            ErrorDialogTitle: 'Error',
            LoadingContent: null,
            LoadingDialogCallbacks: null,
            LoadingDialogTitle: 'Loading...',
            SuccessDialogCallbacks: null,
            SuccessDialogTitle: 'Detail'
        }
    };
}

(function ($)
{
    FBModal._activeDialogs = {};

    FBModal.FindAndClose = function (aDialogId)
    {
        let dialogId = aDialogId === undefined ? 'fbd_modaldialog' : aDialogId;
        if (FBModal._activeDialogs[dialogId] !== undefined)
        {
            FBModal._activeDialogs[dialogId].CloseDialog();
        }
    };

    FBModal.FindAndUpdate = function (aDialogId)
    {
        let dialogId = aDialogId === undefined ? 'fbd_modaldialog' : aDialogId;
        if (FBModal._activeDialogs[dialogId] !== undefined)
        {
            FBModal._activeDialogs[dialogId].UpdateDialog();
        }
    };

    FBModal.prototype.Start = function (options)        
    {
        let self = this;
        self.options = $.extend({}, self.options, options);
        if (this.options.UseAjaxLoader === true)
        {
            this.options.AjaxOptions = $.extend({}, this._vars.AjaxDefaults, this.options.AjaxOptions);
            this._useDialogForAjax();
        }
        else
        {
            this._startShowDialog();
        }
    };

    FBModal.prototype.CloseDialog = function ()
    {
        this._closeDialog();
    };

    FBModal.prototype.UpdateDialog = function ()
    {
        this._updateDialog();
    };

    FBModal.prototype._getDialog = function ()
    {
        return $(`#${this.options.DialogId}`);
    };

    FBModal.prototype._useDialogForAjax = function ()
    {
        let self = this;

        FBUtilities.LogMessage('_useDialogForAjax - START');
        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AjaxOptions.LoadingContent))
        {
            FBUtilities.LogMessage('_useDialogForAjax - REJECT - no loading content');
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AjaxOptions.AjaxUrl))
        {
            FBUtilities.LogMessage('_useDialogForAjax - REJECT - no ajax url');
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AjaxOptions.ErrorContent))
        {
            FBUtilities.LogMessage('_useDialogForAjax - REJECT - no error content');
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AjaxOptions.ActionType))
        {
            FBUtilities.LogMessage('_useDialogForAjax - REJECT - no action type');
            return;
        }

        self.options.AjaxOptions.Data === undefined ? {} : self.options.AjaxOptions.Data;

        self._vars.AjaxRequestObject = $.ajax(self.options.AjaxOptions.AjaxUrl,
            {
                success: function (aData, _aTextStatus, _aJqXHR)//ignore jslint
                {
                    FBUtilities.LogMessage('_useDialogForAjax - SUCCESS callback');
                    self.options.Content = aData;
                    self.options.Title = self.options.AjaxOptions.SuccessDialogTitle;
                    self.options.Callbacks = self.options.AjaxOptions.SuccessDialogCallbacks;
                    self._startShowDialog();
                },
                error: function (_aJqXHR, _aTextStatus, _aErrorThrown) //ignore jslint
                {
                    FBUtilities.LogMessage('_useDialogForAjax - ERROR callback');
                    self.options.Content = self.options.AjaxOptions.ErrorContent;
                    self.options.Title = self.options.AjaxOptions.ErrorDialogTitle;
                    self.options.Callbacks = self.options.AjaxOptions.ErrorDialogCallbacks;
                    self._startShowDialog();
                },
                complete: function (_aData, _aTextStatus, _aJqXHR)//ignore jslint
                {
                    FBUtilities.LogMessage('_useDialogForAjax - COMPLETE callback');
                    self._vars.AjaxRequestObject = null;
                },
                type: self.options.AjaxOptions.ActionType,
                data: self.options.AjaxOptions.Data
            });
        FBUtilities.LogMessage('_useDialogForAjax- COMPLETE');
    };

    FBModal.prototype._startShowDialog = function ()
    {
        let self = this;
        FBUtilities.LogMessage('ShowDialog - START');
        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.Content))
        {
            FBUtilities.LogMessage('ShowDialog - REJECT - no content');
            return;
        }

        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.Title))
        {
            //needs a title, don't null or undefine this thing.
            FBUtilities.LogMessage('ShowDialog - REJECT - no title');
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.CloseButtonText))
        {
            //needs a text, don't null or undefine this thing.
            FBUtilities.LogMessage('ShowDialog - REJECT - no close button text');
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AddFooterClose))
        {
            //needs a value, don't null or undefine this thing.
            FBUtilities.LogMessage('ShowDialog - REJECT - bad footer close value');
            return;
        }

        self._initDialog();
    };

    FBModal.prototype._initDialog = function ()
    {
        let self = this;
        // we're here for business, let's see what's going on.
        FBUtilities.LogMessage('_initDialog - START');

        // something is initialized... let's get it out of the way.
        if (self._vars.IsDialogInit === true)
        {
            FBUtilities.LogMessage('_initDialog - There\'s an existing dialog.');

            // it's opening or open (this includes closing)...
            if (self._vars.IsDialogOpening === true || self._vars.IsDialogOpen === true)
            {
                let dialog = self._getDialog();
                // add a callback to get this show on the road once the old one is removed.
                dialog.on('hidden.bs.modal', function (e)
                {
                    FBUtilities.LogMessage('_initDialog Callback for initialization');
                    self._setupDialogHtml();
                });

                // if it's not already closing, start that now.
                if (self._vars.IsDialogClosing === false)
                {
                    FBUtilities.LogMessage('_initDialog - Request it cease to be. (Callback will initialize)');
                    self._closeDialog();
                }
                return;
            }

            FBUtilities.LogMessage('_initDialog - It\'s only initalized, destroy it.');
            self._destroyDialog();
        }
        FBUtilities.LogMessage('_initDialog - Init the dialog markup and events.');

        // hey, nothing in the way, just set things to work.
        self._setupDialogHtml();
    };

    FBModal.prototype._setupDialogHtml = function ()
    {
        let self = this;

        FBUtilities.LogMessage('_setupDialogHtml - START.');


        let dialog = $(`<div id="${self.options.DialogId}" class="modal fade ${this._vars.DialogClass}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true"></div>`);

        $(self.options.ParentSelector).prepend(dialog);

        dialog = self._getDialog();

        let footerMarkup = '';
        let buttonMarkup = '';
        if (!FBUtilities.IsParameterUndefinedOrEmpty(self.options.Buttons))
        {
            let hasValidButtons = false;
            for (var index in self.options.Buttons)
            {
                let buttonDeets = self.options.Buttons[index];
                if (FBUtilities.IsParameterUndefinedOrEmpty(buttonDeets['text']) || FBUtilities.IsParameterUndefinedOrEmpty(buttonDeets['click']))
                {
                    continue;
                }

                let btnClasses = 'vp-btn-secondary';
                if (!FBUtilities.IsParameterUndefinedOrEmpty(buttonDeets['class']))
                {
                    btnClasses = buttonDeets['class'];
                }

                let id = `bbdm_btn_${index}`;
                if (!FBUtilities.IsParameterUndefinedOrEmpty(buttonDeets['id']))
                {
                    id = buttonDeets.id;
                }

                buttonMarkup += `        <button id="${id}" type="button" class="vp-btn ${btnClasses} bbdm_btn">${buttonDeets['text']}</button>`;

                self._vars.ButtonCallbacks[id] = buttonDeets['click'];           
                hasValidButtons = true;
            }//endfor

            if (hasValidButtons === true)
            {
                dialog.on('click', '.bbdm_btn', function (e)
                {
                    let button = $(e.target).closest('.bbdm_btn');
                    let buttonId = button.attr('id');
                    self._vars.ButtonCallbacks[buttonId](e);
                });
            }
        }

        if (self.options.AddClose === true)
        {
            buttonMarkup += `        <button type="button" class="vp-btn vp-btn-secondary" data-dismiss="modal">${self.options.CloseButtonText}</button>`;
        }

        if (buttonMarkup.length > 0)
        {
            footerMarkup = `      <div class="modal-footer">${buttonMarkup}</div>`;
        }

        let dialogBody = `<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title ${self._vars.TitleClass}">Dialog Title</h5>
            <button type="button" class="close ${self._vars.CloseButtonClass}" data-dismiss="modal" aria-label="Close">
                <img src="/img/dialog-icon-close.svg" class="fbd_close-icon"/>
            </button>
        </div>
        <div class="modal-body fbd_content">
            <div class="container-fluid">
            </div>
        </div>
        ${footerMarkup}
    </div>
</div>`;
        dialog.append(dialogBody);

        /* bootstrap events */
        dialog.off('shown.bs.modal').on('shown.bs.modal', function (e)
        {
            FBUtilities.RunCallback(self._vars.CurrentCallbacks, 'OnShow', dialog);
            self._vars.IsDialogOpening = false;
            self._vars.IsDialogOpen = true;
            FBUtilities.LogMessage('FBModal - dialog shown.');
        });

        dialog.off('hidden.bs.modal').on('hidden.bs.modal', function (e)
        {
            FBUtilities.RunCallback(self._vars.CurrentCallbacks, 'OnClose', dialog);

            if (self._vars.OnCloseCallback !== undefined
                && self._vars.OnCloseCallback !== null
                && typeof self._vars.OnCloseCallback === 'function')
            {
                self._vars.OnCloseCallback();
            }
            self._vars.IsDialogOpen = false;
            self._vars.IsDialogClosing = false;
            self._destroyDialog();

            FBUtilities.LogMessage('FBModal - dialog hidden.');
        });
        /* bootstrap events */

        self._vars.IsDialogInit = true;

        // just to be thorough. Nothing from before should still exist.
        self._vars.CurrentCallbacks = self.options.Callbacks;
        self._vars.OnCloseCallback = self.options.OnCloseCallback;

        if (!FBUtilities.IsParameterUndefinedOrEmpty(self.options.ExtraDialogClasses))
        {
            dialog.addClass(self.options.ExtraDialogClasses);
        }

        dialog.find(`.${self._vars.TitleClass}`).html(self.options.Title);
        dialog.find('.fbd_content').html(self.options.Content);
        dialog.find(`.${self._vars.CloseButtonClass}`).attr('title', `${self.options.CloseButtonText} ${self.options.Title} dialog.`);

        FBUtilities.RunCallback(self._vars.CurrentCallbacks, 'OnInit', dialog);
        self._showDialog();
        
        FBModal._activeDialogs[self.options.DialogId] = self;

        FBUtilities.LogMessage('initDialogWorker - COMPLETE.');
        return dialog;
    };

    FBModal.prototype._showDialog = function ()
    {
        let self = this;
        FBUtilities.LogMessage('_showDialog - START');
        if (self._vars.IsDialogInit === false)
        {
            FBUtilities.LogMessage('_showDialog - REJECT');
            return;
        }

        let dialog = $(`.${self._vars.DialogClass}`);
        //dialog.after(`<div class="backdrop"></div>`);
        dialog.on('shown.bs.modal', function ()
        {
            FBUtilities.RunCallback(self._vars.CurrentCallbacks, 'OnShown', dialog);       
        });
        dialog.modal('show');

        self._vars.IsDialogOpening = true;
        dialog.find('.modal-header button').focus();
        FBUtilities.LogMessage('_showDialog - COMPLETE (Requested)');
    };

    FBModal.prototype._closeDialog = function ()
    {
        FBUtilities.LogMessage('_closeDialog - START');
        if (this._vars.IsDialogInit === false)
        {
            FBUtilities.LogMessage('_closeDialog - REJECT');
            return;
        }

        if (this._vars.IsDialogOpen === true || this._vars.IsDialogOpening === true)
        {
            let dialog = this._getDialog();
            dialog.modal('hide');
            this._vars.IsDialogClosing = true;
        }
        FBUtilities.LogMessage('_closeDialog - COMPLETE (Requested)');
    };

    FBModal.prototype._destroyDialog = function ()
    {
        FBUtilities.LogMessage('_destroyDialog - START');
        if (this._vars.IsDialogInit === false)
        {
            FBUtilities.LogMessage('_destroyDialog - REJECT');
            return;
        }

        let dialog = this._getDialog();
        dialog.off('shown.bs.modal');
        dialog.off('hidden.bs.modal');
        dialog.off('click', '.bbdm_btn');
        this._vars.OnCloseCallback = null;
        this._vars.CurrentCallbacks = null;
        this._vars.ButtonCallbacks = {};
        dialog.next('.backdrop').remove();
        dialog.remove();
        this._vars.IsDialogInit = false;

        delete FBModal._activeDialogs[this.options.DialogId];
        FBUtilities.LogMessage('_destroyDialog - COMPLETE');
    };

    FBModal.prototype._updateDialog = function ()
    {
        FBUtilities.LogMessage('_updateDialog - START');
        if (this._vars.IsDialogInit === false)
        {
            FBUtilities.LogMessage('_updateDialog - REJECT');
            return;
        }

        if (this._vars.IsDialogOpen === true && this._vars.IsDialogClosing === false)
        {
            this._getDialog().modal('handleUpdate');
        }

        FBUtilities.LogMessage('_updateDialog - COMPLETE');
    };
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBMenuManager - Menu Manager
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    // Callbacks are OnSuccess, OnError, OnComplete
    FBMenuManager.LoadMenu = function (aParameters)
    {
        var lDefaults, lOptions, lData;

        lDefaults =
        {
            AjaxUrl: '/Core/Menu/'
            , Tagname: null
            , CurrentUrl: null
            , TemplatePrefix: null
            , Preview: false
            , Callbacks: null
        };

        lOptions = $.extend(lDefaults, aParameters);

        if (FBUtilities.IsParameterUndefinedOrEmpty(lOptions.AjaxUrl))
        {
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(lOptions.Tagname))
        {
            return;
        }

        lData =
        {
            tagname: lOptions.Tagname
        };

        if (!FBUtilities.IsParameterUndefinedOrEmpty(lOptions.CurrentUrl))
        {
            lData.currenturl = lOptions.CurrentUrl;
        }
        if (!FBUtilities.IsParameterUndefinedOrEmpty(lOptions.TemplatePrefix))
        {
            lData.templateprefix = lOptions.TemplatePrefix;
        }
        if (!FBUtilities.IsParameterUndefinedOrEmpty(lOptions.Preview)
            && lOptions.Preview === true)
        {
            lData.preview = true;
        }

        FBMenuManager.AjaxRequestObject = $.ajax(lOptions.AjaxUrl,
            {
                data: lData,
                success: function (aData, aTextStatus, aJqXHR)
                {
                    FBUtilities.LogMessage('Load Menu - Success');
                    FBUtilities.RunCallback(lOptions.Callbacks, 'OnSuccess', aData, aTextStatus, aJqXHR);
                },
                error: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    FBUtilities.LogMessage('Load Menu - Error');
                    FBUtilities.RunCallback(lOptions.Callbacks, 'OnError', aJqXHR, aTextStatus, aErrorThrown);
                },
                complete: function (aJqXHR, aTextStatus)
                {
                    FBUtilities.LogMessage('Load Menu - Complete');
                    FBUtilities.RunCallback(lOptions.Callbacks, 'OnComplete', aJqXHR, aTextStatus);
                },
                type: 'GET'
            });
    };//end LoadMenu

}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBDateSelector
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    $.widget("ui.FBDateSelector",
        {
            options:
            {
                ClearInputButtonClass: 'clear_input'
                , ClearInputButtonContent: '<span class="fas fa-times-circle"></span>'
                , ClearInputButtonLabel: 'Clear Input'
                , OnChangeCallback: null
                , DateFormat: null
            },

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lPickerArgs = {},
                    lParentElement,
                    lClearInputButton;

                if (self.options.ClearInputButtonClass === null
                    || self.options.ClearInputButtonContent === null)
                {
                    return;
                }


                lPickerArgs.gotoCurrent = true;
                if (self.options.DateFormat !== null)
                {
                    if (self.options.DateFormat === 'ISO_8601')
                    {
                        lPickerArgs.dateFormat = $.datepicker.ISO_8601;
                    }
                }

                if (jElement.prop('type') !== 'date') 
                {
                    jElement.datepicker(lPickerArgs);
                }

                if (!FBUtilities.IsParameterUndefinedOrEmpty(self.options.OnChangeCallback))
                {
                    jElement.change(function (aEvent)
                    {
                        self.options.OnChangeCallback(aEvent);
                    });
                }

                lParentElement = jElement.parent();
                lParentElement.append('<span class="' + self.options.ClearInputButtonClass + '">' + self.options.ClearInputButtonContent + '</span>');
                lClearInputButton = lParentElement.find('.' + self.options.ClearInputButtonClass);
                lClearInputButton.attr('role', 'button');
                lClearInputButton.attr('tabindex', '0');
                lClearInputButton.attr('aria-controls', jElement.attr('id'));
                if (!FBUtilities.IsParameterUndefinedOrEmpty(self.options.ClearInputButtonLabel))
                {
                    lClearInputButton.attr('aria-label', self.options.ClearInputButtonLabel);
                }
                lClearInputButton.click(
                    function (aEvent) 
                    {
                        aEvent.preventDefault();
                        jElement.val('');
                        return false;
                    }
                );
            }
        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// Expandable Content Sections
///////////////////////////////////////////////////////////////////////////////

function FBExpando()
{
    return undefined;
}

$(function () 
{

    function _ExpandingContent_OpenWorker(container)
    {
        if (container.hasClass('fbcms_ec_collapsed'))
        {
            container.removeClass("fbcms_ec_collapsed");
            $(container).find('.fbcms_ec_title').attr("aria-expanded", true);
            $(container).find('.fbcms_ec_titleicon').attr("aria-pressed", true);
            let masons = container.find('.fbcms_ec_title ~ *.masonry, .fbcms_ec_title ~ .fbcms_pgc_gallery > .masonry');
            if (masons.length !== 0)
            {
                masons.masonry("layout");
            }
        }
    }

    function _ExpandingContent_CloseWorker(container)
    {
        if (!container.hasClass('fbcms_ec_collapsed'))
        {
            container.addClass("fbcms_ec_collapsed");
            $(container).find('.fbcms_ec_title').attr("aria-expanded", false);
            $(container).find('.fbcms_ec_titleicon').attr("aria-pressed", false);
        }
    }

    function _ExpandingContent_ToggleWorker(container)
    {
        if (!container.hasClass('fbcms_ec_collapsed'))
        {
            _ExpandingContent_CloseWorker(container);
        }
        else
        {
            _ExpandingContent_OpenWorker(container);
        }
    }

    function toggleExpandingContent(event)
    {
        let parent = $(event.target).parents('.fbcms_ec');
        _ExpandingContent_ToggleWorker(parent);
    }

    FBExpando.toggleExpandingContent = toggleExpandingContent

    function _determineExpandableContainerToOpen()
    {
        let hash = $(location).attr('hash');
        let result = undefined;
        if (hash && hash !== '' && hash !== '#')
        {
            let name = hash.substring(1);
            let targetedBlock = null;
            try
            {
                targetedBlock = $(`.fbcms_content#${name}`);
            }
            catch (ignore)
            {
            }

            if (targetedBlock !== null)
            {
                if (targetedBlock.hasClass('fbcms_ec'))
                {
                    result = targetedBlock;
                }
            }
        }
        return result;
    }

    $(document).on('click', '.fbcms_ec .fbcms_ec_title', function (event)
    {
        event.preventDefault();
        toggleExpandingContent(event);
        return false;
    });

    function _handleHome(event)
    {
        let startId = $(event.target).parent('.fbcms_ec').siblings('.fbcms_ec').first().attr('aria-labelledby');
        if (startId !== undefined)
        {
            setTimeout(function ()
            {
                $(`#${startId}`).get(0).focus();
            }, 100);
        }
    }

    function _handleEnd(event)
    {
        let endId = $(event.target).parent('.fbcms_ec').siblings('.fbcms_ec').last().attr('aria-labelledby');
        if (endId !== undefined)
        {
            setTimeout(function ()
            {
                $(`#${endId}`).get(0).focus();
            }, 100);
        }
    }

    function _handlePrevious(event)
    {
        let previousId = $(event.target).parent('.fbcms_ec').prev('.fbcms_ec').attr('aria-labelledby');
        if (previousId === undefined)
        {
            _handleEnd(event);
        }
        else
        {
            setTimeout(function ()
            {
                $(`#${previousId}`).get(0).focus();
            }, 100);
        }
    }

    function _handleNext(event)
    {
        let nextId = $(event.target).parent('.fbcms_ec').next('.fbcms_ec').attr('aria-labelledby');

        if (nextId === undefined)
        {
            _handleHome(event);
        }
        else
        {
            setTimeout(function ()
            {
                $(`#${nextId}`).get(0).focus();
            }, 100);
        }
    }

    $(document).on('keydown', '.fbcms_ec .fbcms_ec_title', function (event)
    {
        if (event.altKey || event.shiftKey || event.ctrlKey)
        {
            return;
        }
        else if (event.keyCode === 13 || event.keyCode === 32)
        {
            toggleExpandingContent(event);
        }
        else if (event.keyCode === 36)
        {
            _handleHome(event);
        }
        else if (event.keyCode === 38)
        {
            _handlePrevious(event);
        }
        else if (event.keyCode === 40)
        {
            _handleNext(event);
        }
        else if (event.keyCode === 35)
        {
            _handleEnd(event);
        }
        else
        {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        return false;
    });

    //webkit hash change fix.
    //https://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
    window.addEventListener(
        "hashchange",
        function (/*event*/) 
        {
            let element = document.getElementById(location.hash.substring(1));
            if (element) 
            {
                if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName))
                {
                    element.tabIndex = -1;
                }

                element.focus();
            }

            let jMyExpandable = _determineExpandableContainerToOpen();
            if (jMyExpandable !== undefined)
            {
                _ExpandingContent_OpenWorker(jMyExpandable);
            }

            let jFixedHeader = $('body .navbar-fixed-top');
            if (jFixedHeader.length !== 0)
            {
                setTimeout(function ()
                {
                    window.scrollTo(window.scrollX, window.scrollY - jFixedHeader.height());
                }, 1);
            }
        },
        false
    );

    // INITIALIZE EXPANDABLE CONTENT //

    let jExpandable = _determineExpandableContainerToOpen();
    let jExpandableContentAreas = $('.fbcms_ec').not(jExpandable);

    if (jExpandableContentAreas.length !== 0)
    {
        $.each(
            jExpandableContentAreas,
            function (_index, item)
            {
                if (!$(item).hasClass('fbcms_ec_collapsed'))
                {
                    if (jExpandable !== undefined)
                    {
                        $('html,body').scrollTop(jExpandable.offset().top);
                        jExpandable.removeClass("fbcms_ec_collapsed");
                    }
                }
            }
        );
    }

    $('.fbcms_ec .fbcms_ec_title').next().attr('tabindex', 0);

    if (jExpandable !== undefined)
    {
        if (jExpandable.hasClass('fbcms_ec_collapsed'))
        {
            jExpandable.removeClass("fbcms_ec_collapsed");
        }
        $('html,body').scrollTop(jExpandable.offset().top);
    }
});

///////////////////////////////////////////////////////////////////////////////
// VP-Accordion
///////////////////////////////////////////////////////////////////////////////

function VPAccordion()
{
    return undefined;
}

$(function () 
{
    function _handleToggleEvent(event)
    {
        let $item = $(event.target).closest('.vp-accordion-item');
        let $toggler = $item.children(".vp-accordion-header").children(".vp-accordion-toggler");
        let $siblings = $item.siblings('.vp-accordion-item').not(`.vp-accordion-expanded-always`);

        let wasExpanded = $item.hasClass('vp-accordion-expanded');

        $siblings.removeClass('vp-accordion-expanded');
        $siblings.children(".vp-accordion-header").children(".vp-accordion-toggler").prop("ariaExpanded", false);

        if (wasExpanded)
        {
            $item.removeClass('vp-accordion-expanded');
            $toggler.prop("ariaExpanded", false);
        }
        else
        {
            $item.addClass('vp-accordion-expanded');
            $toggler.prop("ariaExpanded", true);
        }
    }

    function _initialize(selector)
    {
        $(selector).filter('.vp-accordion').each(function ()
        {
            $(this)
                .children('.vp-accordion-item')
                .not(`.vp-accordion-expanded-always`)
                .children('.vp-accordion-header')
                .children('.vp-accordion-toggler')
                .on('click', _handleToggleEvent);
        });
    }

    VPAccordion.initialize = _initialize;

    _initialize(".vp-accordion");

});
///////////////////////////////////////////////////////////////////////////////
// FBRSearchBox - Foxbright Responsive Search Box
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*
        FBRSearchBox - Foxbright Responsive Search Box
        
        Modifies the search form to use the submit button as an "opener" when the viewport 
        width is below a given threshold.  An HTML class will placed on the form when opened, 
        styling transitions can be used to animate a change.  Once the form is open, the 
        submit button will function as a normal submit button.  At or above the viewport 
        width threshold, the button will act normally.
        
        Options:
        
        OpenerAsSubmitterOnDesktop  default: true
                The opener button should behave as a normal submit button at or above 
                the DesktopWidthMinimum.  If true, DesktopWidthMinimum must be set.
        DesktopWidthMinimum         default: 768
                Size, in pixels, that normal behavior will be resumed.  Required if 
                OpenerAsSubmitterOnDesktop is set to true.
        FormActivatedClass          default: 'opened'
                Required. Class to add to the form to indicate/activate the open state.
        SubmitButtonClass           default: 'submit'
                Required. Class to be used to select the submit button(s) *inside* the form element.
        InputFieldClass             default: 'search-input'
                Required. Class to be used to select the search-input(s) *inside* the form element.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ActivateSearch
                Called to open the form for searching.
        DeactivateSearch
                Called to close the form.
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        form element directly.
        
        $('.search-form').FBRSearchBox();
        
        $('.search-form').FBRSearchBox({ FormActivatedClass : 'my_open_class' });
    */
    $.widget("ui.FBRSearchBox",
        {
            options:
            {
                OpenerAsSubmitterOnDesktop: true
                , DesktopWidthMinimum: 768
                , FormActivatedClass: 'opened'
                , SubmitButtonClass: 'submit'
                , InputFieldClass: 'search-input'
            },

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                //check options.
                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.FormActivatedClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SubmitButtonClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.InputFieldClass))
                {
                    FBUtilities.LogMessage('FBRSearchBox - required settings null or empty.');
                    return;
                }

                if (self.options.OpenerAsSubmitterOnDesktop === true
                    && (FBUtilities.GetIntOrNull(self.options.DesktopWidthMinimum) === null
                        || FBUtilities.GetIntOrNull(self.options.DesktopWidthMinimum) <= 0))
                {
                    FBUtilities.LogMessage('FBRSearchBox - desktop threshold not set as requested.');
                    return;
                }

                //set events
                jElement.find(`.${self.options.SubmitButtonClass}`)
                    .on('click', function (aEvent) 
                    {
                        aEvent.preventDefault();
                        self._ClickOpener();
                        return false;
                    });

                jElement.find(`.${self.options.InputFieldClass}`)
                    .on('keypress', function (aEvent) 
                    {
                        if (aEvent.which === 13)
                        {
                            jElement.submit();
                            return false;
                        }
                    })
                    .on('keydown', function (aEvent) 
                    {
                        if (aEvent.which === 27)
                        {
                            self.DeactivateSearch();
                            jElement.find(`.${self.options.InputFieldClass}`).val('')
                            jElement.find(`.${self.options.SubmitButtonClass}`).focus();
                            return false;
                        }
                    });

                jElement.on('focusout', function (aEvent)
                {
                    setTimeout(function ()
                    {
                        if ($(self.element).has($(document.activeElement)).length == 0)
                        {
                            self.DeactivateSearch();
                            $(self.element).find(`.${self.options.InputFieldClass}`).val('')
                        }
                    }, 0);

                });

                $(window).on('resize', function (aEvent)
                {
                    self._OnResize();
                });
                self._OnResize();
            },

            _OnResize: function ()
            {
                var self = this;
                var jElement = $(self.element);

                var lViewportWidth = FBUtilities.GetIntOrNull($("body").innerWidth());

                if (lViewportWidth < self.options.DesktopWidthMinimum)
                {
                    jElement.find(`.${self.options.InputFieldClass}`).attr('tabindex', "-1");
                }
                else
                {
                    jElement.find(`.${self.options.InputFieldClass}`).removeAttr('tabindex');
                }
            },

            _ClickOpener: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lViewportWidth = FBUtilities.GetIntOrNull($("body").innerWidth());

                if (lViewportWidth >= self.options.DesktopWidthMinimum)
                {
                    jElement.submit();
                }
                else if (false === jElement.is(`.${self.options.FormActivatedClass}`))
                {
                    self.ActivateSearch();
                }
                else if (false === FBUtilities.IsStringEmptyOrWhitespace(jElement.find(`.${self.options.InputFieldClass}`).val()))
                {
                    jElement.submit();
                }
                else
                {
                    self.DeactivateSearch();
                }
            },

            ActivateSearch: function ()
            {
                let jElement = $(this.element);
                jElement.addClass(this.options.FormActivatedClass);
                jElement.find(`.${this.options.InputFieldClass}`).focus();
            },

            DeactivateSearch: function ()
            {
                $(this.element).removeClass(this.options.FormActivatedClass);
            }
        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBRSlideOut - Foxbright Responsive Menu Slideout
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*
        FBRSlideOut - Foxbright Responsive Menu Slideout
        
        Javascript controller for a responsive menu slideout.
        Options can create buttons for activation and place content in them.
    	
        The slider element is checked for display mode attributes.  If either 
        is not found, is found to be blank, or is found not to be "none" or 
        one of the key values present in DisplayModeClasses, the Compatibility 
        mode is activated.  All options listed below with a compatibility 
        value will be overwritten with that value in compatibility mode.
        All classes are present in compatibility mode unless otherwise noted.
        
        Options:
        
        SliderClass                         default: 'nav-slider'; compatibility: 'nav_slider'
                Required.  The class that should be added to the selected 
                element for CSS styling and transistions.
            	
        SlideoutClass                       default: 'fbcms_rslideout'
                Required.  The class that will be added upon initialization.
                Change at your peril.
                
        LinerClass                          default: 'slide-liner'; compatibility: 'slide_liner'
                Required.  The class to be put on the element that will wrap all content 
                inside the containing element.
            	
        SliderOpenClass                     default: 'slide-open'; compatibility: 'slideropen'
                Required.  The class to indicate the slider is open.
            	
        SliderOpenContainerSelector         default: 'body'
                A selector to use to place a class on indicating the slider 
                details.
            	
        SliderContainerActiveClass			default: 'nav-slider-active'
                A class to add to the container to indicate that there is a 
                working slider in place.
                Not present in compatibility mode.
            	
        SliderContainerInactiveClass		default: 'nav-slider-deactivated'
                A class to add to the container to indicate that the slider is 
                non-working.
                Not present in compatibility mode.
            	
        SliderOpenContainerClass            default: 'nav-slider-open'; compatibility: 'navslideropen'
                A class to place on the element(s) found by 
                SliderOpenContainerSelector.
            	
        AddSliderButton                     default: true
                True to add a slider button for opening the slider.  If set to 
                true, SliderButtonClass must be set.
            	
        SliderButtonClass                   default: 'nav-slider-button'; compatibility: 'slider-opener'
                Required if AddSliderButton is set to true.  The class to be 
                added to the slider opener/closer button(s) created.
            	
        SliderButtonActivatedClass          default: 'activated'
                A class to be added to the slider opener/closer button(s) when 
                activated (the slider open).
            	
        SliderButtonContent                 default: '<span></span><span class="screen-reader-text">Website Menu</span>'
                Content to be displayed in the slider opener/closer button(s).
            	
        SliderButtonExtraClasses            default: 'slider-button'; compatibility: 'changerbutton'
                Extra classes to be added to the slider opener/closer 
                button(s).
            	
        AdditionalButtonContainerSelector   default: null
                An additional container selector to add a slider opener/closer 
                button(s) to.
            	
        AdditionalSliderButtonClass         default: 'slider-button-secondary'; compatibility: 'secondary-opener'
                An additional class to add to additional slider opener/closer 
                button(s).
            	
        AdditionalSliderButtonContent       default: '<span></span><span class="screen-reader-text">Website Menu</span>'
                Content to be displayed in the additional slider opener/closer 
                button(s).
            	
        AdditionalSliderButtonExtraClasses  default: 'slider-button'; compatibility: 'changerbutton'
                Extra classes to be added to the additional slider 
                opener/closer button(s).
            	
        DisplayModeThreshold				default: 768
                Threshold at which to switch between display modes.
            	
        DisplayModeClasses					default: { 'slideout': 'navslideout', 'overlay': 'navoverlay' }
                List of display modes with classes to indicate their use.
                Not present in compatibility mode.
            	
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleSlider
                Called to toggle the slider open or closed.
        OpenSlider
                Called to open the slider (or do nothing if the slider is already open).
        CloseSlider
                Called to close the slider (or do nothing if the slider is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.header_navigation').FBRSlideOut();
        
        $('.header_navigation').FBRSlideOut(
            {
                AdditionalButtonContainerSelector : '#header'
            }
        );
    */
    $.widget("ui.FBRSlideOut",
        {
            options:
            {
                SliderClass: 'nav-slider' //'nav_slider'
                , SlideoutClass: 'fbcms_rslideout' 
                , LinerClass: 'slide-liner' //'slide_liner'
                , SliderOpenClass: 'slide-open' //'slideropen'
                , SliderOpenContainerSelector: 'body'
                , SliderContainerActiveClass: 'nav-slider-active'
                , SliderContainerInactiveClass: 'nav-slider-deactivated'
                , SliderOpenContainerClass: 'nav-slider-open' //'navslideropen'
                , AddSliderButton: true
                , SliderButtonClass: 'nav-slider-button' //'slider-opener'
                , SliderButtonActivatedClass: 'activated'
                , SliderButtonContent: '<span></span><span class="screen-reader-text">Close Website Menu</span>'
                , SliderButtonExtraClasses: 'slider-button' //'changerbutton'
                , AddAdditionalButton: true
                , AdditionalButtonContainerSelector: null
                , AdditionalSliderButtonClass: 'slider-button-secondary' //'secondary-opener'
                , AdditionalSliderButtonId: 'navigation-slider-opener-button'
                , AdditionalSliderButtonContent: '<span></span><span class="screen-reader-text">Open Website Menu</span>'
                , AdditionalSliderButtonExtraClasses: 'slider-button' //'changerbutton'
                , DisplayModeThreshold: 768
                , DisplayModeClasses: { 'slider': 'navslideout', 'overlay': 'navoverlay' }
                , SkipToNavigationLinkId: 'skip-to-navigation'
            },

            _prevFocusItem: null,
            _myExternalOpenerButtonItem: null,

            _prevTabbableItem: null,
            _myFirstTabbableItem: null,
            _myLastTabbableItem: null,
            _nextTabbableItem: null,
            _lastBelowTheThreshold: false,
            _DesktopDisplayClass: null,
            _DesktopUseTabbingLoop: null,
            _MobileDisplayClass: false,
            _MobileUseTabbingLoop: false,

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if ($('body.page_bodyonly').length === 1)
                {
                    jElement.remove();
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SlideoutClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenClass))
                {
                    FBUtilities.LogMessage('FBRSlideOut - required settings null or empty.');
                    return;
                }

                if (self.options.AddSliderButton === true
                    && FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderButtonClass))
                {
                    FBUtilities.LogMessage('FBRSlideOut - slider button setting not set as requested.');
                    return;
                }

                var lMobileDisplayMode = jElement.data('slider-mobiledisplaymode');
                var lDesktopDisplayMode = jElement.data('slider-desktopdisplaymode');
                if (FBUtilities.IsParameterUndefinedOrEmpty(lDesktopDisplayMode) === false
                    && FBUtilities.IsParameterUndefinedOrEmpty(self.options.DisplayModeClasses[lDesktopDisplayMode]) === false)
                {
                    self._DesktopDisplayClass = self.options.DisplayModeClasses[lDesktopDisplayMode];
                    self._DesktopUseTabbingLoop = true;
                }
                else if (lDesktopDisplayMode === "none")
                {
                    self._DesktopDisplayClass = 'none';
                }
                if (FBUtilities.IsParameterUndefinedOrEmpty(lMobileDisplayMode) === false
                    && FBUtilities.IsParameterUndefinedOrEmpty(self.options.DisplayModeClasses[lMobileDisplayMode]) === false)
                {
                    self._MobileDisplayClass = self.options.DisplayModeClasses[lMobileDisplayMode];
                    self._MobileUseTabbingLoop = true;
                }
                else if (lMobileDisplayMode === "none")
                {
                    self._MobileDisplayClass = 'none';
                }

                if (FBUtilities.IsParameterUndefinedOrNull(self._DesktopDisplayClass)
                    || FBUtilities.IsParameterUndefinedOrNull(self._MobileDisplayClass))
                {
                    // trigger compatibility mode...
                    self.options.SliderClass = 'nav_slider';
                    self.options.LinerClass = 'slide_liner';
                    self.options.SliderOpenClass = 'slideropen';
                    self.options.SliderOpenContainerClass = 'navslideropen';
                    self.options.SliderButtonClass = 'slider-opener';
                    self.options.SliderButtonExtraClasses = 'changerbutton';
                    self.options.AdditionalSliderButtonClass = 'secondary-opener';
                    self.options.AdditionalSliderButtonExtraClasses = 'changerbutton';
                }

                //window.console.log('FBRSlideOut - DesktopMode: "' + self._DesktopDisplayClass + '"; MobileMode: "' + self._MobileDisplayClass + '"');

                if (self.options.AddSliderButton === true)
                {
                    jElement.prepend('<a class="' + self.options.SliderButtonClass + '" href="#"></a>');

                    let lMenuButton = jElement.children('.' + self.options.SliderButtonClass);
                    if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderButtonExtraClasses) === false)
                    {
                        lMenuButton.addClass(self.options.SliderButtonExtraClasses);
                    }
                    if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderButtonContent) === false)
                    {
                        lMenuButton.html(self.options.SliderButtonContent);
                    }

                    if (self.options.AddAdditionalButton === true)
                    {
                        let container = $(self.options.AdditionalButtonContainerSelector);
                        let haveContainer = (container.length > 0);
                        let html = `<a id="${self.options.AdditionalSliderButtonId}" class="${self.options.SliderButtonClass}" tabindex="0" href="javascript:"></a>`;
                        let button;
                        if (haveContainer)
                        {
                            let firstChild = container.children().first();
                            if (firstChild.length !== 0 && firstChild.attr('id') === "accessibility")
                            {
                                firstChild.after(html);
                            }
                            else
                            {
                                container.prepend(html);
                            }
                            button = container.children(`.${self.options.SliderButtonClass}`);
                        }
                        else
                        {
                            button = $(html);
                        }

                        if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalSliderButtonClass))
                        {
                            button.addClass(self.options.AdditionalSliderButtonClass);
                        }

                        if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalSliderButtonExtraClasses))
                        {
                            button.addClass(self.options.AdditionalSliderButtonExtraClasses);
                        }

                        if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalSliderButtonContent))
                        {
                            button.html(self.options.AdditionalSliderButtonContent);
                        }

                        if (!haveContainer)
                        {
                            jElement.before(button);
                        }
                    }
                }

                if (self.options.AddSliderButton === true)
                {
                    jElement.find(`.${self.options.SliderButtonClass}`).on(
                        'click',
                        function (_event) 
                        {
                            self.CloseSlider();
                            return false;
                        }
                    );

                    if (self.options.AddAdditionalButton === true)
                    {
                        self._myExternalOpenerButtonItem = $(`.${self.options.AdditionalSliderButtonClass}`);

                        $(`.${self.options.AdditionalSliderButtonClass}`).on(
                            'click',
                            function (_event) 
                            {
                                self.ToggleSlider($(this).closest(`.${self.options.AdditionalSliderButtonClass}`));
                                return false;
                            }
                        );
                    }
                }

                jElement.on("keydown", function (e)
                {
                    var lViewportWidth = FBUtilities.GetIntOrNull($("body").innerWidth());
                    if ($(self.options.SliderOpenContainerSelector).hasClass(self.options.SliderContainerInactiveClass))
                    {
                        return true;
                    }

                    if (e.key === "Escape") // Escape
                    {

                        if (jElement.hasClass(self.options.SliderOpenClass))
                        {
                            e.preventDefault();
                            e.stopPropagation();
                            self.CloseSlider();
                            return false;
                        }
                    }

                    return true;
                });

                // skip this if we're in compatibility mode.
                if (FBUtilities.IsParameterUndefinedOrNull(self._DesktopDisplayClass) === false
                    && FBUtilities.IsParameterUndefinedOrNull(self._MobileDisplayClass) === false)
                {
                    if (self._DesktopDisplayClass !== self._MobileDisplayClass)
                    {
                        $(window).resize(function ()
                        {
                            self._updateOnPageResizeOrLoad();
                        });
                    }
                    self._updateOnPageResizeOrLoad();
                }

                // reconfigure jump to navigation link.                
                $(`#${self.options.SkipToNavigationLinkId}`).on('click', function (e)
                {
                    let viewportWidth = FBUtilities.GetIntOrNull(window.innerWidth);
                    if ((viewportWidth < self.options.DisplayModeThreshold && self._MobileUseTabbingLoop)
                        || (viewportWidth >= self.options.DisplayModeThreshold && self._DesktopUseTabbingLoop))
                    {
                        e.preventDefault();
                        document.location = `#${self.options.AdditionalSliderButtonId}`;
                        return false;
                    }
                });

                jElement.addClass(self.options.SliderClass);
                jElement.wrapInner('<div class="' + self.options.LinerClass + '"></div>');
                $(self.options.SliderOpenContainerSelector).addClass(self.options.SliderContainerClass);


                self._lastBelowTheThreshold = self._isBelowThresehold();

                $(window).on("resize", function ()
                {
                    let isBelow = self._isBelowThresehold();

                    if (isBelow != self._lastBelowTheThreshold)
                    {
                        self._lastBelowTheThreshold = isBelow;
                        if (self._DesktopUseTabbingLoop !== self._MobileUseTabbingLoop)
                        {
                            self._updateTabbability();
                        }
                    }
                });

                jElement.on("fb:changevisibility", function (aEvent)
                {
                    self._updateTabbability();
                    console.log('changevisibility caught: "' + aEvent.detail.name + '"');// TODO: seems to trigger on every TAB through the menu...
                });

                setTimeout(function ()
                {
                    self._updateTabbability();
                }, 1)

                jElement.addClass(self.options.SlideoutClass);
            },

            _updateOnPageResizeOrLoad()
            {
                var self = this;

                if (FBUtilities.IsParameterUndefinedOrNull(self._DesktopDisplayClass)
                    || FBUtilities.IsParameterUndefinedOrNull(self._MobileDisplayClass))
                {
                    // drop out if this is somehow called in compatibility mode.
                    return;
                }

                let viewportWidth = FBUtilities.GetIntOrNull(window.innerWidth);
                if (viewportWidth >= self.options.DisplayModeThreshold)
                {
                    self._updateContainerClass(self._MobileDisplayClass, self._DesktopDisplayClass);
                }
                else
                {
                    self._updateContainerClass(self._DesktopDisplayClass, self._MobileDisplayClass);
                }
            },

            _updateContainerClass: function (aRemoveClass, aAddClass)
            {
                var self = this;

                var lContainerElement = $(self.options.SliderOpenContainerSelector);

                // does it start inactive?
                var lStartInactive = (aRemoveClass === "none");
                // should it finish inactive?
                var lFinishInactive = (aAddClass === "none");

                // (in)active classes...
                // if it doesn't have the class it should for the finish... updated it.
                if (lFinishInactive === true
                    && lContainerElement.hasClass(self.options.SliderContainerInactiveClass) === false)
                {
                    lContainerElement.removeClass(self.options.SliderContainerActiveClass).addClass(self.options.SliderContainerInactiveClass)
                }
                else if (lFinishInactive === false
                    && lContainerElement.hasClass(self.options.SliderContainerActiveClass) === false)
                {
                    lContainerElement.removeClass(self.options.SliderContainerInactiveClass).addClass(self.options.SliderContainerActiveClass)
                }
                // otherwise no changes are necessary...

                // is there a class to remove?
                if (lStartInactive === false)
                {
                    lContainerElement.removeClass(aRemoveClass);
                }
                // is there a class to add?
                if (lFinishInactive === false)
                {
                    lContainerElement.addClass(aAddClass);
                }
            },
            _isBelowThresehold: function ()
            {
                return FBUtilities.GetIntOrNull(window.innerWidth) < this.options.DisplayModeThreshold;
            },
            _isSliderActive: function ()
            {
                if (FBUtilities.IsParameterUndefinedOrNull(this._DesktopDisplayClass)
                    || FBUtilities.IsParameterUndefinedOrNull(this._MobileDisplayClass))
                {
                    return this._isBelowThresehold();
                }
                return (false === $(this.options.SliderOpenContainerSelector).hasClass(this.options.SliderContainerInactiveClass));
            },

            _isSliderOpened: function ()
            {
                return $(this.element).hasClass(this.options.SliderOpenClass);
            },
            _doBypass: function ()
            {
                return this._isSliderActive() && !this._isSliderOpened();
            },
            _doInternalLoop: function ()
            {
                return this._isSliderActive() && this._isSliderOpened();
            },
            _updateTabbability: function ()
            {
                // all the tabbing events.
                var self = this;
                var jElement = $(self.element);


                if (self._prevTabbableItem !== null)
                {
                    self._prevTabbableItem.off('keydown');
                }

                if (self._nextTabbableItem !== null)
                {
                    self._nextTabbableItem.off('keydown');
                }

                if (self._myFirstTabbableItem !== null)
                {
                    self._myFirstTabbableItem.off('keydown');
                }

                if (self._myFirstTabbableItem !== null)
                {
                    self._myLastTabbableItem.off('keydown');
                }

                if (!self._isSliderActive())
                {
                    return;
                }

                var lAllTabbableItems = $(':tabbable');

                self._myFirstTabbableItem = jElement.find(':tabbable').first();
                self._myLastTabbableItem = jElement.find(':tabbable').last();

                var lMyFirstItemIndex = parseInt(lAllTabbableItems.index(self._myFirstTabbableItem), 10);
                var lPrevItemIndex = lMyFirstItemIndex - 1;
                if (lPrevItemIndex < 0)
                {
                    lPrevItemIndex = lAllTabbableItems.length - 1;
                }
                self._prevTabbableItem = lAllTabbableItems.eq(lPrevItemIndex);

                var lMyLastItemIndex = parseInt(lAllTabbableItems.index(self._myLastTabbableItem), 10);
                var lNextItemIndex = lMyLastItemIndex + 1;
                if (lNextItemIndex < 0)
                {
                    lNextItemIndex = 0;
                }
                self._nextTabbableItem = lAllTabbableItems.eq(lNextItemIndex);

                // set up the bypass if the slider is closed...
                // before to after.
                self._prevTabbableItem.on("keydown", function (e)
                {
                    let propagate = true;
                    if (e.keyCode === 9 && e.shiftKey === false && self._doBypass())
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        self._nextTabbableItem.focus();
                        propagate = false;
                    }
                    return propagate;
                });
                // after to before.
                self._nextTabbableItem.on("keydown", function (e)
                {
                    let propagate = true;
                    if (e.keyCode === 9 && e.shiftKey === true && self._doBypass())
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        self._prevTabbableItem.focus();
                        propagate = false;
                    }
                    return propagate;
                });

                // set up the internal loop if the slider is closed...
                // bottom to top.
                self._myLastTabbableItem.on("keydown", function (e)
                {
                    let propagate = true;
                    if (e.keyCode === 9 && e.shiftKey === false && self._doInternalLoop())
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        self._myFirstTabbableItem.focus();
                        propagate = false;
                    }
                    return propagate;
                });
                // top to bottom.
                self._myFirstTabbableItem.on("keydown", function (e)
                {
                    let propagate = true;
                    if (e.keyCode === 9 && e.shiftKey === true && self._doInternalLoop())
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        self._myLastTabbableItem.focus();
                        propagate = false;
                    }
                    return propagate;
                });
            },

            ToggleSlider: function (aActivatingElement)
            {
                var self = this;
                var jElement = $(self.element);

                // toggle all the classes on the markup.
                jElement.toggleClass(self.options.SliderOpenClass);

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerSelector)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerClass))
                {
                    $(self.options.SliderOpenContainerSelector).toggleClass(self.options.SliderOpenContainerClass);
                }

                jElement.children(`.${self.options.LinerClass}`).children(`.${self.options.SliderButtonClass}`).toggleClass(self.options.SliderButtonActivatedClass);

                // and in the buttons...
                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalButtonContainerSelector) === false)
                {
                    let lAdditionalButtonContainers = $(self.options.AdditionalButtonContainerSelector);
                    if (lAdditionalButtonContainers.length > 0)
                    {
                        $.each(
                            lAdditionalButtonContainers,
                            function (_index, aValue)
                            {
                                $(aValue).children(`.${self.options.SliderButtonClass}`).toggleClass(self.options.SliderButtonActivatedClass);
                            }
                        );
                    }
                }

                // based on the open status (class changes)...
                if (self.IsSliderOpen() === true)
                {
                    // if we're now open...
                    if (FBUtilities.IsParameterUndefinedOrEmpty(aActivatingElement) === false)
                    {
                        // if an activated item had been submitted...
                        self._prevFocusItem = aActivatingElement;
                        // save any submitted activating element for return to focus when closed.
                    }
                    else
                    {
                        // if no item has been submitted, clear the variable.
                        self._prevFocusItem = null;
                    }
                    // set focus on our starting item.
                    self._GetStartingFocusItem().focus();
                }
                else
                {
                    // if we're now closed...
                    if (self._prevFocusItem === null)
                    {
                        // and no activating item was submitted...
                        if (self._myExternalOpenerButtonItem !== null)
                        {
                            // set focus on our external opener button (if any)
                            self._myExternalOpenerButtonItem.focus();
                        }
                        else
                        {
                            // set focus on the tabbable item immediately previous to the menu.
                            self._prevTabbableItem.focus();
                        }
                    }
                    else
                    {
                        // an activating item was set, set focus there and clear the variable.
                        self._prevFocusItem.focus();
                        self._prevFocusItem = null;
                    }
                }
            },

            OpenSlider: function (aActivatingElement)
            {
                var self = this,
                    jElement = $(self.element),
                    lAdditionalButtonContainers;

                jElement.addClass(self.options.SliderOpenClass);

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerSelector)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerClass))
                {
                    $(self.options.SliderOpenContainerSelector).addClass(self.options.SliderOpenContainerClass);
                }

                jElement.children('.' + self.options.LinerClass).children('.' + self.options.SliderButtonClass).addClass(self.options.SliderButtonActivatedClass);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalButtonContainerSelector) === false)
                {
                    lAdditionalButtonContainers = $(self.options.AdditionalButtonContainerSelector);
                    if (lAdditionalButtonContainers.length > 0)
                    {
                        $.each(
                            lAdditionalButtonContainers,
                            function (aIndex, aValue)//ignore jslint
                            {
                                var lValue = $(aValue);
                                lValue.children('.' + self.options.SliderButtonClass).addClass(self.options.SliderButtonActivatedClass);
                            }
                        );
                    }
                }

                // we're now open...
                if (FBUtilities.IsParameterUndefinedOrEmpty(aActivatingElement) === false)
                {
                    // if an activated item had been submitted...
                    self._prevFocusItem = aActivatingElement;
                    // save any submitted activating element for return to focus when closed.
                }
                else
                {
                    // if no item has been submitted, clear the variable.
                    self._prevFocusItem = null;
                }
                // set focus on our starting item.
                self._GetStartingFocusItem().focus();
            },

            IsSliderOpen: function ()
            {
                return $(this.element).hasClass(this.options.SliderOpenClass);
            },

            _GetStartingFocusItem: function ()
            {
                return $(this.element).find(':tabbable').not('.' + this.options.SliderButtonClass).first();
            },

            CloseSlider: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lAdditionalButtonContainers;

                jElement.removeClass(self.options.SliderOpenClass);

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerSelector)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderOpenContainerClass))
                {
                    $(self.options.SliderOpenContainerSelector).removeClass(self.options.SliderOpenContainerClass);
                }

                jElement.children('.' + self.options.LinerClass).children('.' + self.options.SliderButtonClass).removeClass(self.options.SliderButtonActivatedClass);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.AdditionalButtonContainerSelector) === false)
                {
                    lAdditionalButtonContainers = $(self.options.AdditionalButtonContainerSelector);
                    if (lAdditionalButtonContainers.length > 0)
                    {
                        $.each(
                            lAdditionalButtonContainers,
                            function (aIndex, aValue)//ignore jslint
                            {
                                var lValue = $(aValue);
                                lValue.children('.' + self.options.SliderButtonClass).removeClass(self.options.SliderButtonActivatedClass);
                            }
                        );
                    }
                }

                // we're now closed...
                if (self._prevFocusItem === null)
                {
                    // and no activating item was submitted...
                    if (self._myExternalOpenerButtonItem !== null)
                    {
                        // set focus on our external opener button (if any)
                        self._myExternalOpenerButtonItem.focus();
                    }
                    else
                    {
                        // set focus on the tabbable item immediately previous to the menu.
                        self._prevTabbableItem.focus();
                    }
                }
                else
                {
                    // an activating item was set, set focus there and clear the variable.
                    self._prevFocusItem.focus();
                    self._prevFocusItem = null;
                }
            }

        });
}(jQuery));


///////////////////////////////////////////////////////////////////////////////
// FBRMainDropNav - Foxbright Responsive Main Drop Navigation
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*
        FBRMainDropNav - Foxbright Responsive Main Drop Navigation
        
        Javascript controller for the responsive main drop menu that changes 
        form/functionality below 768 pixels for mobile and tablet touch screen use.
        
        Options:
        
        MenuClass                           default: 'fbcms_rmainmenu'
                Required.  Class to put in place when the menu is initialized.
        MenuOpenClass                       default: 'menuopen'
                Required.  Class to put in place when the menu is open.
        AddDropOpenerToMenuButton           default: true
                True to add a opener button for the whole menu.  Primarily intended to be 
                shown in mobile (below 768px viewport width) mode.
        MenuButtonSelector                  default: '.menu_title'
                Required if AddDropOpenerToMenuButton is true or AllowMenuOpenClose is true 
                AND MenuButtonClass is not set.
        MenuButtonClass                     default: 'main-opener'
                Required if AddDropOpenerToMenuButton is true or AllowMenuOpenClose is true 
                AND MenuButtonSelector is not set.
        MenuTopLevelContainerClass          default: 'top_level'
                Required.  Class to be used to locate the top level container (already in 
                markup).
        MenuTopLevelItemClass               default: 'top_level_item'
                Required.  Class to be used to locate the top level menu items (already in 
                markup).
        MenuSublistItemClass                default: 'sublist_item'
                Required.  Class to be used to locate menu items in sub menus (already in 
                markup).
        MenuItemActiveClass                 default: 'active'
                Required.  Class to be used to identify the currently active menu item 
                (already in markup).
        DropOpenerClass                     default: 'main-drop-opener'
                Required.  Class to be put into the buttons used to open the top level menu 
                item sub menus.
        OpenDropContent                     default: '<span class="fas fa-plus"></span>'
                Content to be shown when a opener button is closed and may be opened.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Open {Link Text} Menu Subpages</span>
        CloseDropContent                    default: '<span class="fas fa-minus"></span>'
                Content to be shown when a opener button is open and may be closed.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Close {Link Text} Menu Subpages</span>
        MenuLinkClass                       default: 'item_link'
                Required.  Class to be used to identify the menu link inside a menu item 
                (already in markup).
        MenuLinkWrapperClass                default: 'link_pair'
                Required.  This is a class to be attached to a new element that will wrap 
                the menu links.  Inside, the link will have the opener button added with it 
                (if that option is turned on).
        MenuDropClass                       default: 'drop'
                Required.  Class to be used to identify the sub menu (if any) inside a menu 
                item (already in markup).
        InitOpenActiveItems                 default: true
                True to open active menu items by default when the menu is loaded.  This 
                will open the menu items all the way down to the current page.
        MenuDefaultOpen                     default: true
                True to open the overall menu by default.
        HonorDefaultOpenOnActiveOpen        default: false
                True to honor the MenuDefaultOpen setting is the InitOpenActiveItems setting 
                is true.  False to open if any active items are present and the 
                InitOpenActiveItems setting is true, regardless of the MenuDefaultOpen 
                setting.
        AllowMenuOpenClose                  default: true
                True to allow the menu to be opened or closed.
        AllowMultipleItemsOpen              default: true
                True to allow multiple menu items to be open, false to close others when one 
                is opened.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleMenu
                Called to toggle the menu open or closed.
        OpenMenu
                Called to open the menu (or do nothing if the menu is already open).
        CloseMenu
                Called to close the menu (or do nothing if the menu is already closed).
        ToggleNavItem
                Called to toggle a menu item open or closed.
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('nav.main-nav').FBRMainDropNav();
    */
    $.widget("ui.FBRMainDropNav",
        {
            options:
            {
                MenuClass: 'fbcms_rmainmenu'
                , MenuOpenClass: 'menuopen'
                , AddDropOpenerToMenuButton: true
                , MenuButtonSelector: '.menu_title'
                , MenuButtonClass: 'main-opener'
                , MenuTopLevelContainerClass: 'top_level'
                , MenuTopLevelItemClass: 'top_level_item'
                , MenuTopLevelOpenClass: 'dropfocus'
                , MenuSublistItemClass: 'sublist_item'
                , MenuItemActiveClass: 'active'
                , DropOpenerClass: 'main-drop-opener'
                , OpenDropContent: '<span class="fas fa-plus"></span>'
                , CloseDropContent: '<span class="fas fa-minus"></span>'
                , MenuLinkClass: 'item_link'
                , MenuLinkWrapperClass: 'link_pair'
                , MenuDropClass: 'drop'
                , InitOpenActiveItems: true
                , MenuDefaultOpen: true
                , HonorDefaultOpenOnActiveOpen: false
                , AllowMenuOpenClose: true
                , AllowMultipleItemsOpen: true
            },

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lMenuButton,
                    lButton;

                if ($('body.page_bodyonly').length === 1)
                {
                    jElement.remove();
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuOpenClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuTopLevelContainerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuTopLevelItemClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuSublistItemClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuItemActiveClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropOpenerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuLinkClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuLinkWrapperClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuDropClass))
                {
                    FBUtilities.LogMessage('FBRMainDropNav - primary required option null or empty.');
                    return;
                }

                if ((self.options.AllowMenuOpenClose === true
                    || self.options.AddDropOpenerToMenuButton === true)
                    && (FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuButtonSelector)
                        || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuButtonClass)))
                {
                    FBUtilities.LogMessage('FBRMainDropNav - menu button settings in disagreement.');
                    return;
                }


                lMenuButton = jElement.find(self.options.MenuButtonSelector);
                if (self.options.AllowMenuOpenClose === true
                    && lMenuButton.length === 0)
                {
                    FBUtilities.LogMessage('FBRMainDropNav - menu button not found as requested by settings.');
                    return;
                }

                if (self.options.AllowMenuOpenClose === true)
                {
                    lMenuButton.addClass(self.options.MenuButtonClass);
                    lMenuButton.wrapInner('<span class="menu_title_text"></span>');
                    if (self.options.AddDropOpenerToMenuButton === true)
                    {
                        lMenuButton.append('<a href="#" class="' + self.options.DropOpenerClass + '"></a>');
                        lButton = lMenuButton.children('.' + self.options.DropOpenerClass);
                        self._setNavItemButtonText(lButton, jElement);
                    }
                }

                $.each(
                    jElement.find('.' + self.options.MenuTopLevelItemClass + ',.' + self.options.MenuSublistItemClass)
                    , function (aIndex, aValue)//ignore jslint
                    {
                        var lValue, lLink, lLinkWrapper, lDrop, lMyButton;

                        lValue = $(aValue);

                        lLink = lValue.children('.' + self.options.MenuLinkClass);
                        lLink.wrap('<div class="' + self.options.MenuLinkWrapperClass + '"></div>');
                        lLinkWrapper = lValue.children('.' + self.options.MenuLinkWrapperClass);
                        lDrop = lValue.children('.' + self.options.MenuDropClass);

                        if (lDrop.length === 1)
                        {
                            lLinkWrapper.append('<a href="#" class="' + self.options.DropOpenerClass + '"></a>');
                            lMyButton = lLinkWrapper.children('.' + self.options.DropOpenerClass);
                            self._setNavItemButtonText(lMyButton, lValue);
                        }
                    }
                );

                jElement.on(
                    'click'
                    , '.' + self.options.DropOpenerClass
                    , function (aEvent) 
                    {
                        var lTarget, lItemToToggle;

                        aEvent.preventDefault();
                        lTarget = $(aEvent.target);
                        lItemToToggle = lTarget.closest('.' + self.options.MenuSublistItemClass);
                        if (lItemToToggle.length === 0)
                        {
                            lItemToToggle = lTarget.closest('.' + self.options.MenuTopLevelItemClass);
                        }
                        if (lItemToToggle.length === 0)
                        {
                            self.ToggleMenu();
                            return false;
                        }
                        self.ToggleNavItem(lItemToToggle);
                        return false;
                    }
                );

                //if (self.options.AllowMenuOpenClose)
                //{
                //    lMenuButtonSelector = '.' + self.options.MenuButtonClass;
                //    if (self.options.AddDropOpenerToMenuButton === true)
                //    {
                //        lMenuButtonSelector += ',.' + self.options.MenuButtonClass + ' .' + self.options.DropOpenerClass;
                //    }
                //}

                if (self.options.InitOpenActiveItems)
                {
                    self._openActiveNavItems();
                }
                if (self.options.MenuDefaultOpen)
                {
                    self.OpenMenu();
                }

                var lMainNavClass = 'nav-main';
                if ($('.' + lMainNavClass).length === 0)
                {
                    lMainNavClass = 'main-nav';
                }
                if ($('.' + lMainNavClass).length === 0)
                {
                    return;
                }

                jElement.find('.' + self.options.MenuTopLevelItemClass).DropFocusManager(
                    {
                        TitleOpenerSelector: '> .' + self.options.MenuLinkWrapperClass + ' > .' + self.options.MenuLinkClass
                        , DropLinksSelector: '> .' + self.options.MenuDropClass + ' a'
                    }
                );

                function handleTabKey(e)
                {
                    if (false === $('.secondary-opener').is(':visible'))
                    {
                        // ignore tab events on full menu.
                    }
                    else if ($(this).hasClass('main-drop-opener'))
                    {
                        if (false === $(this).parent().hasClass('main-opener'))
                        {
                            if ($(this).parent().parent().hasClass('top_level_item'))
                            {
                                if ($(this).parent().parent().next('.top_level_item').length === 0)
                                {
                                    let jTabbable = jElement.parent().find(':tabbable');
                                    let index = jTabbable.index(this);
                                    if (index === -1 || (index + 1) >= jTabbable.length)
                                    {
                                        jTabbable.first().get(0).focus();
                                        e.preventDefault();
                                        e.stopPropagation();
                                        return false;
                                    }
                                }
                            }
                            else if ($(this).parent().parent().next('.sublist_item').length === 0)
                            {
                                let jSublist = $(this).parent('.link_pair').parent('.sublist_item');
                                if (!jSublist.hasClass('menuopen'))
                                {
                                    let next = jSublist.parent('.main_sublist').parent('.drop').prev('.link_pair').find('.main-drop-opener').get(0);
                                    if ($(next).is(':tabbable'))
                                    {
                                        next.focus();
                                        e.preventDefault();
                                        e.stopPropagation();
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                    else if ($(this).hasClass('top_level_link'))
                    {
                        let jTabbable = jElement.parent().find(':tabbable');
                        let index = jTabbable.index(this);
                        if (index === -1 || (index + 1) >= jTabbable.length)
                        {
                            jTabbable.first().get(0).focus();
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }
                    }
                    else if ($(this).hasClass('item_link'))
                    {
                        if (false === $(this).next().hasClass('main-drop-opener') && $(this).parent().parent().next('.sublist_item').length === 0)
                        {
                            let next = $(this)
                                .parent('.link_pair')
                                .parent('.sublist_item')
                                .parent('.main_sublist')
                                .parent('.drop')
                                .prev('.link_pair')
                                .find('.main-drop-opener')
                                .get(0);

                            if ($(next).is(':tabbable'))
                            {
                                next.focus();
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            }
                        }
                    }
                    return true;
                }

                function handleEscapeKey(e)
                {
                    let lClosestOpenParentMenu = $(this).closest('.menuopen');
                    if (lClosestOpenParentMenu.length !== 0)
                    {
                        if (false === lClosestOpenParentMenu.hasClass(lMainNavClass))
                        {
                            let lClosestParentOpenDrop = $(this).closest('.drop');
                            lClosestParentOpenDrop.prev('.link_pair')
                                .find('.main-drop-opener')
                                .focus()
                                .click();
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }
                    }
                    return true;
                }

                // handle escape on links.
                jElement.find('a').on('keydown', function (e)
                {
                    if (e.keyCode === 9 && false === e.shiftKey)
                    {
                        handleTabKey.call(this, e);
                    }
                    else if (e.key === "Escape")
                    {
                        handleEscapeKey.call(this, e);
                    }
                    return true;
                });
                
                jElement.addClass(self.options.MenuClass);
            },

            ToggleMenu: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lMenuButton,
                    lButton;

                jElement.toggleClass(self.options.MenuOpenClass);
                if (self.options.AddDropOpenerToMenuButton === true)
                {
                    lMenuButton = jElement.find(self.options.MenuButtonSelector);
                    lButton = lMenuButton.children('.' + self.options.DropOpenerClass);
                    self._setNavItemButtonText(lButton, jElement);
                }
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRMainDropNav:ToggleMenu' } }));
            },

            OpenMenu: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lMenuButton,
                    lButton;

                jElement.addClass(self.options.MenuOpenClass);

                if (self.options.AddDropOpenerToMenuButton === true)
                {
                    lMenuButton = jElement.find(self.options.MenuButtonSelector);
                    lButton = lMenuButton.children('.' + self.options.DropOpenerClass);
                    self._setNavItemButtonText(lButton, jElement);
                }
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRMainDropNav:OpenMenu' } }));
            },

            CloseMenu: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lMenuButton,
                    lButton;

                jElement.removeClass(self.options.MenuOpenClass);
                if (self.options.AddDropOpenerToMenuButton === true)
                {
                    lMenuButton = jElement.find(self.options.MenuButtonSelector);
                    lButton = lMenuButton.children('.' + self.options.DropOpenerClass);
                    self._setNavItemButtonText(lButton, jElement);
                }
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRMainDropNav:CloseMenu' } }));
            },

            ToggleNavItem: function (aNavItem)
            {
                var self = this;

                if (aNavItem.hasClass(self.options.MenuOpenClass) === false)
                {
                    self.OpenNavItem(aNavItem);
                }
                else
                {
                    self.CloseNavItem(aNavItem);
                }
            },

            OpenNavItem: function (aNavItem)
            {
                var self = this,
                    jElement = $(self.element),
                    lButton = aNavItem.children('.' + self.options.MenuLinkWrapperClass).find('.' + self.options.DropOpenerClass);

                if (self.options.AllowMultipleItemsOpen === false)
                {
                    var lAllOpenItems = jElement.find('.' + self.options.MenuSublistItemClass + '.has_subitems.' + self.options.MenuOpenClass);
                    var lParentOpenItems = aNavItem.parents('.' + self.options.MenuSublistItemClass + '.has_subitems.' + self.options.MenuOpenClass);
                    var lFilteredOpenItems = lAllOpenItems.not(lParentOpenItems);
                    $.each(
                        lFilteredOpenItems,
                        function (aIndex, aValue)
                        {
                            self.CloseNavItem($(aValue));
                        }
                    );
                }

                self._openNavItem(lButton, aNavItem);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: aNavItem, name: 'FBRMainDropNav:OpenNavItem' } }));
            },

            _openNavItem: function (aButton, aNavItem)
            {
                var self = this;

                aNavItem.addClass(self.options.MenuOpenClass);
                self._setNavItemButtonText(aButton, aNavItem);
            },

            CloseNavItem: function (aNavItem)
            {
                var self = this,
                    lButton = aNavItem.children('.' + self.options.MenuLinkWrapperClass).find('.' + self.options.DropOpenerClass);

                self._closeNavItem(lButton, aNavItem);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: aNavItem, name: 'FBRMainDropNav:CloseNavItem' } }));
            },

            _closeNavItem: function (aButton, aNavItem)
            {
                var self = this;

                aNavItem.removeClass(self.options.MenuOpenClass);
                self._setNavItemButtonText(aButton, aNavItem);
            },

            _setNavItemButtonText: function (aButton, aNavItem)
            {
                var self = this,
                    lLink = aNavItem.children('.' + self.options.MenuLinkWrapperClass).children('.' + self.options.MenuLinkClass);

                if (aNavItem.is('.' + self.options.MenuOpenClass))
                {
                    aButton.html(self.options.CloseDropContent + '<span class="screen-reader-text">Close ' + lLink.text() + ' Menu Subpages</span>');
                }
                else
                {
                    aButton.html(self.options.OpenDropContent + '<span class="screen-reader-text">Open ' + lLink.text() + ' Menu Subpages</span>');
                }
            },

            _openActiveNavItems: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lActiveItems = jElement.find('.' + self.options.MenuTopLevelItemClass + '.' + self.options.MenuItemActiveClass + ',.' + self.options.MenuSublistItemClass + '.' + self.options.MenuItemActiveClass);


                if (self.options.HonorDefaultOpenOnActiveOpen === false
                    && lActiveItems.length > 0)
                {
                    self.OpenMenu();
                }

                $.each(
                    lActiveItems,
                    function (aIndex, aValue)//ignore jslint
                    {
                        var lValue = $(aValue),
                            lButton = lValue.children('.' + self.options.MenuLinkWrapperClass).find('.' + self.options.DropOpenerClass);

                        self._openNavItem(lButton, lValue);
                    }
                );
            }

        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// FBRListNav - Foxbright Responsive List Navigation
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*
        FBRListNav - Foxbright Responsive List Navigation
        
        Javascript controller for the responsive simple menu that changes 
        form/functionality below 768 pixels for mobile and tablet touch screen use.
        
        If the class fbcms_rlistmenu is used as a menu class, the menu will be a simple list 
        menu in the desktop view, and a stack of menu items that can be closed using their 
        title as a button.
        
        If the class fbcms_rdropmenu is used as a menu class, them menu will be a drop menu 
        in the desktop view as well.
        
        Options:
        
        MenuClass                           default: 'fbcms_rlistmenu'
                Required.  A class to be added to the menu once the widget has successfully 
                completed.  May be default or changed as noted above to change behavior.
        MenuInitClass                       default: 'fbcms_simplemenu'
                Required.  A class to be added to the menu once the widget has successfully 
                completed.  Change this at your peril.
        MenuOpenClass                       default: 'menuopen'
                Required.  A class to indicate when the menu is open, to be added or removed 
                by the widget as appropriate.
        MenuTitleClass                      default: 'menu_title'
                Required.  A class selector for finding the title element of the menu in the 
                menu element.  If the menu title is empty, the widget will do nothing.
        AddMenuButton                       default: false
                If true, add a button to the menu title with events to open and close the 
                menu. If true, MenuButtonClass, OpenMenuContent, and CloseMenuContent are 
                all required.
        MenuButtonClass                     default: 'menu_opener'
                Required if AddMenuButton is true.  A class used to identify the button added 
                to the menu title.
        OpenMenuContent                     default: '<span class="fas fa-chevron-down"></span>'
                Required if AddMenuButton is true.  Content to appear in the menu button when 
                the menu is closed and may be opened.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Open {Menu Title} Menu</span>
        CloseMenuContent                    default: '<span class="fas fa-chevron-up"></span>'
                Required if AddMenuButton is true.  Content to appear in the menu button when 
                the menu is open and may be closed.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Close {Menu Title} Menu</span>
        MenuContainerClass                  default: 'simplemenu_container'
                Required.  A class that should be found in the markup on the element wrapping 
                the menu items.
        InitOpen                            default: false
                If true, the menu will initialize open.
        MenuClickActive                     default: true
                If true, the menu button will be activated on mouse click events.
        MenuHoverActive                     default: false
                If true, the menu button will be activated on mouse hover events, closing on 
                hover out after a delay (MenuHoverDelay) if not hovered over in that time.
        MenuHoverDelay                      default: 300
                A hover delay for use if the MenuHoverActive is true.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleMenu
                Called to toggle the menu open or closed.
        OpenMenu
                Called to open the menu (or do nothing if the menu is already open).
        CloseMenu
                Called to close the menu (or do nothing if the menu is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.list-nav.menu_school').FBRListNav(
            {
                AddMenuButton : true
                ,InitOpen : true
            }
        );
        
        $('.drop-nav.menu_subpages').FBRListNav(
            {
                MenuClass: 'fbcms_rdropmenu'
                ,AddMenuButton : true
            }
        );
    */
    $.widget("ui.FBRListNav",
        {
            options:
            {
                MenuClass: 'fbcms_rlistmenu'
                , MenuInitClass: 'fbcms_simplemenu'
                , MenuOpenClass: 'menuopen'
                , MenuTitleClass: 'menu_title'
                , AddMenuButton: false
                , MenuButtonClass: 'menu_opener'
                , OpenMenuContent: '<span class="fas fa-chevron-down"></span>'
                , CloseMenuContent: '<span class="fas fa-chevron-up"></span>'
                , MenuContainerClass: 'simplemenu_container'
                , InitOpen: false
                , MenuClickActive: true
                , MenuHoverActive: false
                , MenuHoverDelay: 300
            },

            _hoverTimer: null,

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if ($('body.page_bodyonly').length === 1)
                {
                    jElement.remove();
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuInitClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuOpenClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuTitleClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuContainerClass))
                {
                    FBUtilities.LogMessage('FBRListNav - required settings null or empty.');
                    return;
                }

                if (self.options.AddMenuButton === true
                    && (FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuButtonClass)
                        || FBUtilities.IsStringEmptyOrWhitespace(self.options.OpenMenuContent)
                        || FBUtilities.IsStringEmptyOrWhitespace(self.options.CloseMenuContent)))
                {
                    FBUtilities.LogMessage('FBRListNav - menu button settings not set as requested.');
                    return;
                }

                let lTitleElement = jElement.find(`.${self.options.MenuTitleClass}`);

                if (lTitleElement.length === 0)
                {
                    FBUtilities.LogMessage('FBRListNav - menu title not found.');
                    return;
                }
                lTitleElement.attr("aria-expanded", false);

                self._MenuTitle = lTitleElement.text();

                if (self.options.AddMenuButton === true)
                {
                    lTitleElement.append('<span class="' + self.options.MenuButtonClass + '"></span>');
                    self._setMenuButtonContent();
                }

                let lButtonEventSelector = '.' + self.options.MenuTitleClass;
                if (self.options.AddMenuButton === true)
                {
                    lButtonEventSelector = lButtonEventSelector + ',.' + self.options.MenuButtonClass;
                }

                if (self.options.MenuClickActive === true)
                {
                    jElement.on(
                        'click',
                        lButtonEventSelector,
                        function (aEvent) 
                        {
                            aEvent.preventDefault();
                            self.ToggleMenu();
                            return false;
                        }
                    );
                }

                if (self.options.MenuHoverActive === true)
                {
                    jElement.hover(
                        function ()
                        {
                            self.OpenMenu();

                            if (self._hoverTimer !== null)
                            {
                                $.clearTimer(self._hoverTimer);
                            }
                        }
                        , function ()
                        {
                            self._hoverTimer = $.timer(
                                self.options.MenuHoverDelay,
                                function ()
                                {
                                    self.CloseMenu();
                                }
                            );
                        }
                    );
                }

                if (self.options.InitOpen)
                {
                    self.OpenMenu();
                }

                jElement.DropFocusManager(
                    {
                        HoverFocusClass: self.options.MenuOpenClass
                        , OpenOnHoverFocus: false
                        , TitleOpenerSelector: '.' + self.options.MenuTitleClass
                        , DropLinksSelector: '.' + self.options.MenuContainerClass + ' a'
                    }
                );

                jElement.addClass(self.options.MenuClass);
                jElement.addClass(self.options.MenuInitClass);
            },

            _MenuTitle: null,

            ToggleMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.toggleClass(self.options.MenuOpenClass);
                jElement.find(`.${self.options.MenuTitleClass}`).attr("aria-expanded", jElement.hasClass(self.options.MenuOpenClass));

                self._setMenuButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRListNav:ToggleMenu' } }));
            },

            OpenMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.addClass(self.options.MenuOpenClass);
                jElement.find(`.${self.options.MenuTitleClass}`).attr("aria-expanded", true);
                
                self._setMenuButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRListNav:OpenMenu' } }));
            },

            CloseMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.removeClass(self.options.MenuOpenClass);
                jElement.find(`.${self.options.MenuTitleClass}`).attr("aria-expanded", false);
                
                self._setMenuButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRListNav:CloseMenu' } }));
            },

            _setMenuButtonContent: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lMenuButton;

                if (self.options.AddMenuButton === true)
                {
                    lMenuButton = jElement.find('.' + self.options.MenuButtonClass);

                    if (jElement.is('.' + self.options.MenuOpenClass))
                    {
                        lMenuButton.html(self.options.CloseMenuContent + '<span class="screen-reader-text">Close ' + self._MenuTitle + ' Menu</span>');
                    }
                    else
                    {
                        lMenuButton.html(self.options.OpenMenuContent + '<span class="screen-reader-text">Open ' + self._MenuTitle + ' Menu</span>');
                    }
                }
            }

        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// VisualNavManager - Visual Nav/"Mobile Menu" Manager
///////////////////////////////////////////////////////////////////////////////

function VisualNavManager_Functions()
{
    return undefined;
}

VisualNavManager_Functions._ExtraMenuButtonHandler = function (aEvent) 
{
    aEvent.preventDefault();
    $(aEvent.target).closest('.visual_nav_wrapper').VisualNavManager('ToggleMenu');
    return false;
};

VisualNavManager_Functions._ExtraMenuEscapeHandler = function (aEvent) 
{
    if (aEvent.keyCode === 27 /*escape*/)
    {
        aEvent.preventDefault();
        var jNav = $(aEvent.target).closest('.visual_nav_wrapper');
        jNav.VisualNavManager('CloseMenu');
        jNav.find('.visual_nav_extraopener').focus();// warning, class from options here!!!
        return false;
    }
};

VisualNavManager_Functions._ExtraMenuLoopBackHandler = function (aEvent) 
{
    if (aEvent.keyCode === 9 && aEvent.shiftKey === false)
    {
        aEvent.preventDefault();
        var jNav = $(aEvent.target).closest('.visual_nav_wrapper');
        jNav.find('.visual_nav_liner_extra .visual_nav_item_link').first().focus();// warning, class from options here!!!
    }
};

VisualNavManager_Functions._ExtraMenuLoopFrontHandler = function (aEvent) 
{
    if (aEvent.keyCode === 9 && aEvent.shiftKey === true)
    {
        aEvent.preventDefault();
        var jNav = $(aEvent.target).closest('.visual_nav_wrapper');
        jNav.find('.visual_nav_liner_extra .visual_nav_item_link').last().focus();// warning, class from options here!!!
    }
};

VisualNavManager_Functions._ExtraMenuGlobalFocusHandler = function (aEvent) 
{
    if ($(aEvent.target).closest('.visual_nav_wrapper .visual_nav_liner_extra').length === 0)
    {
        var jNav = $('.visual_nav_wrapper');
        jNav.VisualNavManager('CloseMenu');
        if (jQuery.contains( jNav.find('.visual_nav_extraopener'), aEvent.target ) === false)
        {
            jNav.VisualNavManager('CloseMenu');
        }
    }
};

(function ($)
{
    /*
        VisualNavManager - Visual Nav/"Mobile Menu" Manager
        
        Javascript controller for any active components of the VisualNav menus.
        This currently consists of the Extra/Overflow menu.
        
        Options:
        
        MenuOpenClass                       default: 'visual_nav_open'
                Required.  A class to indicate when the menu is open, to be added or removed 
                by the widget as appropriate.
        MenuButtonClass                     default: 'visual_nav_extraopener'
                Required if AddMenuButton is true.  A class used to identify the button added 
                to the menu title.
        MenuContainerClass                  default: 'visual_nav_liner_extra'
                Required.  A class that should be found in the markup on the element wrapping 
                the menu items.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleMenu
                Called to toggle the menu open or closed.
        OpenMenu
                Called to open the menu (or do nothing if the menu is already open).
        CloseMenu
                Called to close the menu (or do nothing if the menu is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.visual_nav_wrapper').VisualNavManager();

    */
    $.widget("ui.VisualNavManager",
        {
            options:
            {
                MenuOpenClass: 'visual_nav_open'
                , MenuButtonClass: 'visual_nav_extraopener'
                , MenuContainerClass: 'visual_nav_liner_extra'
                , MenuLinkClass: 'visual_nav_item_link'
            },

            _hoverTimer: null,

            _destroy: function ()
            {
                var self = this;
                var jElement = $(self.element);
                
                jElement.off(
                    'click',
                    '.' + self.options.MenuButtonClass,
                    VisualNavManager_Functions._ExtraMenuButtonHandler
                );

                let jExtraMenuOpener = jElement.find('.visual_nav_extraopener');
                let jExtraMenu = jElement.find('.visual_nav_liner_extra');
                if (jExtraMenuOpener.length > 0
                    && jExtraMenu.length > 0)
                {
                    let lExtraMenu = jExtraMenu.get(0);
                    let jExtraLinks = jExtraMenu.find('.visual_nav_item_link');
                    
                    jExtraLinks.off('keydown', VisualNavManager_Functions._ExtraMenuEscapeHandler);
                    
                    jExtraLinks.first().off('keydown', VisualNavManager_Functions._ExtraMenuLoopFrontHandler);

                    jExtraLinks.last().off('keydown', VisualNavManager_Functions._ExtraMenuLoopBackHandler);
                    
                    $('body').off('click', VisualNavManager_Functions._ExtraMenuGlobalFocusHandler);
                }
                
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                //TODO: should this remain???
                if ($('body.page_bodyonly').length === 1)
                {
                    jElement.remove();
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuOpenClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuButtonClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuContainerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MenuLinkClass))
                {
                    FBUtilities.LogMessage('FBRListNav - required settings null or empty.');
                    return;
                }

                jElement.on(
                    'click',
                    '.' + self.options.MenuButtonClass,
                    VisualNavManager_Functions._ExtraMenuButtonHandler
                );
                
                var lElement = jElement.get(0);
                $("body").css("--VisualNav-Height", "" + lElement.offsetHeight + "px");
                
                let jExtraMenuOpener = jElement.find('.visual_nav_extraopener');
                let jExtraMenu = jElement.find('.visual_nav_liner_extra');
                if (jExtraMenuOpener.length > 0
                    && jExtraMenu.length > 0)
                {
                    let lExtraMenu = jExtraMenu.get(0);
                    let jExtraLinks = jExtraMenu.find('.visual_nav_item_link');
                    
                    // if it's ESC, close menu.
                    jExtraLinks.on('keydown', VisualNavManager_Functions._ExtraMenuEscapeHandler);
                    

                    // on first item, loop to last on backward tab.
                    jExtraLinks.first().on('keydown', VisualNavManager_Functions._ExtraMenuLoopFrontHandler);

                    // on last item, loop to first on forward tab.
                    jExtraLinks.last().on('keydown', VisualNavManager_Functions._ExtraMenuLoopBackHandler);
                    
                    
                    // on focus loss, close menu?                    
                    jExtraMenu.on('focusout', function(event)
                    {
                        // unknown if this is usefully populated.
                        if (jQuery.contains( lExtraMenu, event.relatedTarget ) === false)
                        {
                            self.CloseMenu();
                        }
                    });
                    $('body').on('click', VisualNavManager_Functions._ExtraMenuGlobalFocusHandler);
                }
            },

            ToggleMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.toggleClass(self.options.MenuOpenClass);

                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'VisualNavManager:ToggleMenu' } }));
            },

            OpenMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.addClass(self.options.MenuOpenClass);

                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'VisualNavManager:OpenMenu' } }));
            },

            CloseMenu: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.removeClass(self.options.MenuOpenClass);

                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'VisualNavManager:CloseMenu' } }));
            }
        });
        
    $(window).on('load', function ()
    {
        $('.visual_nav_wrapper').VisualNavManager();
    });
}(jQuery));


///////////////////////////////////////////////////////////////////////////////
// FBRFlyUp - Foxbright Responsive Flyup
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*
        FBRFlyUp - Foxbright Responsive Flyup
        
        Fly-up widget.
        
        The element selected by the widget (container element) will have a class added to it 
        to indicate that it is opened (OpenClass). Selecting the fly-up tab or mouse hovering 
        over any part of the slider will open the fly-up and put the class in place.
        
        Options:
        
        FlyupTitleSelector                  default: null - must be set to a valid selector.
                Required.  A selector to be used to find the title element(s) inside the element.
        ContainerClass                      default: 'flyup_container'
                Required.  The class to be set to the widget element.
        OpenClass                           default: 'flyup_expanded'
                Required.  The class to be set on the drawer element when open.
        DrawerClass                         default: 'flyup_drawer'
                Required.  The class to be set on a content wrapper that does all the sliding.
                This element will be added to the DOM by the widget.
        TabWrapperClass                     default: 'flyup_tabcontainer'
                Required.  The class to be set on a wrapper around the tab.
                This element will be added to the DOM by the widget.
        TabClass                            default: 'flyup_tab'
                Required.  The class to be added to the flyup title element.
        SlideClass                          default: 'flyup_slide'
                Required.  The class for the element to be wrapped around all content under the 
                flyup title.  This element will be added to the DOM by the widget.
        AnimationSpeed                      default: 500
                Required.  Number of milliseconds that the slide animation should take.
        UseClickOnly                        default: false
                Required.  True if the flyup should work only on click instead of by hover.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleFlyup
                Called to toggle the widget open or closed.
        OpenFlyup
                Called to open the widget (or do nothing if the widget is already open).
        CloseFlyup
                Called to close the widget (or do nothing if the widget is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.  New markup and classes will be added in place.  This example 
        has the markup followed by the jQuery call to activate it.
        
        <div class="slider_box">
            <h2 class="slider_box_title">{TITLE CONTENT}</h2>
            {SLIDER CONTENT - Must be HTML elements, may be multiple.}
        </div>
        
        $('.slider_box').FBRFlyUp(
            {
                FlyupTitleSelector : '.slider_box_title'
            }
        );
    */
    $.widget("ui.FBRFlyUp",
        {
            options:
            {
                FlyupTitleSelector: null
                , ContainerClass: 'flyup_container'
                , OpenClass: 'flyup_expanded'
                , DrawerClass: 'flyup_drawer'
                , TabWrapperClass: 'flyup_tabcontainer'
                , TabClass: 'flyup_tab'
                , SlideClass: 'flyup_slide'
                , AnimationSpeed: 500
                , UseClickOnly: false
            },

            _destroy: function ()
            {
                var self, jElement, lTitleElement, lIsEditMode, lTab, lDrawer, lSlide;

                self = this;
                jElement = $(self.element);
                lTitleElement = jElement.find(self.options.FlyupTitleSelector);
                if (lTitleElement.length === 0)
                {
                    return;
                }

                lIsEditMode = FBCommon_1_2.isInEditor();
                lTab = jElement.find('.' + self.options.TabClass);
                lDrawer = jElement.find('.' + self.options.DrawerClass);
                lSlide = jElement.find('.' + self.options.SlideClass);

                if (lTab.length === 0
                    || lDrawer.length === 0
                    || lSlide.length === 0)
                {
                    return;
                }

                if (lIsEditMode === false
                    && FBUtilities.IsStringEmptyOrWhitespace(lTab.text()))
                {
                    jElement.show();
                    return;
                }

                jElement.css(
                    {
                        position: ''
                    }
                );

                lDrawer.css(
                    {
                        position: '',
                        top: ''
                    }
                );

                jQuery(document).off('click');
                lTab.off('keypress');

                if (self.options.UseClickOnly)
                {
                    lTab.off('click', self.ToggleFlyup);
                }
                else
                {
                    jElement.off(
                        "mouseout",
                        '.' + self.options.DrawerClass
                    );
                    jElement.off(
                        "mouseover",
                        '.' + self.options.TabClass
                    );
                }

                jElement.off(
                    "focusin",
                    '.' + self.options.SlideClass
                );


                lTitleElement.unwrap();
                lTitleElement.removeAttr('tabindex');
                lTitleElement.removeClass(self.options.TabClass);
                jElement.find('.' + self.options.DrawerClass).unwrap();
                jElement.find('.' + self.options.SlideClass).children().unwrap();
                jElement.removeClass(self.options.ContainerClass);
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self, jElement, lTitleElement, lTab, lDrawer, lSlide;

                self = this;
                jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.FlyupTitleSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.ContainerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.OpenClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DrawerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.TabWrapperClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.TabClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SlideClass)
                    || FBUtilities.IsParameterUndefined(self.options.AnimationSpeed)
                    || FBUtilities.IsParameterUndefined(self.options.UseClickOnly))
                {
                    FBUtilities.LogMessage('FBRFlyUp - required settings null or empty.');
                    jElement.hide();
                    return;
                }

                lTitleElement = jElement.find(self.options.FlyupTitleSelector);
                if (lTitleElement.length === 0)
                {
                    jElement.hide();
                    return;
                }

                lTitleElement.wrap($('<div></div>').addClass(self.options.TabWrapperClass));
                lTitleElement.addClass(self.options.TabClass);
                lTitleElement.attr('tabindex', '0');
                jElement.children().not('.' + self.options.TabWrapperClass).wrapAll($('<div></div>').addClass(self.options.SlideClass));
                jElement.children().wrapAll($('<div></div>').addClass(self.options.DrawerClass));
                jElement.addClass(self.options.ContainerClass);


                lTab = jElement.find('.' + self.options.TabClass);
                lDrawer = jElement.find('.' + self.options.DrawerClass);
                lSlide = jElement.find('.' + self.options.SlideClass);

                if (lTab.length === 0
                    || lDrawer.length === 0)
                {
                    jElement.hide();
                    return;
                }

                if (FBCommon_1_2.isInEditor() === false
                    && FBUtilities.IsStringEmptyOrWhitespace(lTab.text()))
                {
                    jElement.hide();
                    return;
                }

                if (lSlide.length === 0)
                {
                    jElement.hide();
                    return;
                }

                jElement.css(
                    {
                        position: 'relative'
                    }
                );

                lDrawer.css(
                    {
                        position: 'absolute',
                        top: -lTab.innerHeight()
                    }
                );

                jQuery(document).click(
                    function (aEvent)
                    {
                        var lTarget = jQuery(aEvent.target);
                        if (!lTarget.parents().is(lDrawer))
                        {
                            self.CloseFlyup();
                        }
                    }
                );

                lTab.keypress(
                    function (aEvent)
                    {
                        if (aEvent.which === 13)
                        {
                            self.ToggleFlyup();
                            return false;
                        }
                    }
                );

                if (self.options.UseClickOnly)
                {
                    lTab.on('click', self.ToggleFlyup);
                }
                else
                {
                    jElement.on(
                        "mouseout",
                        '.' + self.options.DrawerClass,
                        function (aEvent)
                        {
                            var lDrawerParent = $(aEvent.relatedTarget).closest('.' + self.options.DrawerClass);
                            if (lDrawerParent.length === 1
                                && lDrawerParent.get(0) === lDrawer.get(0))
                            {
                                return false;
                            }
                            self.CloseFlyup();
                        }
                    );
                    jElement.on(
                        "mouseover",
                        '.' + self.options.TabClass,
                        function (/*aEvent*/)
                        {
                            self.OpenFlyup();
                        }
                    );
                }

                jElement.on(
                    "focusin",
                    '.' + self.options.SlideClass,
                    function (/*aFIEvent*/)
                    {
                        self.OpenFlyup();
                        lSlide.on(
                            "focusout",
                            function (aFOEvent)
                            {
                                var lSlideParent = $(aFOEvent.target).closest('.' + self.options.SlideClass);
                                if (lSlideParent.length === 1
                                    && lSlideParent.get(0) === lSlide.get(0))
                                {
                                    return false;
                                }

                                self.CloseFlyup();
                                lSlide.off("focusout");
                            }
                        );
                    }
                );
            },

            ToggleFlyup: function ()
            {
                var self, jElement, lDrawer;

                self = this;
                jElement = $(self.element);
                lDrawer = jElement.find('.' + self.options.DrawerClass);

                if (lDrawer.hasClass(self.options.OpenClass))
                {
                    self.CloseFlyup();
                }
                else
                {
                    self.OpenFlyup();
                }
            },

            OpenFlyup: function ()
            {
                var self, jElement, lDrawer;

                self = this;
                jElement = $(self.element);
                lDrawer = jElement.find('.' + self.options.DrawerClass);

                lDrawer.animate({
                    top: -lDrawer.innerHeight()
                }, {
                    queue: false,
                    duration: self.options.AnimationSpeed,
                    complete: function ()
                    {
                        lDrawer.addClass(self.options.OpenClass);
                        self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRFlyUp:OpenFlyup' } }));
                    }
                });
            },

            CloseFlyup: function ()
            {
                var self, jElement, lTab, lDrawer;

                self = this;
                jElement = $(self.element);
                lTab = jElement.find('.' + self.options.TabClass);
                lDrawer = jElement.find('.' + self.options.DrawerClass);

                lDrawer.animate({
                    top: -lTab.innerHeight()
                }, {
                    queue: false,
                    duration: self.options.AnimationSpeed,
                    complete: function ()
                    {
                        lDrawer.removeClass(self.options.OpenClass);
                        self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBRFlyUp:CloseFlyup' } }));
                    }
                });
            }

        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// DropFocusManager - Foxbright Drop Focus Manager
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*            
        DropFocusManager - Foxbright Drop Focus Manager
        
        Javascript controller for managing simple drop logic and incorporating keyboard focus 
        into the drop behavior as well.
        
        The element selected by the widget (container element) will have a class added to it 
        to indicate that it is opened (HoverFocusClass). Selecting or focusing on the element 
        or elements indicated by TitleOpenerSelector will put the class in place. Selection 
        of the element(s) indicated by DropLinksSelector will keep the open status in place.
        A delay for closing the element (FocusCloseDelay) is available for tuning the 
        behavior of the widget and ensuring time for events to propagate.
        
        Options:
        
        HoverFocusClass                     default: 'hoverfocus'
                Required.  A class to be added to the element when focus is in the element.
        OpenOnHoverFocus                    default: true
                Required.  True if the hoverfocus class is to be added on hover as well.
        FocusCloseDelay                     default: 10
                Required.  The number of milliseconds after loss of focus to wait before 
                closing the element.  Necessary to give time for new focus events that occur 
                inside the element to propagate and stop the closure.
        TitleOpenerSelector                 default: null
                Required.  A jQuery selector indicating the element or elements to use as an 
                opener button for the element.
        DropLinksSelector                   default: null
                Required.  A jQuery selector indicating the elements inside the element that 
                should keep the element open if selected.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleDrop
                Called to toggle the widget open or closed.
        OpenDrop
                Called to open the widget (or do nothing if the widget is already open).
        CloseDrop
                Called to close the widget (or do nothing if the widget is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.list-nav.menu_quicklinks').DropFocusManager(
            {
                TitleOpenerSelector : '.menu_title'
                ,DropLinksSelector : '.drop a'
            }
        );
    */
    $.widget("ui.DropFocusManager",
        {
            options:
            {
                HoverFocusClass: 'hoverfocus'
                , OpenOnHoverFocus: true
                , FocusCloseDelay: 10
                , TitleOpenerSelector: null
                , DropLinksSelector: null
            },

            _focusTimer: null,

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.HoverFocusClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.TitleOpenerSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropLinksSelector))
                {
                    FBUtilities.LogMessage('DropFocusManager - required settings null or empty.');
                    return;
                }

                jElement.on(
                    "focusin",
                    self.options.TitleOpenerSelector,
                    function (/*aEvent*/)
                    {
                        if (self.options.OpenOnHoverFocus === true)
                        {
                            $.clearTimer(self._focusTimer);
                            self.OpenDrop();
                        }
                    }
                );

                jElement.on(
                    "focusin",
                    self.options.DropLinksSelector,
                    function (/*aEvent*/)
                    {
                        $.clearTimer(self._focusTimer);
                        self.OpenDrop();
                    }
                );

                jElement.on(
                    "focusout",
                    self.options.TitleOpenerSelector + ',' + self.options.DropLinksSelector,
                    function (/*aEvent*/)
                    {
                        self._focusTimer = $.timer(
                            self.options.FocusCloseDelay,
                            function ()
                            {
                                self.CloseDrop();
                            }
                        );
                    }
                );

            },

            ToggleDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);
                jElement.toggleClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'DropFocusManager:ToggleDrop' } }));
            },

            OpenDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);

                if (jElement.hasClass(self.options.HoverFocusClass))
                {
                    return;
                }
                jElement.addClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'DropFocusManager:OpenDrop' } }));
            },

            CloseDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);
                jElement.removeClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'DropFocusManager:CloseDrop' } }));
            }

        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// ItemFocusManager - Foxbright Item Focus Manager
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    /*            
        ItemFocusManager - Foxbright Item Focus Manager
        
        Javascript controller for managing simple drop logic and incorporating keyboard focus 
        into the drop behavior as well. Based on DropFocusManager.
        
        The element selected by the widget (container element) will have a class added to it 
        to indicate that it is opened (HoverFocusClass). Selecting or focusing on the element 
        or elements inside it will put the class in place. 
        A delay for closing the element (FocusCloseDelay) is available for tuning the 
        behavior of the widget and ensuring time for events to propagate.
        
        Options:
        
        HoverFocusClass                     default: 'hoverfocus'
                Required.  A class to be added to the element when focus is in the element.
        OpenOnHoverFocus                    default: true
                Required.  True if the hoverfocus class is to be added on hover as well.
        FocusCloseDelay                     default: 10
                Required.  The number of milliseconds after loss of focus to wait before 
                closing the element.  Necessary to give time for new focus events that occur 
                inside the element to propagate and stop the closure.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleDrop
                Called to toggle the widget open or closed.
        OpenDrop
                Called to open the widget (or do nothing if the widget is already open).
        CloseDrop
                Called to close the widget (or do nothing if the widget is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.item').ItemFocusManager();
    */
    $.widget("ui.ItemFocusManager",
        {
            options:
            {
                HoverFocusClass: 'hoverfocus'
                , OpenOnHoverFocus: true
                , FocusCloseDelay: 10
            },

            _focusTimer: null,

            destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.HoverFocusClass))
                {
                    FBUtilities.LogMessage('ItemFocusManager - required settings null or empty.');
                    return;
                }

                jElement.on(
                    "focusin",
                    function (/*aEvent*/)
                    {
                        if (self.options.OpenOnHoverFocus === true)
                        {
                            $.clearTimer(self._focusTimer);
                            self.OpenDrop();
                        }
                    }
                );

                jElement.on(
                    "focusout",
                    function (/*aEvent*/)
                    {
                        self._focusTimer = $.timer(
                            self.options.FocusCloseDelay,
                            function ()
                            {
                                self.CloseDrop();
                            }
                        );
                    }
                );

            },

            ToggleDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);
                jElement.toggleClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'ItemFocusManager:ToggleDrop' } }));
            },

            OpenDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);

                if (jElement.hasClass(self.options.HoverFocusClass))
                {
                    return;
                }
                jElement.addClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'ItemFocusManager:OpenDrop' } }));
            },

            CloseDrop: function ()
            {
                var self, jElement;

                self = this;
                jElement = $(self.element);
                jElement.removeClass(self.options.HoverFocusClass);
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'ItemFocusManager:CloseDrop' } }));
            }

        });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// jQuery functions extensions.
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    // --[ Truncate text ]-------------------------------------------------------------------------

    jQuery.fn.truncate = function (max, settings)
    {
        settings = jQuery.extend({
            chars: /\s/,
            trail: ["...", ""]
        }, settings);


        var myResults = {},
            ie = jQuery.browser.msie;

        function fixIE(o)
        {
            if (ie)
            {
                o.style.removeAttribute("filter");
            }
        }
        return this.each(function ()
        {
            var jQuerythis = jQuery(this),
                myStrOrig = jQuerythis.html().replace(/\r\n/gim, ""),
                myStr = myStrOrig,
                myRegEx = /<\/?[^<>]*\/?>/gim,
                myRegExArray,
                myRegExHash = {},
                myResultsKey = jQuery("*").index(this),
                c,
                endCap = 0,
                eachEl;


            //while ( ( myRegExArray = myRegEx.exec( myStr ) ) !== null )
            for (myRegExArray = myRegEx.exec(myStr); myRegExArray !== null; myRegExArray = myRegEx.exec(myStr))
            {
                myRegExHash[myRegExArray.index] = myRegExArray[0];
            }

            myStr = jQuery.trim(myStr.split(myRegEx).join(""));
            if (myStr.length > max)
            {
                while (max < myStr.length)
                {
                    c = myStr.charAt(max);
                    if (c.match(settings.chars))
                    {
                        myStr = myStr.substring(0, max);
                        break;
                    }
                    max -= 1;
                }

                if (myStrOrig.search(myRegEx) !== -1)
                {
                    endCap = 0;
                    for (eachEl in myRegExHash)
                    {
                        if (myRegExHash.hasOwnProperty(eachEl))
                        {
                            myStr = [myStr.substring(0, eachEl), myRegExHash[eachEl], myStr.substring(eachEl, myStr.length)].join("");
                            if (eachEl < myStr.length)
                            {
                                endCap = myStr.length;
                            }
                        }
                    }
                    jQuerythis.html([myStr.substring(0, endCap), myStr.substring(endCap, myStr.length).replace(/<(\w+)[^>]*>.*<\/\1>/gim, "").replace(/<(br|hr|img|input)[^<>]*\/?>/gim, "")].join(""));
                } else
                {
                    jQuerythis.html(myStr);
                }
                myResults[myResultsKey] = myStrOrig;
                jQuerythis.html(["<div class='truncate_less'>", jQuerythis.html(), settings.trail[0], "</div>"].join(""))
                    .find(".truncate_show", this).click(function ()
                    {
                        if (jQuerythis.find(".truncate_more").length === 0)
                        {
                            jQuerythis.append(["<div class='truncate_more' style='display: none;'>", myResults[myResultsKey], settings.trail[1], "</div>"].join(""))
                                .find(".truncate_hide").click(function ()
                                {
                                    jQuerythis.find(".truncate_more").css("background", "#fff").fadeOut("normal", function ()
                                    {
                                        jQuerythis.find(".truncate_less").css("background", "#fff").fadeIn("normal", function ()
                                        {
                                            fixIE(this);
                                            jQuery(this).css("background", "none");
                                        });
                                        fixIE(this);
                                    });
                                    return false;
                                });
                        }
                        jQuerythis.find(".truncate_less").fadeOut("normal", function ()
                        {
                            jQuerythis.find(".truncate_more").fadeIn("normal", function ()
                            {
                                fixIE(this);
                            });
                            fixIE(this);
                        });
                        jQuery(".truncate_show", jQuerythis).click(function ()
                        {
                            jQuerythis.find(".truncate_less").css("background", "#fff").fadeOut("normal", function ()
                            {
                                jQuerythis.find(".truncate_more").css("background", "#fff").fadeIn("normal", function ()
                                {
                                    fixIE(this);
                                    jQuery(this).css("background", "none");
                                });
                                fixIE(this);
                            });
                            return false;
                        });
                        return false;
                    });
            }
        });
    };

    $.fn.extend({
        getRadioValue: function ()
        {
            return $(this).filter(':checked').val();
        },
        getYesNoRadioIsYes: function (alternateYesValue)
        {
            var yesValue, jCheckedElement;
            yesValue = (alternateYesValue === undefined) ? "True" : alternateYesValue;
            if ($(this).is('[type=hidden]'))
            {
                return ($(this).val() === yesValue);
            }
            jCheckedElement = $(this).filter(':checked');
            return (jCheckedElement.length !== 0 && jCheckedElement.val() === yesValue);
        },
        getYesNoCheckIsYes: function (alternateYesValue)
        {
            var yesValue, jCheckedElement;
            yesValue = (alternateYesValue === undefined) ? "True" : alternateYesValue;
            if ($(this).is('[type=hidden]'))
            {
                return ($(this).val() === yesValue);
            }
            jCheckedElement = $(this).filter(':checked');
            return (jCheckedElement.length !== 0 && jCheckedElement.val() === yesValue);
        },
        getYesNoDefaultRadio: function ()
        {
            var jCheckedElement;
            if ($(this).is('[type=hidden]'))
            {
                return FBUtilities.GetBoolOrNull($(this).val());
            }
            jCheckedElement = $(this).filter(':checked');
            if (jCheckedElement.length !== 0)
            {
                return FBUtilities.GetBoolOrNull(jCheckedElement.val());
            }
            return null;
        },
        getSelectBoxValue: function ()
        {
            var selectedValue, selectedOption;
            selectedValue = "";
            selectedOption = $(this).find("option:selected");
            if (selectedOption.length !== 0)
            {
                selectedValue = selectedOption.val();
            }
            return selectedValue;
        },
        getMultipleCheckedValues: function ()
        {
            return $(this).filter(":checked").map(function ()
            {
                return $(this).val();
            }).get();
        }
    });
}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// Masonry
///////////////////////////////////////////////////////////////////////////////
/*
$( window ).on( 'load', function ()
{
    $('.fbcms_contentbody.masonry').each(function()
    {
        var self = $(this);
        self.isotope(
            {
                itemSelector: '.fbcms_contentitem',
                masonry: 
                {
                    columnWidth: 1
                }
            }
        );
    });
} );
*/

/*
    RotatorManager - Foxbright Rotator Manager
    TODO: update docs
    Javascript controller for managing simple drop logic and incorporating keyboard focus 
    into the drop behavior as well.
    
    The element selected by the widget (container element) will have a class added to it 
    to indicate that it is opened (HoverFocusClass). Selecting or focusing on the element 

    
    Options:
    
    PermaLinkUrl                        default: null - must be set when called.
            Required.  The uri location of a permalink for this photo gallery.  Since this 
            is required and has no default, it must be set when initializing the manager.
    GalleryTitle                        default: null
            Optional.  A title for the gallery.
    RotatorContainerSelector            default: '.fbcms_imagerotator'
            Required.  Selector indicating the element that is to be used as the rotator 
            container.
    ShowButtons                         default: false
            Optional.  True to show buttons, false otherwise.
    ButtonPositionsPlayPauseModifer    default: 'upperright' [upperleft|upperright|lowerleft|lowerright]
            Optional; Required if ShowButtons is true.  Play/Pause button position. 
    ButtonPositionsPermaLinkModifer    default: 'upperright' [upperleft|upperright|lowerleft|lowerright]
            Optional; Required if ShowButtons is true.  Permalink button position. 
    ButtonPositionsNextPrevModifer     default: 'middle' [upperleft|upperright|middle|lowerleft|lowerright]
            Optional; Required if ShowButtons is true.  Next/Previous buttons position.
    ButtonPositionsPagerModifer        default: 'upperright' [upperleft|upperright|lowerleft|lowerright]
            Optional; Required if ShowButtons is true.  Pager button postion.
    ButtonClass                         default: 'fbpgro_button'
            Optional; Required if ShowButtons is true.  Class to be put on all buttons.
    PrevButtonClass                     default: 'fbpgro_prev'
            Optional; Required if ShowButtons is true.  Previous button class.
    PrevButtonIcon                      default: '<span class="fas fa-angle-left" aria-hidden="true"></span>'
            Optional; Required if ShowButtons is true.  Previous button icon.
    PrevButtonContent                   default: '<span class="screen-reader-text">Previous</span>'
            Optional; Required if ShowButtons is true.  Previous button content.
    NextButtonClass                     default: 'fbpgro_next'
            Optional; Required if ShowButtons is true.  Next button class.
    NextButtonIcon                      default: '<span class="fas fa-angle-right" aria-hidden="true"></span>'
            Optional; Required if ShowButtons is true.  Next button icon.
    NextButtonContent                   default: '<span class="screen-reader-text">Next</span>'
            Optional; Required if ShowButtons is true.  Next button content.
    PlayPauseButtonClass                default: 'fbpgro_playpause'
            Optional; Required if ShowButtons is true.  Play Pause button class.
    PlayPauseButtonIconPause            default: '<span class="fas fa-pause" aria-hidden="true"></span>'
            Optional; Required if ShowButtons is true.  Play Pause button icon when playing.
    PlayPauseButtonContentPause         default: '<span class="screen-reader-text">Pause</span>'
            Optional; Required if ShowButtons is true.  Play Pause button content when playing.
    PlayPauseButtonIconPlay             default: '<span class="fas fa-play" aria-hidden="true"></span>'
            Optional; Required if ShowButtons is true.  Play Pause button icon when paused.
    PlayPauseButtonContentPlay          default: '<span class="screen-reader-text">Play</span>'
            Optional; Required if ShowButtons is true.  Play Pause button content when paused.
    PermaLinkButtonClass                default: 'fbpgro_permalink'
            Optional; Required if ShowButtons is true.  Permalink button class.
    PermaLinkButtonIcon                 default: '<span class="fas fa-link" aria-hidden="true"></span>'
            Optional; Required if ShowButtons is true.  Permalink button icon.
    PermaLinkButtonContent              default: '<span class="screen-reader-text">Gallery Permalink</span>'
            Optional; Required if ShowButtons is true.  Permalink button content.
    ShowPager                           default: false
            Optional.  True to show pager, false otherwise.
    PagerClass                          default: 'fbpgro_pager'
            Optional; Required if ShowPager is true.  Pager class.
    ShowOverlay                         default: false
            Optional.  True to show overlay, false otherwise.
    OverlayClass                        default: 'fbpgro_overlay'
            Optional; Required if ShowOverlay is true.  Overlay class.
    OverlayTextWrapperClass             default: 'fbpgro_textwrapper'
            Optional; Required if ShowOverlay is true.  Class for wrapper around title and 
            description text elements.
    OverlayTitleClass                   default: 'fbpgro_title'
            Optional; Required if ShowOverlay is true.  Text element class.
    OverlayDescClass                    default: 'fbpgro_desc'
            Optional; Required if ShowOverlay is true.  Description element class.
    OverlayLinkWrapperClass             default: 'fbpgro_linkwrapper'
            Optional; Required if ShowOverlay is true.  Overlay link wrapper class.
    OverlayLinkClass                    default: 'fbpgro_link'
            Optional; Required if ShowOverlay is true.  Overlay link class.
    OverlayUpdateFunction               default: null 
            Optional.  An override for the overlay update function.  This will be called each 
            time a slide is changed.  
            The signature is: function(aContentBlock, aTitle, aDesc, aUrl, aUrlTarget, aUrlText)
    OnPreInitFunctions                  default: null
            Optional. Functions that may be called upon before initialization of the rotator, 
            but after the markup has been updated by the widget.
            The signature is: function(aCycleEvent, aCycleOptions)
    
    Methods:
    
    The widget is fully functional on its own, but can be remotely activated with the following 
    methods.
    
    OverlayUpdateFunction(aTitle, aDesc, aUrl, aUrlTarget, aUrlText)
            Called to toggle the widget open or closed.
    
    Examples:
    
    Since the function is built as a jQuery Widget, simply call the functions on the 
    container element directly.
    
    $('#content_1337').RotatorManager(
        {
            PermaLinkUrl: '/Core/Gallery/Index/1701/'
        }
    );
*/
(function ($)
{
    $.widget("ui.RotatorManager",
        {
            options:
            {
                PermaLinkUrl: null
                , GalleryTitle: null
                , RotatorContainerSelector: '.fbcms_imagerotator'
                , ShowButtons: false
                , ButtonPositionsPlayPauseModifer: 'upperright'
                , ButtonPositionsPermaLinkModifer: 'upperright'
                , ButtonPositionsNextPrevModifer: 'middle'
                , ButtonPositionsPagerModifer: 'upperright'
                , ButtonClass: 'fbpgro_button'
                , PrevButtonClass: 'fbpgro_prev'
                , NextButtonClass: 'fbpgro_next'
                , PlayPauseButtonClass: 'fbpgro_playpause'
                , PlayPauseButtonPlayClass: 'fbpgro_play'
                , PermaLinkButtonClass: 'fbpgro_permalink'
                , ShowPager: false
                , PagerClass: 'fbpgro_pager'
                , ShowOverlay: false
                , OverlayClass: 'fbpgro_overlay'
                , OverlayTextWrapperClass: 'fbpgro_textwrapper'
                , OverlayTitleClass: 'fbpgro_title'
                , OverlayDescClass: 'fbpgro_desc'
                , OverlayLinkWrapperClass: 'fbpgro_linkwrapper'
                , OverlayLinkClass: 'fbpgro_link'
                , OverlayUpdateFunction: null
                , OnPreInitFunctions: null
            },

            _AddButtons: false,
            _AddPager: false,
            _AddOverlay: false,

            _destroy: function ()
            {
                $(this.element).find(this.options.RotatorContainerSelector).cycle('destroy');
            },

            _init: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (lRotatorContainer.length !== 1)
                {
                    FBUtilities.LogMessage('RotatorManager._init - incorrect number of rotators found.');
                    return;
                }

                jElement.addClass('fbcmsrotator');
                lRotatorContainer.cycle();
                self._updatePlayPauseButton();
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (lRotatorContainer.length !== 1)
                {
                    FBUtilities.LogMessage('RotatorManager._create - incorrect number of rotators found.');
                    return;
                }

                if (self._initOptions() === false)
                {
                    FBUtilities.LogMessage('RotatorManager._create - options not initialized.');
                    return;
                }

                /*if (FBUtilities.IsStringEmptyOrWhitespace(self.options.PermaLinkUrl))
                {
                    FBUtilities.LogMessage('RotatorManager - required settings null or empty.');
                    return;
                }*/

                self._createButtons(true);
                self._createPager();
                self._createOverlay();
                self._createGeneralEvents(true);
            },

            ReInit: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (lRotatorContainer.length !== 1)
                {
                    FBUtilities.LogMessage('RotatorManager.ReInit - incorrect number of rotators found.');
                    return;
                }

                if (self._initOptions() === false)
                {
                    FBUtilities.LogMessage('RotatorManager.ReInit - options not initialized.');
                    return;
                }

                /*if (FBUtilities.IsStringEmptyOrWhitespace(self.options.PermaLinkUrl))
                {
                    FBUtilities.LogMessage('RotatorManager.ReInit - required settings null or empty.');
                    return;
                }*/

                self._createButtons(false);
                self._createPager();
                self._createOverlay();
                self._createGeneralEvents(false);
            },

            _initOptions: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (lRotatorContainer.length !== 1)
                {
                    FBUtilities.LogMessage('RotatorManager - incorrect number of rotators found.');
                    return false;
                }

                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-permalink')))
                {
                    self.options.PermaLinkUrl = lRotatorContainer.data('fbpgr-permalink');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-title')))
                {
                    self.options.GalleryTitle = lRotatorContainer.data('fbpgr-title');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-showbuttons')))
                {
                    self.options.ShowButtons = lRotatorContainer.data('fbpgr-showbuttons');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-playpausemod')))
                {
                    self.options.ButtonPositionsPlayPauseModifer = lRotatorContainer.data('fbpgr-playpausemod');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-nextprevmod')))
                {
                    self.options.ButtonPositionsNextPrevModifer = lRotatorContainer.data('fbpgr-nextprevmod');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-permalinkmod')))
                {
                    self.options.ButtonPositionsPermaLinkModifer = lRotatorContainer.data('fbpgr-permalinkmod');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-showpager')))
                {
                    self.options.ShowPager = lRotatorContainer.data('fbpgr-showpager');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-pagermod')))
                {
                    self.options.ButtonPositionsPagerModifer = lRotatorContainer.data('fbpgr-pagermod');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-showoverlay')))
                {
                    self.options.ShowOverlay = lRotatorContainer.data('fbpgr-showoverlay');
                }
                if (!FBUtilities.IsStringEmptyOrWhitespace(lRotatorContainer.data('fbpgr-overlayfunc')))
                {
                    self.options.OverlayUpdateFunction = lRotatorContainer.data('fbpgr-overlayfunc');
                }

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.ButtonPositionsPlayPauseModifer)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.ButtonPositionsPermaLinkModifer)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.ButtonPositionsNextPrevModifer)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.ButtonPositionsPagerModifer)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.ButtonClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.PrevButtonClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.NextButtonClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.PlayPauseButtonClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.PlayPauseButtonPlayClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.PermaLinkButtonClass))
                {
                    self._AddButtons = self.options.ShowButtons;
                }

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.PagerClass))
                {
                    self._AddPager = self.options.ShowPager;
                }

                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayTextWrapperClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayTitleClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayDescClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayLinkWrapperClass)
                    && !FBUtilities.IsStringEmptyOrWhitespace(self.options.OverlayLinkClass))
                {
                    self._AddOverlay = self.options.ShowOverlay;
                }

                //initialize the pre-init callbacks list.
                if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.OnPreInitFunctions))
                {
                    //it's null or empty, create it.
                    self.options.OnPreInitFunctions = [];
                }
                else if (
                    self.options.OnPreInitFunctions !== undefined
                    && self.options.OnPreInitFunctions.constructor !== undefined
                    && self.options.OnPreInitFunctions.call !== undefined
                    && self.options.OnPreInitFunctions.apply !== undefined
                ) 
                {
                    //it's a function, add it to the array.
                    var lFunction = self.options.OnPreInitFunctions;
                    self.options.OnPreInitFunctions = [];
                    self.options.OnPreInitFunctions.push(lFunction);
                }
                else if ($.isArray(self.options.OnPreInitFunctions))
                {
                    //it's an array, we can add to it.
                }
                else
                {
                    //dunno what it is. nuke it and create it anew.
                    self.options.OnPreInitFunctions = [];
                }
            },

            _createButtons: function (aIsInitialCreation)
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (self._AddButtons !== true)
                {
                    FBUtilities.LogMessage('RotatorManager - not adding buttons.');
                    return;
                }

                //TODO: cleanup
                /*
                var lPermalinkLabel = '';
                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.GalleryTitle))
                {
                    lPermalinkLabel = ' aria-label="' + self.options.GalleryTitle + '"';
                }

                jElement.append('<a class="' + self.options.ButtonClass + ' ' + self.options.PrevButtonClass + '" href="#">' + self.options.PrevButtonIcon + self.options.PrevButtonContent + '</a>');
                jElement.append('<a class="' + self.options.ButtonClass + ' ' + self.options.NextButtonClass + '" href="#">' + self.options.NextButtonIcon + self.options.NextButtonContent + '</a>');
                jElement.append('<a class="' + self.options.ButtonClass + ' ' + self.options.PlayPauseButtonClass + '" href="#">' + self.options.PlayPauseButtonIconPause + self.options.PlayPauseButtonContentPause + '</a>');
                if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.PermaLinkUrl))
                {
                    jElement.append('<a class="' + self.options.ButtonClass + ' ' + self.options.PermaLinkButtonClass + '" href="' + self.options.PermaLinkUrl + '" ' + lPermalinkLabel + '>' + self.options.PermaLinkButtonIcon + self.options.PermaLinkButtonContent + '</a>');
                }
                */

                if (FBCommon_1_2.isInEditor() === false
                    && aIsInitialCreation === true)
                {
                    self.options.OnPreInitFunctions.push(
                        function (aCycleEvent, aCycleOptions)
                        {
                            jElement.on(
                                "click",
                                '.' + self.options.PrevButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    lRotatorContainer.cycle('prev');
                                    return false;
                                }
                            );
                            jElement.on(
                                "click",
                                '.' + self.options.NextButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    lRotatorContainer.cycle('next');
                                    return false;
                                }
                            );
                            jElement.on(
                                "click",
                                '.' + self.options.PlayPauseButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    var lMyButton = $(aEvent.target).closest('.' + self.options.PlayPauseButtonClass);
                                    if (aCycleOptions.paused === true)
                                    {
                                        lRotatorContainer.cycle('resume');
                                    }
                                    else
                                    {
                                        lRotatorContainer.cycle('pause');
                                    }
                                    self._updatePlayPauseButton();
                                    return false;
                                }
                            );
                        }
                    );
                }

                var lPrevButton = jElement.find('.' + self.options.PrevButtonClass);
                var lNextButton = jElement.find('.' + self.options.NextButtonClass);
                var lPlayPauseButton = jElement.find('.' + self.options.PlayPauseButtonClass);
                var lPermaLinkButton = jElement.find('.' + self.options.PermaLinkButtonClass);

                var lNextPrevHPosition = (self.options.ButtonPositionsNextPrevModifer.indexOf('left') !== -1) === true ? 'left' : 'right';
                var lPlayPauseHPosition = (self.options.ButtonPositionsPlayPauseModifer.indexOf('left') !== -1) === true ? 'left' : 'right';
                var lPermaLinkHPosition = (self.options.ButtonPositionsPermaLinkModifer.indexOf('left') !== -1) === true ? 'left' : 'right';

                var lNextPrevVPosition = (self.options.ButtonPositionsNextPrevModifer.indexOf('upper') !== -1) === true ? 'top' :
                    ((self.options.ButtonPositionsNextPrevModifer.indexOf('lower') !== -1) === true ? 'bottom' : 'middle');
                var lPlayPauseVPosition = (self.options.ButtonPositionsPlayPauseModifer.indexOf('upper') !== -1) === true ? 'top' : 'bottom';
                var lPermaLinkVPosition = (self.options.ButtonPositionsPermaLinkModifer.indexOf('upper') !== -1) === true ? 'top' : 'bottom';

                lPermaLinkButton.css(lPermaLinkVPosition, 0);
                lPlayPauseButton.css(lPlayPauseVPosition, 0);

                if (lNextPrevVPosition === "top"
                    || lNextPrevVPosition === "bottom")
                {
                    lPrevButton.css(lNextPrevVPosition, 0);
                    lNextButton.css(lNextPrevVPosition, 0);
                }
                else
                {
                    lPrevButton.addClass('fbcpgro_over fbcpgro_large');
                    lNextButton.addClass('fbcpgro_over fbcpgro_large');
                }

                // permalink button position.
                var lPLHPosition = 0;
                var lPLBWidth = 0;
                if (lPermaLinkButton.length > 0)
                {
                    lPermaLinkButton.css(lPermaLinkHPosition, lPLHPosition + (lPLHPosition > 0 ? 'px' : ''));
                    lPLBWidth = lPermaLinkButton.width();
                }

                // play/pause button position.
                var lPPHPosition = 0;
                if (lPermaLinkHPosition === lPlayPauseHPosition
                    && lPermaLinkVPosition === lPlayPauseVPosition)
                {
                    lPPHPosition += lPLBWidth;
                }
                lPlayPauseButton.css(lPlayPauseHPosition, lPPHPosition + (lPPHPosition > 0 ? 'px' : ''));

                // next/prev button position.
                if (lNextPrevVPosition.indexOf('top') >= 0
                    || lNextPrevVPosition.indexOf('bottom') >= 0)
                {
                    var lNPHPosition = 0;
                    if (lPermaLinkHPosition === lNextPrevHPosition
                        && lPermaLinkVPosition === lNextPrevVPosition)
                    {
                        lNPHPosition += lPLBWidth;
                    }
                    if (lPlayPauseHPosition === lNextPrevHPosition
                        && lPlayPauseVPosition === lNextPrevVPosition)
                    {
                        lNPHPosition += lPlayPauseButton.width();
                    }
                    if (lNextPrevHPosition.indexOf('right') >= 0)
                    {
                        lNextButton.css(lNextPrevHPosition, lNPHPosition + (lNPHPosition > 0 ? 'px' : ''));
                        lNPHPosition += lNextButton.width();
                        lPrevButton.css(lNextPrevHPosition, lNPHPosition + (lNPHPosition > 0 ? 'px' : ''));
                    }
                    else
                    {
                        lPrevButton.css(lNextPrevHPosition, lNPHPosition + (lNPHPosition > 0 ? 'px' : ''));
                        lNPHPosition += lPrevButton.width();
                        lNextButton.css(lNextPrevHPosition, lNPHPosition + (lNPHPosition > 0 ? 'px' : ''));
                    }
                }
            },

            _createPager: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (self._AddPager !== true)
                {
                    FBUtilities.LogMessage('RotatorManager - not adding pager.');
                    return;
                }

                jElement.append('<div class="' + self.options.PagerClass + '"></div>');

                var lPrevButton = jElement.find('.' + self.options.PrevButtonClass);
                var lNextButton = jElement.find('.' + self.options.NextButtonClass);
                var lPlayPauseButton = jElement.find('.' + self.options.PlayPauseButtonClass);
                var lPermaLinkButton = jElement.find('.' + self.options.PermaLinkButtonClass);
                var lPager = jElement.find('.' + self.options.PagerClass);

                var lPLBWidth = 0;
                if (lPermaLinkButton.length > 0)
                {
                    lPLBWidth = lPermaLinkButton.width();
                }

                var lNextPrevHPosition = (self.options.ButtonPositionsNextPrevModifer.indexOf('left') !== -1) === true ? 'left' : 'right';
                var lPlayPauseHPosition = (self.options.ButtonPositionsPlayPauseModifer.indexOf('left') !== -1) === true ? 'left' : 'right';
                var lPermaLinkHPosition = (self.options.ButtonPositionsPermaLinkModifer.indexOf('left') !== -1) === true ? 'left' : 'right';
                var lPagerHPosition = (self.options.ButtonPositionsPagerModifer.indexOf('left') !== -1) === true ? 'left' :
                    ((self.options.ButtonPositionsPagerModifer.indexOf('right') !== -1) === true ? 'right' : 'center');

                var lNextPrevVPosition = (self.options.ButtonPositionsNextPrevModifer.indexOf('upper') !== -1) === true ? 'top' :
                    ((self.options.ButtonPositionsNextPrevModifer.indexOf('lower') !== -1) === true ? 'bottom' : 'middle');
                var lPlayPauseVPosition = (self.options.ButtonPositionsPlayPauseModifer.indexOf('upper') !== -1) === true ? 'top' : 'bottom';
                var lPermaLinkVPosition = (self.options.ButtonPositionsPermaLinkModifer.indexOf('upper') !== -1) === true ? 'top' : 'bottom';
                var lPagerVPosition = (self.options.ButtonPositionsPagerModifer.indexOf('upper') !== -1) === true ? 'top' : 'bottom';

                lPager.css(lPagerVPosition, 0);

                //pager position.
                var lPHPosition = 0;
                if (lPermaLinkHPosition === lPagerHPosition
                    && lPermaLinkVPosition === lPagerVPosition)
                {
                    lPHPosition += lPLBWidth;
                }
                if (lPlayPauseHPosition === lPagerHPosition
                    && lPlayPauseVPosition === lPagerVPosition)
                {
                    lPHPosition += lPlayPauseButton.width();
                }
                if (lNextPrevHPosition === lPagerHPosition
                    && lNextPrevVPosition === lPagerVPosition)
                {
                    lPHPosition += lNextButton.width();
                    lPHPosition += lPrevButton.width();
                }

                if (lPagerHPosition.indexOf('center') >= 0)
                {
                    lPager.css('left', '50%');
                    lPager.css({ 'transform': 'translate(-50%, 0)' });
                }
                else
                {
                    lPager.css(lPagerHPosition, lPHPosition + (lPHPosition > 0 ? 'px' : ''));
                }
            },

            _createOverlay: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (self._AddOverlay !== true)
                {
                    FBUtilities.LogMessage('RotatorManager - not adding overlay.');
                    return;
                }

                jElement.append('<div class="' + self.options.OverlayClass + '"></div>');

                var lOverlay = jElement.find('.' + self.options.OverlayClass);

                lOverlay.append('<div class="' + self.options.OverlayTextWrapperClass + '"></div>');
                var lTextWrapper = lOverlay.find('.' + self.options.OverlayTextWrapperClass);

                lTextWrapper.append('<div class="' + self.options.OverlayTitleClass + '"></div>');
                lTextWrapper.append('<div class="' + self.options.OverlayDescClass + '"></div>');
            },

            _createGeneralEvents: function (aIsInitialCreation)
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (FBCommon_1_2.isInEditor() === false
                    && aIsInitialCreation === true)
                {
                    self.options.OnPreInitFunctions.push(
                        function (aCycleEvent, aCycleOptions)
                        {
                            jElement.on(
                                "click",
                                '[data-fbpg-url]',
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    var lUrl = $(aEvent.target).data('fbpg-url');
                                    var lTarget = $(aEvent.target).data('fbpg-urltarget');
                                    if (FBUtilities.IsParameterUndefinedOrEmpty(lTarget)
                                        && !FBUtilities.IsParameterUndefinedOrEmpty(lUrl))
                                    {
                                        document.location = lUrl;
                                    }
                                    else if (!FBUtilities.IsParameterUndefinedOrEmpty(lUrl))
                                    {
                                        window.open(
                                            $(aEvent.target).data('fbpg-url'),
                                            $(aEvent.target).data('fbpg-urltarget')
                                        );
                                    }
                                    return false;
                                }
                            );
                        }
                    );
                }

                lRotatorContainer.on(
                    'cycle-pre-initialize',
                    function (aCycleEvent, aCycleOptions)
                    {
                        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.OnPreInitFunctions))
                        {
                            return;
                        }
                        for (var lIndex = 0, lLength = self.options.OnPreInitFunctions.length; lIndex < lLength; lIndex++)
                        {
                            self.options.OnPreInitFunctions[lIndex](aCycleEvent, aCycleOptions);
                        }//endfor
                    }
                );

                lRotatorContainer.on(
                    'cycle-update-view',
                    function (_event, _options, _slideOptions, aCurrentSlideElement)
                    {
                        let slide = $(aCurrentSlideElement);
                        let img = slide.find('img');
                        let title = img.data('fbpg-title');
                        let desc = img.data('fbpg-desc');
                        let url = img.data('fbpg-url');
                        let urlTarget = img.data('fbpg-urltarget');
                        let linkText = img.data('fbpg-linktext');
                        let linkAriaLabel = img.data('fbpg-linkarialabel');

                        if (!FBUtilities.IsParameterUndefinedOrEmpty(self.options.OverlayUpdateFunction))
                        {
                            self.options.OverlayUpdateFunction(jElement, title, desc, url, urlTarget, linkText, linkAriaLabel);
                        }
                        else
                        {
                            self.UpdateRotatorOverlay(title, desc, url, urlTarget, linkText, linkAriaLabel);
                        }
                    }
                );
            },

            _addOverlayLink: function (aLinkText, aUrl, aUrlTarget, aLinkAriaLabel)
            {
                var self = this;
                var jElement = $(self.element);

                var lShowLink = !FBUtilities.IsStringEmptyOrWhitespace(aUrl)
                    && !FBUtilities.IsStringEmptyOrWhitespace(aLinkText);
                if (lShowLink === false)
                {
                    return;
                }

                var lOverlay = jElement.find('.' + self.options.OverlayClass);
                var lTextWrapper = lOverlay.find('.' + self.options.OverlayTextWrapperClass);
                lTextWrapper.append('<div class="' + self.options.OverlayLinkWrapperClass + '"></div>');
                var lLinkWrapper = lOverlay.find('.' + self.options.OverlayLinkWrapperClass);
                lLinkWrapper.append('<a class="' + self.options.OverlayLinkClass + '" href="#"></a>');
                var lLinkElement = lLinkWrapper.find('.' + self.options.OverlayLinkClass);

                lLinkElement.html(aLinkText);
                lLinkElement.attr('href', aUrl);

                if (!FBUtilities.IsStringEmptyOrWhitespace(aUrlTarget) && aUrlTarget !== '_self')
                {
                    lLinkElement.attr('target', aUrlTarget);
                }

                if (!FBUtilities.IsStringEmptyOrWhitespace(aLinkAriaLabel))
                {
                    lLinkElement.attr('aria-label', aLinkAriaLabel);
                }
            },

            _updatePlayPauseButton: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lButton = jElement.find('.' + self.options.PlayPauseButtonClass);
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);
                var lCycleOptions = lRotatorContainer.data('cycle.opts');
                if (lCycleOptions.paused === true)
                {
                    lButton.removeClass(self.options.PlayPauseButtonPlayClass);
                }
                else
                {
                    lButton.addClass(self.options.PlayPauseButtonPlayClass);
                }
            },

            UpdateRotatorOverlay: function (aTitle, aDesc, aUrl, aUrlTarget, aLinkText, aLinkAriaLabel)
            {
                var self = this;
                var jElement = $(self.element);

                var lOverlay = jElement.find('.' + self.options.OverlayClass);

                if (lOverlay.length === 0)
                {
                    return;
                }
                lOverlay.hide();

                if (FBUtilities.IsStringEmptyOrWhitespace(aTitle)
                    && FBUtilities.IsStringEmptyOrWhitespace(aDesc)
                    && (FBUtilities.IsStringEmptyOrWhitespace(aUrl) || FBUtilities.IsStringEmptyOrWhitespace(aLinkText)))
                {
                    return;
                }

                var lTitleElement = lOverlay.find('.' + self.options.OverlayTitleClass);
                var lDescElement = lOverlay.find('.' + self.options.OverlayDescClass);
                var lLinkElement = lOverlay.find('.' + self.options.OverlayLinkClass);

                var lTextWrapElement = lOverlay.find('.' + self.options.OverlayTextWrapperClass);
                var lLinkWrapElement = lOverlay.find('.' + self.options.OverlayLinkWrapperClass);
                lLinkWrapElement.remove();

                var lShowTitle = !FBUtilities.IsStringEmptyOrWhitespace(aTitle);
                var lShowDesc = !FBUtilities.IsStringEmptyOrWhitespace(aDesc);
                var lShowLink = !FBUtilities.IsStringEmptyOrWhitespace(aUrl);

                if (lShowTitle)
                {
                    lTitleElement.html(aTitle);
                }
                if (lShowDesc)
                {
                    lDescElement.html(aDesc);
                }

                if (lShowTitle)
                {
                    lTitleElement.show();
                }
                else
                {
                    lTitleElement.hide();
                }
                if (lShowDesc)
                {
                    lDescElement.show();
                }
                else
                {
                    lDescElement.hide();
                }

                self._addOverlayLink(aLinkText, aUrl, aUrlTarget, aLinkAriaLabel);

                if (lShowTitle
                    || lShowDesc
                    || lShowLink)
                {
                    lOverlay.show();
                }
            }
        });

    // load it on all instances found when the page is loaded.
    $(document).ready(
        function ()
        {
            $.each(
                $('.fbcms_photogallery .fbcms_imagerotator'),
                function (aIndex, aValue)
                {
                    var lSelector = '#' + $(aValue).parent('.fbcms_photogallery').attr('id');
                    $(lSelector).RotatorManager();
                }
            );
            /*
            $.each(
                $('.fbcms_media .fbcms_imagerotator'),
                function (aIndex, aValue)
                {
                    var lSelector = '#' + $(aValue).parent('.fbcms_media').attr('id');
                    $(lSelector).RotatorManager();
                }
            );*/
        }
    );

    // to reinit:
    /*
    if ($('#ElementId').is('.fbcmsrotator'))
    {
        $('#ElementId').RotatorManager('ReInit');
    }
    else
    {
        $('#ElementId').RotatorManager();
    }
    */

})(jQuery);




/*
    SpotlightManager - Foxbright Spotlight Manager
    
    Javascript controller for managing spotlights.
    TODO: update docs

    Options:
    
    PermaLinkUrl                        default: null - must be set when called.
            Required.  The uri location of a permalink for this spotlight gallery.  Since 
            this is required and has no default, it must be set when initializing the 
            manager.
    GalleryTitle                        default: null
            Optional.  A title for the spotlight gallery.
    ContentHeaderSelector               default: '.fbcms_contentheader'
            Required.  Selector indicating the element that is to be used as the content 
            header container.
    ContentFooterSelector               default: '.fbcms_contentfooter'
            Required.  Selector indicating the element that is to be used as the content 
            footer container.
    RotatorContainerSelector            default: '.fbcms_spotlights_list'
            Required.  Selector indicating the element that is to be used as the rotator 
            container.
    ControlsClass                       default: 'fbcms_spotlight_controls'
            Required.  Class to be used for controls container in the header and/or 
            footer.
    ButtonPositionsHeaderModifer        default: 'left' [left|right]
            Optional; Required if any Show*Button* option is true.  Header Controls 
            alignment. 
    ButtonPositionsFooterModifer        default: 'left' [left|right]
            Optional; Required if any Show*Button* option is true.  Footer Controls 
            alignment. 
    ButtonClass                         default: 'spotlight_button'
            Optional; Required if any Show*Button* option is true.  Class to be put on 
            all buttons.
    ShowNextPrevButtons                 default: true
            Optional.  True to show next & previous buttons, false otherwise.
    ButtonPositionsNextPrevModifer      default: 'bottom' [top|bottom|middle|both]
            Optional; Required if ShowNextPrevButtons option is true.  Next & previous 
            button position. 
    PrevButtonClass                     default: 'spotlight_prev'
            Optional; Required if ShowNextPrevButtons is true.  Previous button class.
    PrevButtonIcon                      default: '<span class="fas fa-angle-left" aria-hidden="true"></span>'
            Optional; Required if ShowNextPrevButtons is true.  Previous button icon.
    PrevButtonContent                   default: '<span class="screen-reader-text">Previous</span>'
            Optional; Required if ShowNextPrevButtons is true.  Previous button content.
    NextButtonClass                     default: 'spotlight_next'
            Optional; Required if ShowNextPrevButtons is true.  Next button class.
    NextButtonIcon                      default: '<span class="fas fa-angle-right" aria-hidden="true"></span>'
            Optional; Required if ShowNextPrevButtons is true.  Next button icon.
    NextButtonContent                   default: '<span class="screen-reader-text">Next</span>'
            Optional; Required if ShowNextPrevButtons is true.  Next button content.
    ShowPlayPauseButton                 default: true
            Optional.  True to show play/pause button, false otherwise.
    ButtonPositionsPlayPauseModifer     default: 'bottom' [top|bottom|both]
            Optional; Required if ShowPlayPauseButton option is true.  Play/Pause button 
            position. 
    PlayPauseButtonClass                default: 'spotlight_playpause'
            Optional; Required if ShowPlayPauseButton is true.  Play Pause button class.
    PlayPauseButtonIconPause            default: '<span class="fas fa-pause" aria-hidden="true"></span>'
            Optional; Required if ShowPlayPauseButton is true.  Play Pause button icon when playing.
    PlayPauseButtonContentPause         default: '<span class="screen-reader-text">Pause</span>'
            Optional; Required if ShowPlayPauseButton is true.  Play Pause button content when playing.
    PlayPauseButtonIconPlay             default: '<span class="fas fa-play" aria-hidden="true"></span>'
            Optional; Required if ShowPlayPauseButton is true.  Play Pause button icon when paused.
    PlayPauseButtonContentPlay          default: '<span class="screen-reader-text">Play</span>'
            Optional; Required if ShowPlayPauseButton is true.  Play Pause button content when paused. 
    ShowPager                           default: true
            Optional.  True to show the pager, false otherwise.
    PagerClass                          default: 'fbcms_spotlight_pager'
            Optional; Required if ShowPager or ShowNextPrevButtons is true.  Class to 
            be used for element to contain pager and next/prev classes.
    PagesClass                          default: 'spotlight_pages'
            Optional; Required if ShowPager is true.  Class to be used for the element 
            to contain page buttons.
    ButtonPositionsPagerModifer      default: 'bottom' [top|bottom|both]
            Optional; Required if ShowPager option is true.  Pager position. 
    ShowPermalinkButton                 default: true
            Optional.  True to show Permalink/View All button, false otherwise.
    ButtonPositionsPermaLinkModifer      default: 'bottom' [top|bottom|both]
            Optional; Required if ShowPermalinkButton option is true.  Permalink 
            button position. 
    PermaLinkButtonClass                default: 'spotlight_viewall'
            Optional; Required if ShowPermalinkButton is true.  Permalink button class.
    PermaLinkButtonIcon                 default: ''
            Optional; Required if ShowPermalinkButton is true.  Permalink button icon.
    PermaLinkButtonContent              default: 'View All'
            Optional; Required if ShowPermalinkButton is true.  Permalink button content.
    OnPreInitFunctions                  default: null
            Optional. Functions that may be called upon before initialization of the rotator, 
            but after the markup has been updated by the widget.
            The signature is: function(aCycleEvent, aCycleOptions)
    
    Methods:
    
    The widget is fully functional on its own, but can be remotely activated with the following 
    methods.
        
    Examples:
    
    Since the function is built as a jQuery Widget, simply call the functions on the 
    container element directly.
    
    $('#content_1337').SpotlightManager(
        {
            PermaLinkUrl: '/Core/Gallery/Spotlights/1701/'
        }
    );
*/
(function ($)
{
    $.widget("ui.SpotlightManager",
        {
            options:
            {
                PermaLinkUrl: null
                , GalleryTitle: null
                , ContentHeaderSelector: '.fbcms_contentheader'
                , ContentFooterSelector: '.fbcms_contentfooter'
                , RotatorContainerSelector: '.fbcms_spotlights_list'
                , ControlsClass: 'fbcms_spotlight_controls'
                , ButtonPositionsHeaderModifer: 'left'
                , ButtonPositionsFooterModifer: 'left'
                , ButtonClass: 'spotlight_button'
                , PrevButtonClass: 'spotlight_prev'
                , NextButtonClass: 'spotlight_next'
                , PlayPauseButtonClass: 'spotlight_playpause'
                , PlayPauseButtonPlayClass: 'spotlight_play'
                , PagerClass: 'fbcms_spotlight_pager'
                , PagesClass: 'spotlight_pages'
                , PermaLinkButtonClass: 'spotlight_viewall'
                , OnPreInitFunctions: null
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lAddButtons = false;
                var lAddPager = false;

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.PermaLinkUrl)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.RotatorContainerSelector))
                {
                    FBUtilities.LogMessage('SpotlightManager - required settings null or empty.');
                    return;
                }

                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (lRotatorContainer.length !== 1)
                {
                    FBUtilities.LogMessage('SpotlightManager - incorrect number of rotators found.');
                    return;
                }

                //initialize the pre-init callbacks list.
                if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.OnPreInitFunctions))
                {
                    //it's null or empty, create it.
                    self.options.OnPreInitFunctions = [];
                }
                else if (
                    self.options.OnPreInitFunctions !== undefined
                    && self.options.OnPreInitFunctions.constructor !== undefined
                    && self.options.OnPreInitFunctions.call !== undefined
                    && self.options.OnPreInitFunctions.apply !== undefined
                ) 
                {
                    //it's a function, add it to the array.
                    var lFunction = self.options.OnPreInitFunctions;
                    self.options.OnPreInitFunctions = [];
                    self.options.OnPreInitFunctions.push(lFunction);
                }
                else if ($.isArray(self.options.OnPreInitFunctions))
                {
                    //it's an array, we can add to it.
                }
                else
                {
                    //dunno what it is. nuke it and create it anew.
                    self.options.OnPreInitFunctions = [];
                }

                self._createControls(lAddButtons, lAddPager);

                if (FBCommon_1_2.isInEditor() === false)
                {
                    self.options.OnPreInitFunctions.push(
                        function (aCycleEvent, aCycleOptions)
                        {
                            jElement.on(
                                "click",
                                '[data-fbpg-url]',
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    window.open(
                                        $(aEvent.target).data('fbpg-url'),
                                        $(aEvent.target).data('fbpg-urltarget')
                                    );
                                    return false;
                                }
                            );
                        }
                    );
                }

                lRotatorContainer.on(
                    'cycle-pre-initialize',
                    function (aCycleEvent, aCycleOptions)
                    {
                        if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.OnPreInitFunctions))
                        {
                            return;
                        }
                        for (var lIndex = 0, lLength = self.options.OnPreInitFunctions.length; lIndex < lLength; lIndex++)
                        {
                            self.options.OnPreInitFunctions[lIndex](aCycleEvent, aCycleOptions);
                        }//endfor
                    }
                );

                lRotatorContainer.cycle();
                self._updatePlayPauseButton();
            },

            _createControls: function (aAddButtons, aAddPager)
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);

                if (FBCommon_1_2.isInEditor() === false)
                {
                    self.options.OnPreInitFunctions.push(
                        function (aCycleEvent, aCycleOptions)
                        {
                            jElement.on(
                                "click",
                                '.' + self.options.PrevButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    lRotatorContainer.cycle('prev');
                                    return false;
                                }
                            );
                            jElement.on(
                                "click",
                                '.' + self.options.NextButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    lRotatorContainer.cycle('next');
                                    return false;
                                }
                            );
                            jElement.on(
                                "click",
                                '.' + self.options.PlayPauseButtonClass,
                                function (aEvent)
                                {
                                    aEvent.preventDefault();
                                    if (aCycleOptions.paused === true)
                                    {
                                        lRotatorContainer.cycle('resume');
                                    }
                                    else
                                    {
                                        lRotatorContainer.cycle('pause');
                                    }
                                    self._updatePlayPauseButton();
                                    return false;
                                }
                            );
                        }
                    );
                }
            },

            _updatePlayPauseButton: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lButton = jElement.find('.' + self.options.PlayPauseButtonClass);
                var lRotatorContainer = jElement.find(self.options.RotatorContainerSelector);
                var lCycleOptions = lRotatorContainer.data('cycle.opts');
                if (lCycleOptions.paused === true)
                {
                    lButton.removeClass(self.options.PlayPauseButtonPlayClass);
                }
                else
                {
                    lButton.addClass(self.options.PlayPauseButtonPlayClass);
                }
            }
        });
})(jQuery);


var waitForFinalEvent = (
    function ()
    {
        var timers = {};
        return function (callback, ms, uniqueId)
        {
            if (!uniqueId)
            {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId])
            {
                clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    }
)();

/*
    SpotlistNavManager - Foxbright Spotlist Navigation Manager
    
    Javascript controller for managing spotlights.

    Options:
    
    SliderNavClass                      default: 'fb_audnav'
        Required. Class added to slider content area once the javascript is successfully 
        in place.
    SlideListSelector                   default: '.fbcms_spotlist_items'
        Required. Selector for the list of items.
    SlideSelector                       default: '.fbcms_spotlist_item'
        Required. Selector for the items.
    PositionUnits                       default: 'px'
        Required. Units to use for CSS positioning.
    ActiveSlideClass                    default: 'audnav_active'
        Required. Class to indicate currently selected item.
    SmallTabHeight                      default: 50
        Required. Tab height (width when turned sideways) for small display.
    SmallSlideWidth                     default: 300
        Required. Slide width for small display.
    SmallSizeCutoff                     default: 767
        Required. Size at which the small display ends (inclusive).
    MediumSizeClass                     default: 'audnavmd'
        Required. Class to indicate medium display size.
    MediumTabHeight                     default: 75
        Required. Tab height (width when turned sideways) for medium display.
    MediumSlideWidth                    default: 400
        Required. Slide width for medium display.
    MediumSizeCutoff                    default: 1023
        Required. Size at which the medium display ends (inclusive).
    LargeSizeClass                      default: 'audnavlg'
        Required. Class to indicate large display size.
    LargeTabHeight                      default: 100
        Required. Tab height (width when turned sideways) for large display.
    LargeSlideWidth                     default: 500
        Required. Slide width for large display.
    SlideTitleSelector                  default: '.desc_short'
        Required. Selector for item titles to be rotated on medium and large display.
    
    Methods:
    
    The widget is fully functional on its own, but can be remotely activated with the following 
    methods.
        
    Examples:
    
    Since the function is built as a jQuery Widget, simply call the functions on the 
    container element directly.
    
    $('#content_1337').SpotlistNavManager();
*/
(function ($)
{
    $.widget("ui.SpotlistNavManager",
        {
            options:
            {
                SliderNavClass: 'fb_audnav'
                , SlideListSelector: '.fbcms_spotlist_items'
                , SlideSelector: '.fbcms_spotlist_item'
                , PositionUnits: 'px'
                , ActiveSlideClass: 'audnav_active'
                , SmallTabHeight: 50
                , SmallSlideWidth: 300
                , SmallSizeCutoff: 767
                , MediumSizeClass: 'audnavmd'
                , MediumTabHeight: 75
                , MediumSlideWidth: 400
                , MediumSizeCutoff: 1023
                , LargeSizeClass: 'audnavlg'
                , LargeTabHeight: 100
                , LargeSlideWidth: 500
                , SlideTitleSelector: '.desc_short'
            },

            _slideWidth: null,
            _slideHeight: null,

            _slideTabWidth: null,


            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SliderNavClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SlideListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SlideSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.PositionUnits)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.ActiveSlideClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MediumSizeClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LargeSizeClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.SlideTitleSelector))
                {
                    FBUtilities.LogMessage('SpotlistNavManager - required settings null or empty.');
                    return;
                }

                var lNumSpots = jElement.find(self.options.SlideSelector).length;
                if (lNumSpots < 3)
                {
                    FBUtilities.LogMessage('SpotlistNavManager - too few slides found.');
                    return;
                }

                self._sizeSlideNav();

                jElement.find(self.options.SlideListSelector).on(
                    "mouseover",
                    self.options.SlideSelector,
                    function (aEvent)
                    {
                        self._setSlideNavPositions($(aEvent.target).closest(self.options.SlideSelector).index());
                    }
                );

                jElement.find(self.options.SlideListSelector).on(
                    "click",
                    self.options.SlideSelector,
                    function (aEvent)
                    {
                        var lSlide = $(aEvent.target).closest(self.options.SlideSelector);
                        if (lSlide.hasClass(self.options.ActiveSlideClass) === false)
                        {
                            aEvent.preventDefault();
                            self._setSlideNavPositions(lSlide.index());
                            return false;
                        }
                        else
                        {
                            return true;
                        }
                    }
                );

                self._setSlideNavPositions(0);
                jElement.addClass(self.options.SliderNavClass);

                $(window).resize(
                    function ()
                    {
                        waitForFinalEvent(
                            function ()
                            {
                                self._sizeSlideNav();
                            },
                            500,
                            "resizer"
                        );
                    }
                );
            },

            _sizeSlideNav: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                var lNumSpots = jElement.find(self.options.SlideSelector).length;
                if (lNumSpots < 3)
                {
                    return;
                }

                jElement.removeClass(self.options.MediumSizeClass);
                jElement.removeClass(self.options.LargeSizeClass);
                self._slideHeight = self.options.SmallSlideWidth;
                self._slideTabWidth = self.options.SmallTabHeight;

                var lListWidth = jElement.find(self.options.SlideListSelector).width();

                if ($(window).width() <= self.options.SmallSizeCutoff)
                {
                    jElement.find(self.options.SlideSelector).removeAttr("style");
                    jElement.find(self.options.SlideSelector).find('.desc_short').removeAttr("style");
                    jElement.find(self.options.SlideListSelector).removeAttr("style");
                    return;
                }
                else if ($(window).width() <= self.options.MediumSizeCutoff)
                {
                    self._slideHeight = self.options.MediumSlideWidth;
                    // self._slideTabWidth = self.options.MediumTabHeight;
                    self._slideTabWidth = lListWidth / (lNumSpots + 1);
                    jElement.addClass(self.options.MediumSizeClass);
                }
                else
                {
                    self._slideHeight = self.options.LargeSlideWidth;
                    // self._slideTabWidth = self.options.LargeTabHeight;
                    self._slideTabWidth = lListWidth / (lNumSpots + 1);
                    jElement.addClass(self.options.LargeSizeClass);
                }

                self._slideWidth = jElement.find(self.options.SlideSelector).width();

                $.each(
                    jElement.find(self.options.SlideSelector),
                    function (aIndex, aValue)
                    {
                        var lValue = $(aValue);
                        lValue.css('background-image', 'url("' + $(aValue).data('spotimgsrc') + '")');
                    }
                );

                self._slideWidth = self._slideTabWidth * 2;
                // self._slideWidth = lListWidth - (lNumSpots - 1) * self._slideTabWidth;
                jElement.find(self.options.SlideSelector).css('width', self._slideWidth + self.options.PositionUnits);
                jElement.find(self.options.SlideSelector).find(self.options.SlideTitleSelector).css('width', self._slideHeight + self.options.PositionUnits);
                jElement.find(self.options.SlideSelector).find(self.options.SlideTitleSelector).css('transform-origin', (self._slideHeight / 2) + self.options.PositionUnits + ' ' + (self._slideHeight / 2) + self.options.PositionUnits);
                jElement.find(self.options.SlideListSelector).css('height', self._slideHeight + self.options.PositionUnits);

                self._setSlideNavPositions(jElement.find(self.options.SlideSelector + '.' + self.options.ActiveSlideClass).index());
            },

            _setSlideNavPositions: function (aActiveIndex)
            {
                var self = this;
                var jElement = $(self.element);
                var lElementId = $(jElement).attr('id');

                $.each(
                    jElement.find(self.options.SlideSelector),
                    function (aIndex, aValue)
                    {
                        var lValue = $(aValue);
                        var lLeftPositionVal = (aIndex * self._slideTabWidth);
                        if (aActiveIndex === aIndex)
                        {
                            lValue.addClass(self.options.ActiveSlideClass);
                            lValue.find(self.options.SlideTitleSelector).css('width', 'auto');
                        }
                        else
                        {
                            lValue.removeClass(self.options.ActiveSlideClass);
                            lValue.find(self.options.SlideTitleSelector).css('width', self._slideHeight + self.options.PositionUnits);
                        }
                        if (aIndex > aActiveIndex)
                        {
                            lLeftPositionVal += (self._slideWidth - self._slideTabWidth);
                        }
                        lValue.css('left', (lLeftPositionVal + self.options.PositionUnits));
                    }
                );
            }
        });
})(jQuery);


///////////////////////////////////////////////////////////////////////////////
// IFrame Video Resizer
///////////////////////////////////////////////////////////////////////////////

(function ($)
{
    VideoUtilities.SetupVideoResizer = function (aSelector)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aSelector))
        {
            return;
        }

        var lAllContainerElements = $(aSelector);
        if (lAllContainerElements.length === 0)
        {
            return;
        }

        // Find all Videos (YouTube/Vimeo)
        var lAllVideos = lAllContainerElements.find("iframe[src^='//www.youtube.com'], iframe[src^='//player.vimeo.com']");

        if (lAllVideos.length === 0)
        {
            return;
        }

        // Figure out and save aspect ratio for each video
        lAllVideos.each(
            function ()
            {
                $(this)
                    .data('aspectRatio', this.height / this.width)
                    // and remove the hard coded width/height
                    .removeAttr('height')
                    .removeAttr('width');
            }
        );

        // When the window is resized
        $(window).resize(
            function ()
            {
                // Resize all videos according to their own aspect ratio
                lAllVideos.each(
                    function ()
                    {
                        var $el = $(this);
                        var lNewWidth = $el.parent().width();
                        $el
                            .width(lNewWidth)
                            .height(lNewWidth * $el.data('aspectRatio'));

                    }
                );
                // Kick off one resize to fix all videos on page load
            }
        ).resize();
    }; //end SetupVideoResizer

}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// Email Icon Hover/Focus Event
///////////////////////////////////////////////////////////////////////////////

(function ($)
{

    $(
        function () 
        {
            var _EmailLinkClass = 'contact_button';
            var _EmailIconClass = 'fb_emailicon';
            //at rest: far fa-envelope
            //active:  fas fa-envelope
            var _EmailAtRestClass = 'far';
            var _EmailActiveClass = 'fas';

            function _ResetEmailIcons()
            {
                $('.' + _EmailIconClass).removeClass(_EmailActiveClass);
                $('.' + _EmailIconClass).addClass(_EmailAtRestClass);
            }

            function _ActivateEmailIcon(aElement)
            {
                if (FBUtilities.IsParameterUndefinedOrEmpty(aElement))
                {
                    return;
                }
                aElement.removeClass(_EmailAtRestClass);
                aElement.addClass(_EmailActiveClass);
            }

            $('body').on(
                'focusin mouseover',
                '.' + _EmailLinkClass,
                function (aEvent)
                {
                    _ResetEmailIcons();
                    _ActivateEmailIcon($(aEvent.target).closest('.' + _EmailLinkClass).find('.' + _EmailIconClass));
                }
            );

            $('body').on(
                'focusout mouseout',
                '.' + _EmailLinkClass,
                function (aEvent)
                {
                    if (!$(aEvent.target).hasClass(_EmailLinkClass))
                    {
                        //return false;
                    }
                    _ResetEmailIcons();
                }
            );
        }
    );

}(jQuery));

///////////////////////////////////////////////////////////////////////////////
// Foxbright Lightbox Manager
///////////////////////////////////////////////////////////////////////////////
/*
(function ($)
{
    FBLightbox._Initialized = false;

    FBLightbox.Init = function ()
    {
        if (FBUtilities.IsParameterUndefinedOrEmpty(window.lightbox))
        {
            return;
        }
        if (FBLightbox._Initialized === false)
        {
            window.lightbox.init();
            FBLightbox._Initialized = true;
        }
    }; //end Init

}(jQuery));
*/

(function ($)
{
    var quickAjaxTemplate = "<div id=\"QuickAjaxDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"staticBackdrop\" aria-hidden=\"true\"> \
        <div class=\"modal-dialog modal-dialog-centered\" role=\"document\"> \
            <div class=\"modal-content\"> \
                <div class=\"modal-header\" \> \
            <h5 class=\"modal-title\" id=\"QuickAjaxDialogTitle\">Checking the building name.</h5> \
                </div> \
                <div class=\"modal-body\"> \
                    <div class=\"progress\" > \
                        <div class=\"progress-bar progress-bar-striped progress-bar-animated bg-danger\" role=\"progressbar\" style=\"width: 100%\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div> \
                    </div> \
                </div> \
            </div> \
        </div> \
    </div>";

    /**
     * FBQuickAjax.Async
     * Creates a promise object that will post a simple ajax request to a remote ajax service. 
     * @param {
     *      url: [the posting url of the ajax service],
     *      timeout: [milliseconds to wait before giving up on the ajax request],
     *      title: [a short title for progress dialog],
     *      data: [some data to post to the posting url]
     * } options
     * @returns Promise object.
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise
     */
    FBQuickAjax.Async = function (options)
    {
        return new Promise(function (resolutionFunc, rejectionFunc)
        {
            $("#QuickAjaxDialog").remove();

            var $dialog = $(quickAjaxTemplate);

            $dialog.find(".modal-title").html(options.title);
            $("body").prepend($dialog);

            $("#QuickAjaxDialog").off('shown.bs.modal').on('shown.bs.modal', function ()
            {
                $.ajax({
                    type: options.method || "post",
                    url: options.url,
                    timeout: options.timeout,
                    dataType: "json",
                    async: true,
                    data: options.data,
                    error: function (_jqXHR, textStatus, errorThrown) 
                    {
                        console.debug(`${textStatus}: ${errorThrown}`);
                        rejectionFunc(textStatus);
                    },
                    success: function (data, _textStatus, _jqXHR) 
                    {
                        resolutionFunc(data);
                    },
                    complete: function ()
                    {
                        $("#QuickAjaxDialog").modal("hide");
                    }
                });
            });
            $("#QuickAjaxDialog").modal('show');
        });
    }

}(jQuery));


// Manages any in-page changes of the url in the address bar.
var FBUrlManager =
{
    CURRENTSTATEIDENTIFIER: 'CurrentUrlManagerState',
    _CallbackSets: {},
    _SpecifiedDefaults: {},

    // initialize. Sets up a listener to run the callbacks upon a 'back' press in the browser.
    init: function ()
    {
        window.addEventListener(
            'popstate',
            (event) => 
                {
                    FBUrlManager._runCallbacks('OnAddressBarUpdate', document.location);
                }
        );
    },
    // sets a default for a parameter. Setting a value matching this default for the parameter will remove the parameter from the url.
    setParameterDefault: function (aParamName, aDefault)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aParamName))
        {
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._SpecifiedDefaults))
        {
            return;
        }

        let lParamName = FBUrlManager._getNormalizedParamName(aParamName);
        
        // create or overwrite.
        FBUrlManager._SpecifiedDefaults[lParamName] = aDefault;
    },
    // removes a parameter default.
    removeParameterDefault: function (aParamName)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aParamName))
        {
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._SpecifiedDefaults))
        {
            return;
        }

        let lParamName = FBUrlManager._getNormalizedParamName(aParamName);
        
        if (FBUtilities.IsParameterUndefinedOrNull(FBUrlManager._SpecifiedDefaults[lParamName]))
        {
            return;
        }
        delete FBUrlManager._SpecifiedDefaults[lParamName];
    },
    // update the address bar with the given parameter name and value.
    updateAddressBar: function (aParamName, aValue)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aParamName))
        {
            return;
        }
        let lNewAddress = FBUrlManager._getUpdatedUrl(aParamName, aValue);
        
        window.history.replaceState(FBUrlManager.CURRENTSTATEIDENTIFIER, "", lNewAddress);

        FBUrlManager._runCallbacks('OnAddressBarUpdate', lNewAddress);
    },
    // add a set of callbacks by an arbitrary name (for use if you wish to remove them at any point)
    //  available callbacks:
    //   'OnAddressBarUpdate' this will be run after an update and also if 'back' is used to navigate.
    //     it will have one parameter: the new url as set in the address bar.
    addCallbackSet: function (aName, aCallbackSet)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aName))
        {
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._CallbackSets))
        {
            return;
        }

        let lName = FBUrlManager._getNormalizedParamName(aName);
        
        // create or overwrite.
        FBUrlManager._CallbackSets[lName] = aCallbackSet;
    },
    // remove a set of callbacks by name.
    removeCallbackSet: function (aName)
    {
        if (FBUtilities.IsStringEmptyOrWhitespace(aName))
        {
            return;
        }
        if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._CallbackSets))
        {
            return;
        }

        let lName = FBUrlManager._getNormalizedParamName(aName);
        
        if (FBUtilities.IsParameterUndefinedOrNull(FBUrlManager._CallbackSets[lName]))
        {
            return;
        }
        delete FBUrlManager._CallbackSets[lName];
    },
    // worker method: runs the callback specified in each set of callbacks.
    _runCallbacks: function (aCallbackName, aNewAddress)
    {
        for(var lKey in FBUrlManager._CallbackSets)
        {
            FBUtilities.RunCallback(FBUrlManager._CallbackSets[lKey], aCallbackName, aNewAddress);
        }//endfor
    },
    // worker method: performs an desired normalization on the parameter name.
    _getNormalizedParamName: function(aParamName)
    {
        return aParamName;
    },
    // worker method: given a parameter name and value, returns the current address bar url updated with the new parameters.
    _getUpdatedUrl: function(aParamName, aValue)
    {
        let lProtocol = window.location.protocol;
        let lHost = window.location.host;
        let lPathName = window.location.pathname;
        let lSearch = FBUrlManager._getUpdatedSearch(window.location.search, aParamName, aValue);
        let lHash = window.location.hash;
        let lNewUrl = new URL(`${lProtocol}${lHost}${lPathName}${lSearch}${lHash}`);
        return lNewUrl.toString();
    },
    // worker method: given an address query component and parameter name and value, builds a new search query (with leading '?') for use.
    _getUpdatedSearch: function(aExistingQuery, aParamName, aValue)
    {
        let searchParams = new URLSearchParams(aExistingQuery);

        if (searchParams.has(aParamName))
        {
            if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._SpecifiedDefaults[aParamName])
                || FBUrlManager._SpecifiedDefaults[aParamName] !== aValue)
            {
                searchParams.set(aParamName, aValue);
            }
            else if (FBUrlManager._SpecifiedDefaults[aParamName] === aValue)
            {
                searchParams.delete(aParamName);
            }
        }
        else
        {
            if (FBUtilities.IsParameterUndefinedOrEmpty(FBUrlManager._SpecifiedDefaults[aParamName])
                || FBUrlManager._SpecifiedDefaults[aParamName] !== aValue)
            {
                searchParams.append(aParamName, aValue);
            }
        }
        let newSearch = searchParams.toString();
        if (FBUtilities.IsParameterUndefinedOrEmpty(newSearch) === false)
        {
            newSearch = '?' + newSearch;
        }
        return newSearch;
    }

}//end FBUrlManager
// initialize it! It's OK if it's up before the page, needs to be ready for any default or callback submissions.
FBUrlManager.init();


///////////////////////////////////////////////////////////////////////////////
// Foxbright Translate Menu
(function ($) 
{
    $(
        function() 
        {
            // if a translate menu exists...
            if ($('.menu_translate').length > 0)
            {
                // add a named callback set...
                // 'OnAddressBarUpdate' - update any links in the menu that have a valid url with the google translate parameters with the new url.
                FBUrlManager.addCallbackSet(
                    'FoxbrightTranslateMenu',
                    {
                        'OnAddressBarUpdate': function (aNewUrl)
                        {
                            $.each($('.menu_translate a'), function (aIndex, aValue)
                            {
                                let lAnchor = $(aValue);
                                let lAnchorHref = lAnchor.attr('href');
                                let lAnchorUrl = null;
                                try
                                {
                                    lAnchorUrl = new URL(lAnchorHref);
                                }
                                catch (_)
                                {
                                    return;
                                }
                                if (lAnchorUrl.searchParams.has('u') === false
                                    || lAnchorUrl.searchParams.has('tl') === false)
                                {
                                    return;
                                }
                                lAnchorUrl.searchParams.set('u', aNewUrl);
                                lAnchor.attr('href', lAnchorUrl.toString());
                            });
                        }
                    }
                );
            }
        }
    );
}(jQuery));  // END JQUERY WRAPPER (Foxbright Translate Menu)
///////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////
// Foxbright Drop Widget
(function ($) 
{
    
    /*
        FBDropWidget - (Generic Drop derived from FBRListNav)
        - Foxbright Drop
        
        Javascript controller for the responsive simple drop that pops up upon command.  
        Derived from FBRListNav to avoid reinventing the drop.
        
        Options:
        
        DropClass                           default: 'fbcms_drop'
                Required.  A class to be added to the drop once the widget has successfully 
                completed. Change this at your peril.
        DropOpenClass                       default: 'dropopen'
                Required.  A class to indicate when the drop is open, to be added or removed 
                by the widget as appropriate.
        DropTitleClass                      default: null
                Required.  A class selector for finding the title element of the drop in the 
                drop element.  If the drop title is empty, the widget will do nothing.
        DropTitleAuxClass                      default: 'drop_title'
                Required.  A class to be added to the title once the widget has successfully
                complete. Change this at your peril.
        AddOpenButton                       default: false
                If true, add a button to the drop title with events to open and close the 
                drop. If true, OpenButtonClass, OpenDropContent, and CloseDropContent are 
                all required.
        OpenButtonClass                     default: 'drop_opener'
                Required if AddOpenButton is true.  A class used to identify the button added 
                to the drop title.
        OpenDropContent                     default: '<span class="fas fa-chevron-down"></span>'
                Required if AddOpenButton is true.  Content to appear in the drop button when 
                the drop is closed and may be opened.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Open {Drop Title} Drop</span>
        CloseDropContent                    default: '<span class="fas fa-chevron-up"></span>'
                Required if AddOpenButton is true.  Content to appear in the drop button when 
                the drop is open and may be closed.
                Whatever content is put into place, the following content is added afterward.
                <span class="screen-reader-text">Close {Drop Title} Drop</span>
        DropContainerClass                  default: null
                Required.  A class that should be found in the markup on the element wrapping 
                the drop.
        DropContainerClass                  default: 'drop_container'
                Required.  A class to be added to the container once the widget has successfully
                complete. Change this at your peril.
        InitOpen                            default: false
                If true, the drop will initialize open.
        DropClickActive                     default: true
                If true, the drop button will be activated on mouse click events.
        DropHoverActive                     default: false
                If true, the drop button will be activated on mouse hover events, closing on 
                hover out after a delay (DropHoverDelay) if not hovered over in that time.
        DropHoverDelay                      default: 300
                A hover delay for use if the DropHoverActive is true.
        
        Methods:
        
        The widget is fully functional on its own, but can be remotely activated with the following 
        methods.
        
        ToggleDrop
                Called to toggle the drop open or closed.
        OpenDrop
                Called to open the drop (or do nothing if the drop is already open).
        CloseDrop
                Called to close the drop (or do nothing if the drop is already closed).
        
        Examples:
        
        Since the function is built as a jQuery Widget, simply call the functions on the 
        container element directly.
        
        $('.fbcms_translate').FBDropWidget(
            {
                DropTitleClass: 'translatedrop_title'
                , DropContainerClass: 'translatedrop_container'
            }
        );
    */
    $.widget("ui.FBDropWidget",
        {
            options:
            {
                DropClass: 'fbcms_drop' 
                , DropOpenClass: 'dropopen'
                , DropTitleClass: null 
                , DropTitleAuxClass: 'drop_title' 
                , AddOpenButton: false
                , OpenButtonClass: 'drop_opener'
                , DropButtonOpenContent: '<span class="drop_icon fas fa-chevron-down"></span>'
                , DropButtonCloseContent: '<span class="drop_icon fas fa-chevron-up"></span>'
                , DropContainerClass: null 
                , DropContainerAuxClass: 'drop_container' 
                , InitOpen: false
                , DropClickActive: true
                , DropHoverActive: false
                , DropHoverDelay: 300
            },

            _hoverTimer: null,

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.DropClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropOpenClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropTitleClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropTitleAuxClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropContainerClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropContainerAuxClass))
                {
                    FBUtilities.LogMessage('FBDropWidget - required settings null or empty.');
                    return;
                }

                if (self.options.AddOpenButton === true
                    && (FBUtilities.IsStringEmptyOrWhitespace(self.options.OpenButtonClass)
                        || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropButtonOpenContent)
                        || FBUtilities.IsStringEmptyOrWhitespace(self.options.DropButtonCloseContent)))
                {
                    FBUtilities.LogMessage('FBDropWidget - open button settings not set as requested.');
                    return;
                }

                let lTitleElement = jElement.find(`.${self.options.DropTitleClass}`);
                let lContainerElement = jElement.find(`.${self.options.DropContainerClass}`);

                if (lTitleElement.length === 0)
                {
                    FBUtilities.LogMessage('FBDropWidget - drop title not found.');
                    return;
                }
                if (lContainerElement.length === 0)
                {
                    FBUtilities.LogMessage('FBDropWidget - drop container not found.');
                    return;
                }
                lTitleElement.attr("aria-expanded", false);

                self._DropTitle = lTitleElement.text();
                
                if (self.options.AddOpenButton === true)
                {
                    lTitleElement.append('<span class="' + self.options.OpenButtonClass + '"></span>');
                    self._setOpenButtonContent();
                }

                let lButtonEventSelector = '.' + self.options.DropTitleClass;
                if (self.options.AddOpenButton === true)
                {
                    lButtonEventSelector = lButtonEventSelector + ',.' + self.options.OpenButtonClass;
                }

                if (self.options.DropClickActive === true)
                {
                    jElement.on(
                        'click',
                        lButtonEventSelector,
                        function (aEvent) 
                        {
                            aEvent.preventDefault();
                            self.ToggleDrop();
                            return false;
                        }
                    );
                    jElement.on(
                        'keyup',
                        lButtonEventSelector,
                        function (aEvent) 
                        {
							if(aEvent.which == 13)
							{
								aEvent.preventDefault();
								self.ToggleDrop();
								return false;
							}
							return true;
                        }
                    );
				}
				
                if (self.options.DropHoverActive === true)
                {
                    jElement.hover(
                        function ()
                        {
                            self.OpenDrop();

                            if (self._hoverTimer !== null)
                            {
                                $.clearTimer(self._hoverTimer);
                            }
                        }
                        , function ()
                        {
                            self._hoverTimer = $.timer(
                                self.options.DropHoverDelay,
                                function ()
                                {
                                    self.CloseDrop();
                                }
                            );
                        }
                    );
                }

                if (self.options.InitOpen)
                {
                    self.OpenDrop();
                }

                jElement.DropFocusManager(
                    {
                        HoverFocusClass: self.options.DropOpenClass
                        , OpenOnHoverFocus: false
                        , TitleOpenerSelector: '.' + self.options.DropTitleClass
                        , DropLinksSelector: '.' + self.options.DropContainerClass + ' :focusable'
                    }
                );

                jElement.addClass(self.options.DropClass);
                lTitleElement.addClass(self.options.DropTitleAuxClass);
                lContainerElement.addClass(self.options.DropContainerAuxClass);
            },

            _DropTitle: null,

            ToggleDrop: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.toggleClass(self.options.DropOpenClass);
                jElement.find(`.${self.options.DropTitleClass}`).attr("aria-expanded", jElement.hasClass(self.options.DropOpenClass));

                self._setOpenButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBDropWidget:ToggleDrop' } }));
            },

            OpenDrop: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.addClass(self.options.DropOpenClass);
                jElement.find(`.${self.options.DropTitleClass}`).attr("aria-expanded", true);
                
                self._setOpenButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBDropWidget:OpenDrop' } }));
            },

            CloseDrop: function ()
            {
                var self = this,
                    jElement = $(self.element);

                jElement.removeClass(self.options.DropOpenClass);
                jElement.find(`.${self.options.DropTitleClass}`).attr("aria-expanded", false);
                
                self._setOpenButtonContent();
                self.element[0].dispatchEvent(new CustomEvent('fb:changevisibility', { bubbles: true, detail: { item: jElement, name: 'FBDropWidget:CloseDrop' } }));
            },

            _setOpenButtonContent: function ()
            {
                var self = this,
                    jElement = $(self.element),
                    lOpenButton;

                if (self.options.AddOpenButton === true)
                {
                    lOpenButton = jElement.find('.' + self.options.OpenButtonClass);

                    if (jElement.is('.' + self.options.DropOpenClass))
                    {
                        lOpenButton.html(self.options.DropButtonCloseContent + '<span class="screen-reader-text">Close ' + self._DropTitle + ' Drop</span>');
                    }
                    else
                    {
                        lOpenButton.html(self.options.DropButtonOpenContent + '<span class="screen-reader-text">Open ' + self._DropTitle + ' Drop</span>');
                    }
                }
            }

        }
    );
    
    
    FBUtilities.initTranslateWidget = function (aElement, aOnInitializedCallback)
    {
        if ($(aElement).FBDropWidget("instance") !== undefined)
        {
            $(aElement).FBDropWidget("destroy");
        }

        $(aElement).FBDropWidget(
            {
                DropTitleClass: 'translatedrop_title'
                , DropContainerClass: 'translatedrop_container'
            }
        );

        aOnInitializedCallback(aElement);
    };
}(jQuery));  // END JQUERY WRAPPER (Foxbright Drop Widget)
///////////////////////////////////////////////////////////////////////////////


(function ($)
{
    $(window).on('load', function ()
    {
        FBUtilities.initializeLoadables(document);
    });

    FBUtilities.initializeLoadables = function (containerElement)
    {
        if (containerElement === null)
        {
            return;
        }
        containerElement.querySelectorAll("[data-fbonload]").forEach(
            function (element)
            {
                FBUtilities.initializeLoadable(element);
            }
        );
    }

    FBUtilities.initializeLoadable = function (aLoadableElement)
    {
        if (!aLoadableElement.dataset.hasOwnProperty('fbonload'))
        {
            return;
        }

        if (aLoadableElement.dataset.hasOwnProperty('fbInitState')
            && aLoadableElement.dataset.fbInitState !== "new")
        {
            return;
        }
                
        var func = aLoadableElement.dataset.fbonload;
        if (typeof FBUtilities[func] !== 'undefined'
            && typeof FBUtilities[func] === 'function')
        {
            FBUtilities[func](aLoadableElement, FBUtilities.onLoadableInitialized);
        }
        else
        {
            console.log(`Function '${func}' not found!`);
        }
    }

    FBUtilities.onLoadableInitialized = function (aElement)
    {
        // must set to initialized once complete.
        aElement.dataset.fbInitState = "complete";
    }
}(jQuery));  // END JQUERY WRAPPER (Initialize Loadables)


///////////////////////////////////////////////////////////////////////////////
// Metronic Integrated "Fancy" Labels
(function ($) 
{
    function updateFancyInputField(aField, aHasFocus)
    {
        let parent = $(aField).parent();
        let hasWrapper = parent.hasClass('selectfolder') && parent.hasClass('input-group');
        let wrapper = hasWrapper ? $(aField).parent() : aField;
        if (aHasFocus === true || FBUtilities.IsParameterUndefinedOrEmpty(aField.val()) === false)
        {
            wrapper.addClass('notempty');
        }
        else
        {
            wrapper.removeClass('notempty');
        }
    }//end updateFancyInputField

    FBUtilities.initFancyInputField = function (aElement, aOnInitializedCallback)
    {
        let element = $(aElement);
        let normalInput = element.find('.form-control,.vp-input');
        normalInput.on('focus blur change',
            function(e)
            {
                updateFancyInputField($(e.target), e.type === 'focus');
            }
        );

        updateFancyInputField(normalInput, false);

        aOnInitializedCallback(aElement);
    };
}(jQuery));  // END JQUERY WRAPPER (Metronic Integrated "Fancy" Labels)
///////////////////////////////////////////////////////////////////////////////


//
// BEGIN LATINIZE
// Thanks to https://stackoverflow.com/questions/286921/efficiently-replace-all-accented-characters-in-a-string
//

var Latinise = {}; Latinise.latin_map = {
    "Á": "A",
    "Ă": "A",
    "Ắ": "A",
    "Ặ": "A",
    "Ằ": "A",
    "Ẳ": "A",
    "Ẵ": "A",
    "Ǎ": "A",
    "Â": "A",
    "Ấ": "A",
    "Ậ": "A",
    "Ầ": "A",
    "Ẩ": "A",
    "Ẫ": "A",
    "Ä": "A",
    "Ǟ": "A",
    "Ȧ": "A",
    "Ǡ": "A",
    "Ạ": "A",
    "Ȁ": "A",
    "À": "A",
    "Ả": "A",
    "Ȃ": "A",
    "Ā": "A",
    "Ą": "A",
    "Å": "A",
    "Ǻ": "A",
    "Ḁ": "A",
    "Ⱥ": "A",
    "Ã": "A",
    "Ꜳ": "AA",
    "Æ": "AE",
    "Ǽ": "AE",
    "Ǣ": "AE",
    "Ꜵ": "AO",
    "Ꜷ": "AU",
    "Ꜹ": "AV",
    "Ꜻ": "AV",
    "Ꜽ": "AY",
    "Ḃ": "B",
    "Ḅ": "B",
    "Ɓ": "B",
    "Ḇ": "B",
    "Ƀ": "B",
    "Ƃ": "B",
    "Ć": "C",
    "Č": "C",
    "Ç": "C",
    "Ḉ": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Ƈ": "C",
    "Ȼ": "C",
    "Ď": "D",
    "Ḑ": "D",
    "Ḓ": "D",
    "Ḋ": "D",
    "Ḍ": "D",
    "Ɗ": "D",
    "Ḏ": "D",
    "ǲ": "D",
    "ǅ": "D",
    "Đ": "D",
    "Ƌ": "D",
    "Ǳ": "DZ",
    "Ǆ": "DZ",
    "É": "E",
    "Ĕ": "E",
    "Ě": "E",
    "Ȩ": "E",
    "Ḝ": "E",
    "Ê": "E",
    "Ế": "E",
    "Ệ": "E",
    "Ề": "E",
    "Ể": "E",
    "Ễ": "E",
    "Ḙ": "E",
    "Ë": "E",
    "Ė": "E",
    "Ẹ": "E",
    "Ȅ": "E",
    "È": "E",
    "Ẻ": "E",
    "Ȇ": "E",
    "Ē": "E",
    "Ḗ": "E",
    "Ḕ": "E",
    "Ę": "E",
    "Ɇ": "E",
    "Ẽ": "E",
    "Ḛ": "E",
    "Ꝫ": "ET",
    "Ḟ": "F",
    "Ƒ": "F",
    "Ǵ": "G",
    "Ğ": "G",
    "Ǧ": "G",
    "Ģ": "G",
    "Ĝ": "G",
    "Ġ": "G",
    "Ɠ": "G",
    "Ḡ": "G",
    "Ǥ": "G",
    "Ḫ": "H",
    "Ȟ": "H",
    "Ḩ": "H",
    "Ĥ": "H",
    "Ⱨ": "H",
    "Ḧ": "H",
    "Ḣ": "H",
    "Ḥ": "H",
    "Ħ": "H",
    "Í": "I",
    "Ĭ": "I",
    "Ǐ": "I",
    "Î": "I",
    "Ï": "I",
    "Ḯ": "I",
    "İ": "I",
    "Ị": "I",
    "Ȉ": "I",
    "Ì": "I",
    "Ỉ": "I",
    "Ȋ": "I",
    "Ī": "I",
    "Į": "I",
    "Ɨ": "I",
    "Ĩ": "I",
    "Ḭ": "I",
    "Ꝺ": "D",
    "Ꝼ": "F",
    "Ᵹ": "G",
    "Ꞃ": "R",
    "Ꞅ": "S",
    "Ꞇ": "T",
    "Ꝭ": "IS",
    "Ĵ": "J",
    "Ɉ": "J",
    "Ḱ": "K",
    "Ǩ": "K",
    "Ķ": "K",
    "Ⱪ": "K",
    "Ꝃ": "K",
    "Ḳ": "K",
    "Ƙ": "K",
    "Ḵ": "K",
    "Ꝁ": "K",
    "Ꝅ": "K",
    "Ĺ": "L",
    "Ƚ": "L",
    "Ľ": "L",
    "Ļ": "L",
    "Ḽ": "L",
    "Ḷ": "L",
    "Ḹ": "L",
    "Ⱡ": "L",
    "Ꝉ": "L",
    "Ḻ": "L",
    "Ŀ": "L",
    "Ɫ": "L",
    "ǈ": "L",
    "Ł": "L",
    "Ǉ": "LJ",
    "Ḿ": "M",
    "Ṁ": "M",
    "Ṃ": "M",
    "Ɱ": "M",
    "Ń": "N",
    "Ň": "N",
    "Ņ": "N",
    "Ṋ": "N",
    "Ṅ": "N",
    "Ṇ": "N",
    "Ǹ": "N",
    "Ɲ": "N",
    "Ṉ": "N",
    "Ƞ": "N",
    "ǋ": "N",
    "Ñ": "N",
    "Ǌ": "NJ",
    "Ó": "O",
    "Ŏ": "O",
    "Ǒ": "O",
    "Ô": "O",
    "Ố": "O",
    "Ộ": "O",
    "Ồ": "O",
    "Ổ": "O",
    "Ỗ": "O",
    "Ö": "O",
    "Ȫ": "O",
    "Ȯ": "O",
    "Ȱ": "O",
    "Ọ": "O",
    "Ő": "O",
    "Ȍ": "O",
    "Ò": "O",
    "Ỏ": "O",
    "Ơ": "O",
    "Ớ": "O",
    "Ợ": "O",
    "Ờ": "O",
    "Ở": "O",
    "Ỡ": "O",
    "Ȏ": "O",
    "Ꝋ": "O",
    "Ꝍ": "O",
    "Ō": "O",
    "Ṓ": "O",
    "Ṑ": "O",
    "Ɵ": "O",
    "Ǫ": "O",
    "Ǭ": "O",
    "Ø": "O",
    "Ǿ": "O",
    "Õ": "O",
    "Ṍ": "O",
    "Ṏ": "O",
    "Ȭ": "O",
    "Ƣ": "OI",
    "Ꝏ": "OO",
    "Ɛ": "E",
    "Ɔ": "O",
    "Ȣ": "OU",
    "Ṕ": "P",
    "Ṗ": "P",
    "Ꝓ": "P",
    "Ƥ": "P",
    "Ꝕ": "P",
    "Ᵽ": "P",
    "Ꝑ": "P",
    "Ꝙ": "Q",
    "Ꝗ": "Q",
    "Ŕ": "R",
    "Ř": "R",
    "Ŗ": "R",
    "Ṙ": "R",
    "Ṛ": "R",
    "Ṝ": "R",
    "Ȑ": "R",
    "Ȓ": "R",
    "Ṟ": "R",
    "Ɍ": "R",
    "Ɽ": "R",
    "Ꜿ": "C",
    "Ǝ": "E",
    "Ś": "S",
    "Ṥ": "S",
    "Š": "S",
    "Ṧ": "S",
    "Ş": "S",
    "Ŝ": "S",
    "Ș": "S",
    "Ṡ": "S",
    "Ṣ": "S",
    "Ṩ": "S",
    "Ť": "T",
    "Ţ": "T",
    "Ṱ": "T",
    "Ț": "T",
    "Ⱦ": "T",
    "Ṫ": "T",
    "Ṭ": "T",
    "Ƭ": "T",
    "Ṯ": "T",
    "Ʈ": "T",
    "Ŧ": "T",
    "Ɐ": "A",
    "Ꞁ": "L",
    "Ɯ": "M",
    "Ʌ": "V",
    "Ꜩ": "TZ",
    "Ú": "U",
    "Ŭ": "U",
    "Ǔ": "U",
    "Û": "U",
    "Ṷ": "U",
    "Ü": "U",
    "Ǘ": "U",
    "Ǚ": "U",
    "Ǜ": "U",
    "Ǖ": "U",
    "Ṳ": "U",
    "Ụ": "U",
    "Ű": "U",
    "Ȕ": "U",
    "Ù": "U",
    "Ủ": "U",
    "Ư": "U",
    "Ứ": "U",
    "Ự": "U",
    "Ừ": "U",
    "Ử": "U",
    "Ữ": "U",
    "Ȗ": "U",
    "Ū": "U",
    "Ṻ": "U",
    "Ų": "U",
    "Ů": "U",
    "Ũ": "U",
    "Ṹ": "U",
    "Ṵ": "U",
    "Ꝟ": "V",
    "Ṿ": "V",
    "Ʋ": "V",
    "Ṽ": "V",
    "Ꝡ": "VY",
    "Ẃ": "W",
    "Ŵ": "W",
    "Ẅ": "W",
    "Ẇ": "W",
    "Ẉ": "W",
    "Ẁ": "W",
    "Ⱳ": "W",
    "Ẍ": "X",
    "Ẋ": "X",
    "Ý": "Y",
    "Ŷ": "Y",
    "Ÿ": "Y",
    "Ẏ": "Y",
    "Ỵ": "Y",
    "Ỳ": "Y",
    "Ƴ": "Y",
    "Ỷ": "Y",
    "Ỿ": "Y",
    "Ȳ": "Y",
    "Ɏ": "Y",
    "Ỹ": "Y",
    "Ź": "Z",
    "Ž": "Z",
    "Ẑ": "Z",
    "Ⱬ": "Z",
    "Ż": "Z",
    "Ẓ": "Z",
    "Ȥ": "Z",
    "Ẕ": "Z",
    "Ƶ": "Z",
    "Ĳ": "IJ",
    "Œ": "OE",
    "ᴀ": "A",
    "ᴁ": "AE",
    "ʙ": "B",
    "ᴃ": "B",
    "ᴄ": "C",
    "ᴅ": "D",
    "ᴇ": "E",
    "ꜰ": "F",
    "ɢ": "G",
    "ʛ": "G",
    "ʜ": "H",
    "ɪ": "I",
    "ʁ": "R",
    "ᴊ": "J",
    "ᴋ": "K",
    "ʟ": "L",
    "ᴌ": "L",
    "ᴍ": "M",
    "ɴ": "N",
    "ᴏ": "O",
    "ɶ": "OE",
    "ᴐ": "O",
    "ᴕ": "OU",
    "ᴘ": "P",
    "ʀ": "R",
    "ᴎ": "N",
    "ᴙ": "R",
    "ꜱ": "S",
    "ᴛ": "T",
    "ⱻ": "E",
    "ᴚ": "R",
    "ᴜ": "U",
    "ᴠ": "V",
    "ᴡ": "W",
    "ʏ": "Y",
    "ᴢ": "Z",
    "á": "a",
    "ă": "a",
    "ắ": "a",
    "ặ": "a",
    "ằ": "a",
    "ẳ": "a",
    "ẵ": "a",
    "ǎ": "a",
    "â": "a",
    "ấ": "a",
    "ậ": "a",
    "ầ": "a",
    "ẩ": "a",
    "ẫ": "a",
    "ä": "a",
    "ǟ": "a",
    "ȧ": "a",
    "ǡ": "a",
    "ạ": "a",
    "ȁ": "a",
    "à": "a",
    "ả": "a",
    "ȃ": "a",
    "ā": "a",
    "ą": "a",
    "ᶏ": "a",
    "ẚ": "a",
    "å": "a",
    "ǻ": "a",
    "ḁ": "a",
    "ⱥ": "a",
    "ã": "a",
    "ꜳ": "aa",
    "æ": "ae",
    "ǽ": "ae",
    "ǣ": "ae",
    "ꜵ": "ao",
    "ꜷ": "au",
    "ꜹ": "av",
    "ꜻ": "av",
    "ꜽ": "ay",
    "ḃ": "b",
    "ḅ": "b",
    "ɓ": "b",
    "ḇ": "b",
    "ᵬ": "b",
    "ᶀ": "b",
    "ƀ": "b",
    "ƃ": "b",
    "ɵ": "o",
    "ć": "c",
    "č": "c",
    "ç": "c",
    "ḉ": "c",
    "ĉ": "c",
    "ɕ": "c",
    "ċ": "c",
    "ƈ": "c",
    "ȼ": "c",
    "ď": "d",
    "ḑ": "d",
    "ḓ": "d",
    "ȡ": "d",
    "ḋ": "d",
    "ḍ": "d",
    "ɗ": "d",
    "ᶑ": "d",
    "ḏ": "d",
    "ᵭ": "d",
    "ᶁ": "d",
    "đ": "d",
    "ɖ": "d",
    "ƌ": "d",
    "ı": "i",
    "ȷ": "j",
    "ɟ": "j",
    "ʄ": "j",
    "ǳ": "dz",
    "ǆ": "dz",
    "é": "e",
    "ĕ": "e",
    "ě": "e",
    "ȩ": "e",
    "ḝ": "e",
    "ê": "e",
    "ế": "e",
    "ệ": "e",
    "ề": "e",
    "ể": "e",
    "ễ": "e",
    "ḙ": "e",
    "ë": "e",
    "ė": "e",
    "ẹ": "e",
    "ȅ": "e",
    "è": "e",
    "ẻ": "e",
    "ȇ": "e",
    "ē": "e",
    "ḗ": "e",
    "ḕ": "e",
    "ⱸ": "e",
    "ę": "e",
    "ᶒ": "e",
    "ɇ": "e",
    "ẽ": "e",
    "ḛ": "e",
    "ꝫ": "et",
    "ḟ": "f",
    "ƒ": "f",
    "ᵮ": "f",
    "ᶂ": "f",
    "ǵ": "g",
    "ğ": "g",
    "ǧ": "g",
    "ģ": "g",
    "ĝ": "g",
    "ġ": "g",
    "ɠ": "g",
    "ḡ": "g",
    "ᶃ": "g",
    "ǥ": "g",
    "ḫ": "h",
    "ȟ": "h",
    "ḩ": "h",
    "ĥ": "h",
    "ⱨ": "h",
    "ḧ": "h",
    "ḣ": "h",
    "ḥ": "h",
    "ɦ": "h",
    "ẖ": "h",
    "ħ": "h",
    "ƕ": "hv",
    "í": "i",
    "ĭ": "i",
    "ǐ": "i",
    "î": "i",
    "ï": "i",
    "ḯ": "i",
    "ị": "i",
    "ȉ": "i",
    "ì": "i",
    "ỉ": "i",
    "ȋ": "i",
    "ī": "i",
    "į": "i",
    "ᶖ": "i",
    "ɨ": "i",
    "ĩ": "i",
    "ḭ": "i",
    "ꝺ": "d",
    "ꝼ": "f",
    "ᵹ": "g",
    "ꞃ": "r",
    "ꞅ": "s",
    "ꞇ": "t",
    "ꝭ": "is",
    "ǰ": "j",
    "ĵ": "j",
    "ʝ": "j",
    "ɉ": "j",
    "ḱ": "k",
    "ǩ": "k",
    "ķ": "k",
    "ⱪ": "k",
    "ꝃ": "k",
    "ḳ": "k",
    "ƙ": "k",
    "ḵ": "k",
    "ᶄ": "k",
    "ꝁ": "k",
    "ꝅ": "k",
    "ĺ": "l",
    "ƚ": "l",
    "ɬ": "l",
    "ľ": "l",
    "ļ": "l",
    "ḽ": "l",
    "ȴ": "l",
    "ḷ": "l",
    "ḹ": "l",
    "ⱡ": "l",
    "ꝉ": "l",
    "ḻ": "l",
    "ŀ": "l",
    "ɫ": "l",
    "ᶅ": "l",
    "ɭ": "l",
    "ł": "l",
    "ǉ": "lj",
    "ſ": "s",
    "ẜ": "s",
    "ẛ": "s",
    "ẝ": "s",
    "ḿ": "m",
    "ṁ": "m",
    "ṃ": "m",
    "ɱ": "m",
    "ᵯ": "m",
    "ᶆ": "m",
    "ń": "n",
    "ň": "n",
    "ņ": "n",
    "ṋ": "n",
    "ȵ": "n",
    "ṅ": "n",
    "ṇ": "n",
    "ǹ": "n",
    "ɲ": "n",
    "ṉ": "n",
    "ƞ": "n",
    "ᵰ": "n",
    "ᶇ": "n",
    "ɳ": "n",
    "ñ": "n",
    "ǌ": "nj",
    "ó": "o",
    "ŏ": "o",
    "ǒ": "o",
    "ô": "o",
    "ố": "o",
    "ộ": "o",
    "ồ": "o",
    "ổ": "o",
    "ỗ": "o",
    "ö": "o",
    "ȫ": "o",
    "ȯ": "o",
    "ȱ": "o",
    "ọ": "o",
    "ő": "o",
    "ȍ": "o",
    "ò": "o",
    "ỏ": "o",
    "ơ": "o",
    "ớ": "o",
    "ợ": "o",
    "ờ": "o",
    "ở": "o",
    "ỡ": "o",
    "ȏ": "o",
    "ꝋ": "o",
    "ꝍ": "o",
    "ⱺ": "o",
    "ō": "o",
    "ṓ": "o",
    "ṑ": "o",
    "ǫ": "o",
    "ǭ": "o",
    "ø": "o",
    "ǿ": "o",
    "õ": "o",
    "ṍ": "o",
    "ṏ": "o",
    "ȭ": "o",
    "ƣ": "oi",
    "ꝏ": "oo",
    "ɛ": "e",
    "ᶓ": "e",
    "ɔ": "o",
    "ᶗ": "o",
    "ȣ": "ou",
    "ṕ": "p",
    "ṗ": "p",
    "ꝓ": "p",
    "ƥ": "p",
    "ᵱ": "p",
    "ᶈ": "p",
    "ꝕ": "p",
    "ᵽ": "p",
    "ꝑ": "p",
    "ꝙ": "q",
    "ʠ": "q",
    "ɋ": "q",
    "ꝗ": "q",
    "ŕ": "r",
    "ř": "r",
    "ŗ": "r",
    "ṙ": "r",
    "ṛ": "r",
    "ṝ": "r",
    "ȑ": "r",
    "ɾ": "r",
    "ᵳ": "r",
    "ȓ": "r",
    "ṟ": "r",
    "ɼ": "r",
    "ᵲ": "r",
    "ᶉ": "r",
    "ɍ": "r",
    "ɽ": "r",
    "ↄ": "c",
    "ꜿ": "c",
    "ɘ": "e",
    "ɿ": "r",
    "ś": "s",
    "ṥ": "s",
    "š": "s",
    "ṧ": "s",
    "ş": "s",
    "ŝ": "s",
    "ș": "s",
    "ṡ": "s",
    "ṣ": "s",
    "ṩ": "s",
    "ʂ": "s",
    "ᵴ": "s",
    "ᶊ": "s",
    "ȿ": "s",
    "ɡ": "g",
    "ᴑ": "o",
    "ᴓ": "o",
    "ᴝ": "u",
    "ť": "t",
    "ţ": "t",
    "ṱ": "t",
    "ț": "t",
    "ȶ": "t",
    "ẗ": "t",
    "ⱦ": "t",
    "ṫ": "t",
    "ṭ": "t",
    "ƭ": "t",
    "ṯ": "t",
    "ᵵ": "t",
    "ƫ": "t",
    "ʈ": "t",
    "ŧ": "t",
    "ᵺ": "th",
    "ɐ": "a",
    "ᴂ": "ae",
    "ǝ": "e",
    "ᵷ": "g",
    "ɥ": "h",
    "ʮ": "h",
    "ʯ": "h",
    "ᴉ": "i",
    "ʞ": "k",
    "ꞁ": "l",
    "ɯ": "m",
    "ɰ": "m",
    "ᴔ": "oe",
    "ɹ": "r",
    "ɻ": "r",
    "ɺ": "r",
    "ⱹ": "r",
    "ʇ": "t",
    "ʌ": "v",
    "ʍ": "w",
    "ʎ": "y",
    "ꜩ": "tz",
    "ú": "u",
    "ŭ": "u",
    "ǔ": "u",
    "û": "u",
    "ṷ": "u",
    "ü": "u",
    "ǘ": "u",
    "ǚ": "u",
    "ǜ": "u",
    "ǖ": "u",
    "ṳ": "u",
    "ụ": "u",
    "ű": "u",
    "ȕ": "u",
    "ù": "u",
    "ủ": "u",
    "ư": "u",
    "ứ": "u",
    "ự": "u",
    "ừ": "u",
    "ử": "u",
    "ữ": "u",
    "ȗ": "u",
    "ū": "u",
    "ṻ": "u",
    "ų": "u",
    "ᶙ": "u",
    "ů": "u",
    "ũ": "u",
    "ṹ": "u",
    "ṵ": "u",
    "ᵫ": "ue",
    "ꝸ": "um",
    "ⱴ": "v",
    "ꝟ": "v",
    "ṿ": "v",
    "ʋ": "v",
    "ᶌ": "v",
    "ⱱ": "v",
    "ṽ": "v",
    "ꝡ": "vy",
    "ẃ": "w",
    "ŵ": "w",
    "ẅ": "w",
    "ẇ": "w",
    "ẉ": "w",
    "ẁ": "w",
    "ⱳ": "w",
    "ẘ": "w",
    "ẍ": "x",
    "ẋ": "x",
    "ᶍ": "x",
    "ý": "y",
    "ŷ": "y",
    "ÿ": "y",
    "ẏ": "y",
    "ỵ": "y",
    "ỳ": "y",
    "ƴ": "y",
    "ỷ": "y",
    "ỿ": "y",
    "ȳ": "y",
    "ẙ": "y",
    "ɏ": "y",
    "ỹ": "y",
    "ź": "z",
    "ž": "z",
    "ẑ": "z",
    "ʑ": "z",
    "ⱬ": "z",
    "ż": "z",
    "ẓ": "z",
    "ȥ": "z",
    "ẕ": "z",
    "ᵶ": "z",
    "ᶎ": "z",
    "ʐ": "z",
    "ƶ": "z",
    "ɀ": "z",
    "ﬀ": "ff",
    "ﬃ": "ffi",
    "ﬄ": "ffl",
    "ﬁ": "fi",
    "ﬂ": "fl",
    "ĳ": "ij",
    "œ": "oe",
    "ﬆ": "st",
    "ₐ": "a",
    "ₑ": "e",
    "ᵢ": "i",
    "ⱼ": "j",
    "ₒ": "o",
    "ᵣ": "r",
    "ᵤ": "u",
    "ᵥ": "v",
    "ₓ": "x"
};
String.prototype.latinise = function () { return this.replace(/[^A-Za-z0-9\[\] ]/g, function (a) { return Latinise.latin_map[a] || a }) };
String.prototype.latinize = String.prototype.latinise;
String.prototype.isLatin = function () { return this == this.latinise() }

// END LATINIZE

// BEGIN PROPOSE URL SEGMENT
String.prototype.proposePathSegment = function ()
{
    return this
        .toLowerCase()
        .latinize()
        .replace(/[^a-zA-Z0-9\-_~]/g, "-")
        .replace(/[\-~_]{2,}/g, "-");
};
// END PROPOSE URL SEGMENT

// BEGIN SIMPLE DEBOUNCE
const debounceFunc = (func, delay) => {
   let timer;
   return function(...args) {
       const context = this;
       window.clearTimeout(timer);
       timer = window.setTimeout(() => {
           func.apply(context, args);
       }, delay)
    }
}
// END SIMPLE DEBOUNCE